module.exports = {
 "name": "中华人民共和国",
 "center": {
  "longitude": 116.3683244,
  "latitude": 39.915085
 },
 "level": "country",
 "districts": [
  {
   "name": "澳门特别行政区",
   "center": {
    "longitude": 113.543028,
    "latitude": 22.186835
   },
   "level": "province",
   "districts": [
    {
     "name": "花王堂区",
     "center": {
      "longitude": 113.548961,
      "latitude": 22.199207
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "望德堂区",
     "center": {
      "longitude": 113.550183,
      "latitude": 22.193721
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "大堂区",
     "center": {
      "longitude": 113.553647,
      "latitude": 22.188539
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "风顺堂区",
     "center": {
      "longitude": 113.541928,
      "latitude": 22.187368
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "花地玛堂区",
     "center": {
      "longitude": 113.552896,
      "latitude": 22.20787
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "嘉模堂区",
     "center": {
      "longitude": 113.558705,
      "latitude": 22.15376
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "圣方济各堂区",
     "center": {
      "longitude": 113.559954,
      "latitude": 22.123486
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "路凼填海区",
     "center": {
      "longitude": 113.569599,
      "latitude": 22.13663
     },
     "level": "district",
     "districts": []
    }
   ]
  },
  {
   "name": "北京市",
   "center": {
    "longitude": 116.407394,
    "latitude": 39.904211
   },
   "level": "province",
   "districts": [
    {
     "name": "北京城区",
     "center": {
      "longitude": 116.407394,
      "latitude": 39.904211
     },
     "level": "city",
     "districts": [
      {
       "name": "昌平区",
       "center": {
        "longitude": 116.231254,
        "latitude": 40.220804
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "朝阳区",
       "center": {
        "longitude": 116.443205,
        "latitude": 39.921506
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大兴区",
       "center": {
        "longitude": 116.341483,
        "latitude": 39.726917
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东城区",
       "center": {
        "longitude": 116.41649,
        "latitude": 39.928341
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "房山区",
       "center": {
        "longitude": 116.143486,
        "latitude": 39.748823
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰台区",
       "center": {
        "longitude": 116.287039,
        "latitude": 39.858421
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海淀区",
       "center": {
        "longitude": 116.298262,
        "latitude": 39.95993
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "怀柔区",
       "center": {
        "longitude": 116.631931,
        "latitude": 40.316053
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "门头沟区",
       "center": {
        "longitude": 116.101719,
        "latitude": 39.940338
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "密云区",
       "center": {
        "longitude": 116.843047,
        "latitude": 40.376894
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平谷区",
       "center": {
        "longitude": 117.121351,
        "latitude": 40.140595
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石景山区",
       "center": {
        "longitude": 116.222933,
        "latitude": 39.906611
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "顺义区",
       "center": {
        "longitude": 116.654642,
        "latitude": 40.130211
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通州区",
       "center": {
        "longitude": 116.656434,
        "latitude": 39.909946
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西城区",
       "center": {
        "longitude": 116.365873,
        "latitude": 39.912235
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "延庆区",
       "center": {
        "longitude": 115.974981,
        "latitude": 40.456591
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "重庆市",
   "center": {
    "longitude": 106.551643,
    "latitude": 29.562849
   },
   "level": "province",
   "districts": [
    {
     "name": "重庆城区",
     "center": {
      "longitude": 106.551643,
      "latitude": 29.562849
     },
     "level": "city",
     "districts": [
      {
       "name": "巴南区",
       "center": {
        "longitude": 106.540256,
        "latitude": 29.402408
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "北碚区",
       "center": {
        "longitude": 106.395612,
        "latitude": 29.805107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "璧山区",
       "center": {
        "longitude": 106.227305,
        "latitude": 29.592024
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大渡口区",
       "center": {
        "longitude": 106.482346,
        "latitude": 29.484527
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大足区",
       "center": {
        "longitude": 105.721733,
        "latitude": 29.707032
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涪陵区",
       "center": {
        "longitude": 107.38977,
        "latitude": 29.703022
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "合川区",
       "center": {
        "longitude": 106.27613,
        "latitude": 29.972084
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江北区",
       "center": {
        "longitude": 106.574271,
        "latitude": 29.606703
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江津区",
       "center": {
        "longitude": 106.259281,
        "latitude": 29.290069
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "九龙坡区",
       "center": {
        "longitude": 106.510676,
        "latitude": 29.502272
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开州区",
       "center": {
        "longitude": 108.393135,
        "latitude": 31.160711
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南岸区",
       "center": {
        "longitude": 106.644447,
        "latitude": 29.50126
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南川区",
       "center": {
        "longitude": 107.099266,
        "latitude": 29.15789
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "綦江区",
       "center": {
        "longitude": 106.651361,
        "latitude": 29.028066
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黔江区",
       "center": {
        "longitude": 108.770677,
        "latitude": 29.533609
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荣昌区",
       "center": {
        "longitude": 105.594623,
        "latitude": 29.405002
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙坪坝区",
       "center": {
        "longitude": 106.456878,
        "latitude": 29.541144
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铜梁区",
       "center": {
        "longitude": 106.056404,
        "latitude": 29.844811
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "潼南区",
       "center": {
        "longitude": 105.840431,
        "latitude": 30.190992
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万州区",
       "center": {
        "longitude": 108.408661,
        "latitude": 30.807667
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永川区",
       "center": {
        "longitude": 105.927001,
        "latitude": 29.356311
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "渝北区",
       "center": {
        "longitude": 106.631187,
        "latitude": 29.718142
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "渝中区",
       "center": {
        "longitude": 106.568896,
        "latitude": 29.552736
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长寿区",
       "center": {
        "longitude": 107.080734,
        "latitude": 29.857912
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "重庆郊县",
     "center": {
      "longitude": 108.165537,
      "latitude": 29.293902
     },
     "level": "city",
     "districts": [
      {
       "name": "城口县",
       "center": {
        "longitude": 108.664214,
        "latitude": 31.947633
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "垫江县",
       "center": {
        "longitude": 107.33339,
        "latitude": 30.327716
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰都县",
       "center": {
        "longitude": 107.730894,
        "latitude": 29.8635
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "奉节县",
       "center": {
        "longitude": 109.400403,
        "latitude": 31.018363
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梁平区",
       "center": {
        "longitude": 107.769568,
        "latitude": 30.654233
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "彭水苗族土家族自治县",
       "center": {
        "longitude": 108.165537,
        "latitude": 29.293902
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石柱土家族自治县",
       "center": {
        "longitude": 108.114069,
        "latitude": 29.999285
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巫山县",
       "center": {
        "longitude": 109.879153,
        "latitude": 31.074834
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巫溪县",
       "center": {
        "longitude": 109.570062,
        "latitude": 31.398604
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武隆区",
       "center": {
        "longitude": 107.760025,
        "latitude": 29.325601
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秀山土家族苗族自治县",
       "center": {
        "longitude": 109.007094,
        "latitude": 28.447997
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "酉阳土家族苗族自治县",
       "center": {
        "longitude": 108.767747,
        "latitude": 28.841244
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云阳县",
       "center": {
        "longitude": 108.697324,
        "latitude": 30.930612
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "忠县",
       "center": {
        "longitude": 108.039002,
        "latitude": 30.299559
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "福建省",
   "center": {
    "longitude": 119.295143,
    "latitude": 26.100779
   },
   "level": "province",
   "districts": [
    {
     "name": "福州市",
     "center": {
      "longitude": 119.296389,
      "latitude": 26.074268
     },
     "level": "city",
     "districts": [
      {
       "name": "仓山区",
       "center": {
        "longitude": 119.273545,
        "latitude": 26.046743
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "福清市",
       "center": {
        "longitude": 119.384201,
        "latitude": 25.72071
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鼓楼区",
       "center": {
        "longitude": 119.303917,
        "latitude": 26.081983
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "晋安区",
       "center": {
        "longitude": 119.328521,
        "latitude": 26.082107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "连江县",
       "center": {
        "longitude": 119.539704,
        "latitude": 26.197364
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "罗源县",
       "center": {
        "longitude": 119.549776,
        "latitude": 26.489558
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "马尾区",
       "center": {
        "longitude": 119.455588,
        "latitude": 25.9895
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "闽侯县",
       "center": {
        "longitude": 119.131724,
        "latitude": 26.150047
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "闽清县",
       "center": {
        "longitude": 118.863361,
        "latitude": 26.221197
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平潭县",
       "center": {
        "longitude": 119.790168,
        "latitude": 25.49872
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "台江区",
       "center": {
        "longitude": 119.314041,
        "latitude": 26.052843
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永泰县",
       "center": {
        "longitude": 118.932592,
        "latitude": 25.866694
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长乐区",
       "center": {
        "longitude": 119.523266,
        "latitude": 25.962888
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "龙岩市",
     "center": {
      "longitude": 117.017295,
      "latitude": 25.075119
     },
     "level": "city",
     "districts": [
      {
       "name": "连城县",
       "center": {
        "longitude": 116.754472,
        "latitude": 25.710538
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上杭县",
       "center": {
        "longitude": 116.420098,
        "latitude": 25.049518
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武平县",
       "center": {
        "longitude": 116.100414,
        "latitude": 25.095386
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新罗区",
       "center": {
        "longitude": 117.037155,
        "latitude": 25.098312
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永定区",
       "center": {
        "longitude": 116.732091,
        "latitude": 24.723961
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "漳平市",
       "center": {
        "longitude": 117.419998,
        "latitude": 25.290184
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长汀县",
       "center": {
        "longitude": 116.357581,
        "latitude": 25.833531
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "南平市",
     "center": {
      "longitude": 118.17771,
      "latitude": 26.641774
     },
     "level": "city",
     "districts": [
      {
       "name": "光泽县",
       "center": {
        "longitude": 117.334106,
        "latitude": 27.540987
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建瓯市",
       "center": {
        "longitude": 118.304966,
        "latitude": 27.022774
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建阳区",
       "center": {
        "longitude": 118.120464,
        "latitude": 27.331876
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浦城县",
       "center": {
        "longitude": 118.541256,
        "latitude": 27.917263
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邵武市",
       "center": {
        "longitude": 117.492533,
        "latitude": 27.340326
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "顺昌县",
       "center": {
        "longitude": 117.810357,
        "latitude": 26.793288
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "松溪县",
       "center": {
        "longitude": 118.785468,
        "latitude": 27.526232
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武夷山市",
       "center": {
        "longitude": 118.035309,
        "latitude": 27.756647
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "延平区",
       "center": {
        "longitude": 118.182036,
        "latitude": 26.637438
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "政和县",
       "center": {
        "longitude": 118.857642,
        "latitude": 27.366104
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "宁德市",
     "center": {
      "longitude": 119.547932,
      "latitude": 26.665617
     },
     "level": "city",
     "districts": [
      {
       "name": "福鼎市",
       "center": {
        "longitude": 120.216977,
        "latitude": 27.324479
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "福安市",
       "center": {
        "longitude": 119.64785,
        "latitude": 27.08834
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "古田县",
       "center": {
        "longitude": 118.746284,
        "latitude": 26.577837
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蕉城区",
       "center": {
        "longitude": 119.526299,
        "latitude": 26.66061
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "屏南县",
       "center": {
        "longitude": 118.985895,
        "latitude": 26.908276
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "寿宁县",
       "center": {
        "longitude": 119.514986,
        "latitude": 27.454479
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "霞浦县",
       "center": {
        "longitude": 120.005146,
        "latitude": 26.885703
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柘荣县",
       "center": {
        "longitude": 119.900609,
        "latitude": 27.233933
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "周宁县",
       "center": {
        "longitude": 119.339025,
        "latitude": 27.104591
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "厦门市",
     "center": {
      "longitude": 118.089204,
      "latitude": 24.479664
     },
     "level": "city",
     "districts": [
      {
       "name": "海沧区",
       "center": {
        "longitude": 118.032984,
        "latitude": 24.484685
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湖里区",
       "center": {
        "longitude": 118.146768,
        "latitude": 24.512904
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "集美区",
       "center": {
        "longitude": 118.097337,
        "latitude": 24.575969
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "思明区",
       "center": {
        "longitude": 118.082649,
        "latitude": 24.445484
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "同安区",
       "center": {
        "longitude": 118.152041,
        "latitude": 24.723234
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "翔安区",
       "center": {
        "longitude": 118.248034,
        "latitude": 24.618543
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "莆田市",
     "center": {
      "longitude": 119.007777,
      "latitude": 25.454084
     },
     "level": "city",
     "districts": [
      {
       "name": "城厢区",
       "center": {
        "longitude": 118.993884,
        "latitude": 25.419319
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涵江区",
       "center": {
        "longitude": 119.116289,
        "latitude": 25.45872
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荔城区",
       "center": {
        "longitude": 119.015061,
        "latitude": 25.431941
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仙游县",
       "center": {
        "longitude": 118.691637,
        "latitude": 25.362093
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秀屿区",
       "center": {
        "longitude": 119.105494,
        "latitude": 25.31836
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "三明市",
     "center": {
      "longitude": 117.638678,
      "latitude": 26.263406
     },
     "level": "city",
     "districts": [
      {
       "name": "大田县",
       "center": {
        "longitude": 117.847115,
        "latitude": 25.692699
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建宁县",
       "center": {
        "longitude": 116.848443,
        "latitude": 26.833588
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "将乐县",
       "center": {
        "longitude": 117.471372,
        "latitude": 26.728952
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梅列区",
       "center": {
        "longitude": 117.645855,
        "latitude": 26.271711
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "明溪县",
       "center": {
        "longitude": 117.202226,
        "latitude": 26.355856
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁化县",
       "center": {
        "longitude": 116.654365,
        "latitude": 26.261754
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清流县",
       "center": {
        "longitude": 116.816909,
        "latitude": 26.177796
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三元区",
       "center": {
        "longitude": 117.608044,
        "latitude": 26.234019
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙县",
       "center": {
        "longitude": 117.792396,
        "latitude": 26.397199
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泰宁县",
       "center": {
        "longitude": 117.17574,
        "latitude": 26.900259
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永安市",
       "center": {
        "longitude": 117.365052,
        "latitude": 25.941937
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尤溪县",
       "center": {
        "longitude": 118.190467,
        "latitude": 26.170171
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "泉州市",
     "center": {
      "longitude": 118.675676,
      "latitude": 24.874132
     },
     "level": "city",
     "districts": [
      {
       "name": "安溪县",
       "center": {
        "longitude": 118.186288,
        "latitude": 25.055954
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "德化县",
       "center": {
        "longitude": 118.241094,
        "latitude": 25.491493
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰泽区",
       "center": {
        "longitude": 118.613172,
        "latitude": 24.891173
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "惠安县",
       "center": {
        "longitude": 118.796607,
        "latitude": 25.030801
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金门县",
       "center": {
        "longitude": 118.323221,
        "latitude": 24.436417
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "晋江市",
       "center": {
        "longitude": 118.551682,
        "latitude": 24.781636
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鲤城区",
       "center": {
        "longitude": 118.587097,
        "latitude": 24.907424
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洛江区",
       "center": {
        "longitude": 118.671193,
        "latitude": 24.939796
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南安市",
       "center": {
        "longitude": 118.386279,
        "latitude": 24.960385
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泉港区",
       "center": {
        "longitude": 118.916309,
        "latitude": 25.119815
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石狮市",
       "center": {
        "longitude": 118.648066,
        "latitude": 24.732204
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永春县",
       "center": {
        "longitude": 118.294048,
        "latitude": 25.321565
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "漳州市",
     "center": {
      "longitude": 117.647093,
      "latitude": 24.513025
     },
     "level": "city",
     "districts": [
      {
       "name": "东山县",
       "center": {
        "longitude": 117.430061,
        "latitude": 23.701262
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华安县",
       "center": {
        "longitude": 117.534103,
        "latitude": 25.004425
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙海市",
       "center": {
        "longitude": 117.818197,
        "latitude": 24.446706
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙文区",
       "center": {
        "longitude": 117.709754,
        "latitude": 24.503113
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南靖县",
       "center": {
        "longitude": 117.35732,
        "latitude": 24.514654
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平和县",
       "center": {
        "longitude": 117.315017,
        "latitude": 24.363508
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芗城区",
       "center": {
        "longitude": 117.653968,
        "latitude": 24.510787
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云霄县",
       "center": {
        "longitude": 117.339573,
        "latitude": 23.957936
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "漳浦县",
       "center": {
        "longitude": 117.613808,
        "latitude": 24.117102
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长泰县",
       "center": {
        "longitude": 117.759153,
        "latitude": 24.625449
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "诏安县",
       "center": {
        "longitude": 117.175184,
        "latitude": 23.711579
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "广东省",
   "center": {
    "longitude": 113.26641,
    "latitude": 23.132324
   },
   "level": "province",
   "districts": [
    {
     "name": "中山市",
     "center": {
      "longitude": 113.39277,
      "latitude": 22.517585
     },
     "level": "city",
     "districts": [
      {
       "name": "南头镇",
       "center": {
        "longitude": 113.291867,
        "latitude": 22.717679
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "小榄镇",
       "center": {
        "longitude": 113.250897,
        "latitude": 22.672099
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "神湾镇",
       "center": {
        "longitude": 113.363816,
        "latitude": 22.302496
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东凤镇",
       "center": {
        "longitude": 113.256963,
        "latitude": 22.702452
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "南朗镇",
       "center": {
        "longitude": 113.530998,
        "latitude": 22.498612
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "环城街道",
       "center": {
        "longitude": 113.352385,
        "latitude": 22.478059
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "坦洲镇",
       "center": {
        "longitude": 113.468002,
        "latitude": 22.254504
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "中山港街道",
       "center": {
        "longitude": 113.47457,
        "latitude": 22.560023
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "南区街道",
       "center": {
        "longitude": 113.354416,
        "latitude": 22.485429
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "五桂山街道",
       "center": {
        "longitude": 113.402421,
        "latitude": 22.446247
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "石歧区街道",
       "center": {
        "longitude": 113.372237,
        "latitude": 22.520661
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "西区街道",
       "center": {
        "longitude": 113.358988,
        "latitude": 22.520088
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东区街道",
       "center": {
        "longitude": 113.398577,
        "latitude": 22.513701
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "三乡镇",
       "center": {
        "longitude": 113.441608,
        "latitude": 22.357768
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大涌镇",
       "center": {
        "longitude": 113.300876,
        "latitude": 22.46497
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "黄圃镇",
       "center": {
        "longitude": 113.33915,
        "latitude": 22.710864
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "石岐区街道",
       "center": {
        "longitude": 113.388358,
        "latitude": 22.536656
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "沙溪镇",
       "center": {
        "longitude": 113.321321,
        "latitude": 22.508984
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东升镇",
       "center": {
        "longitude": 113.291662,
        "latitude": 22.62273
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "阜沙镇",
       "center": {
        "longitude": 113.349872,
        "latitude": 22.667171
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "民众镇",
       "center": {
        "longitude": 113.493839,
        "latitude": 22.621554
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "横栏镇",
       "center": {
        "longitude": 113.249104,
        "latitude": 22.534847
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "三角镇",
       "center": {
        "longitude": 113.418173,
        "latitude": 22.67658
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "板芙镇",
       "center": {
        "longitude": 113.322644,
        "latitude": 22.416782
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "港口镇",
       "center": {
        "longitude": 113.385893,
        "latitude": 22.585266
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "古镇镇",
       "center": {
        "longitude": 113.190869,
        "latitude": 22.613406
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "东沙群岛",
     "center": {
      "longitude": 116.887613,
      "latitude": 20.617825
     },
     "level": "city",
     "districts": []
    },
    {
     "name": "潮州市",
     "center": {
      "longitude": 116.622444,
      "latitude": 23.657262
     },
     "level": "city",
     "districts": [
      {
       "name": "潮安区",
       "center": {
        "longitude": 116.678203,
        "latitude": 23.462613
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "饶平县",
       "center": {
        "longitude": 117.0039,
        "latitude": 23.663824
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湘桥区",
       "center": {
        "longitude": 116.628627,
        "latitude": 23.674387
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "东莞市",
     "center": {
      "longitude": 113.751799,
      "latitude": 23.020673
     },
     "level": "city",
     "districts": [
      {
       "name": "东坑镇",
       "center": {
        "longitude": 113.933872,
        "latitude": 22.995838
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大岭山镇",
       "center": {
        "longitude": 113.842223,
        "latitude": 22.899965
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "企石镇",
       "center": {
        "longitude": 114.022023,
        "latitude": 23.072874
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "沙田镇",
       "center": {
        "longitude": 113.61818,
        "latitude": 22.919615
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "道滘镇",
       "center": {
        "longitude": 113.675231,
        "latitude": 23.004366
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "虎门镇",
       "center": {
        "longitude": 113.672553,
        "latitude": 22.814835
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "望牛墩镇",
       "center": {
        "longitude": 113.656231,
        "latitude": 23.055334
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "南城街道",
       "center": {
        "longitude": 113.743835,
        "latitude": 23.018534
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "莞城街道",
       "center": {
        "longitude": 113.749234,
        "latitude": 23.038629
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东城街道",
       "center": {
        "longitude": 113.783327,
        "latitude": 23.028053
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "万江街道",
       "center": {
        "longitude": 113.738542,
        "latitude": 23.047104
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "石排镇",
       "center": {
        "longitude": 113.9403,
        "latitude": 23.090292
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "厚街镇",
       "center": {
        "longitude": 113.67114,
        "latitude": 22.936585
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "长安镇",
       "center": {
        "longitude": 113.802516,
        "latitude": 22.814768
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "石碣镇",
       "center": {
        "longitude": 113.813068,
        "latitude": 23.099651
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大朗镇",
       "center": {
        "longitude": 113.943978,
        "latitude": 22.940016
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "横沥镇",
       "center": {
        "longitude": 113.965588,
        "latitude": 23.018472
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "樟木头镇",
       "center": {
        "longitude": 114.083278,
        "latitude": 22.914909
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "清溪镇",
       "center": {
        "longitude": 114.164185,
        "latitude": 22.843847
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "麻涌镇",
       "center": {
        "longitude": 113.581134,
        "latitude": 23.051137
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "茶山镇",
       "center": {
        "longitude": 113.869636,
        "latitude": 23.076755
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "凤岗镇",
       "center": {
        "longitude": 114.136944,
        "latitude": 22.74695
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "高埗镇",
       "center": {
        "longitude": 113.745951,
        "latitude": 23.090824
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "中堂镇",
       "center": {
        "longitude": 113.656917,
        "latitude": 23.092609
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "桥头镇",
       "center": {
        "longitude": 114.10316,
        "latitude": 23.024132
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "谢岗镇",
       "center": {
        "longitude": 114.148739,
        "latitude": 22.961616
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "黄江镇",
       "center": {
        "longitude": 114.003561,
        "latitude": 22.915278
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "塘厦镇",
       "center": {
        "longitude": 114.072575,
        "latitude": 22.806965
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "寮步镇",
       "center": {
        "longitude": 113.874871,
        "latitude": 22.997358
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "洪梅镇",
       "center": {
        "longitude": 113.608903,
        "latitude": 22.994717
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "常平镇",
       "center": {
        "longitude": 113.993116,
        "latitude": 22.974855
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "石龙镇",
       "center": {
        "longitude": 113.874378,
        "latitude": 23.10591
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "佛山市",
     "center": {
      "longitude": 113.121435,
      "latitude": 23.021478
     },
     "level": "city",
     "districts": [
      {
       "name": "禅城区",
       "center": {
        "longitude": 113.122421,
        "latitude": 23.009551
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高明区",
       "center": {
        "longitude": 112.892585,
        "latitude": 22.900139
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南海区",
       "center": {
        "longitude": 113.143441,
        "latitude": 23.028956
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三水区",
       "center": {
        "longitude": 112.896685,
        "latitude": 23.155931
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "顺德区",
       "center": {
        "longitude": 113.293359,
        "latitude": 22.80524
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "广州市",
     "center": {
      "longitude": 113.264385,
      "latitude": 23.12911
     },
     "level": "city",
     "districts": [
      {
       "name": "白云区",
       "center": {
        "longitude": 113.273238,
        "latitude": 23.157367
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "从化区",
       "center": {
        "longitude": 113.586679,
        "latitude": 23.548748
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "番禺区",
       "center": {
        "longitude": 113.384152,
        "latitude": 22.937556
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海珠区",
       "center": {
        "longitude": 113.317443,
        "latitude": 23.083788
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "花都区",
       "center": {
        "longitude": 113.220463,
        "latitude": 23.403744
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄埔区",
       "center": {
        "longitude": 113.480541,
        "latitude": 23.181706
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荔湾区",
       "center": {
        "longitude": 113.244258,
        "latitude": 23.125863
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南沙区",
       "center": {
        "longitude": 113.525165,
        "latitude": 22.801624
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天河区",
       "center": {
        "longitude": 113.361575,
        "latitude": 23.124807
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "越秀区",
       "center": {
        "longitude": 113.266835,
        "latitude": 23.128537
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "增城区",
       "center": {
        "longitude": 113.810627,
        "latitude": 23.261465
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "河源市",
     "center": {
      "longitude": 114.700961,
      "latitude": 23.743686
     },
     "level": "city",
     "districts": [
      {
       "name": "东源县",
       "center": {
        "longitude": 114.746344,
        "latitude": 23.788189
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和平县",
       "center": {
        "longitude": 114.938684,
        "latitude": 24.44218
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "连平县",
       "center": {
        "longitude": 114.488556,
        "latitude": 24.369583
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙川县",
       "center": {
        "longitude": 115.259871,
        "latitude": 24.100066
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "源城区",
       "center": {
        "longitude": 114.702517,
        "latitude": 23.733969
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "紫金县",
       "center": {
        "longitude": 115.184107,
        "latitude": 23.635745
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "惠州市",
     "center": {
      "longitude": 114.415612,
      "latitude": 23.112381
     },
     "level": "city",
     "districts": [
      {
       "name": "博罗县",
       "center": {
        "longitude": 114.289528,
        "latitude": 23.172771
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "惠城区",
       "center": {
        "longitude": 114.382474,
        "latitude": 23.084137
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "惠东县",
       "center": {
        "longitude": 114.719988,
        "latitude": 22.985014
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "惠阳区",
       "center": {
        "longitude": 114.456176,
        "latitude": 22.789788
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙门县",
       "center": {
        "longitude": 114.254863,
        "latitude": 23.727737
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "江门市",
     "center": {
      "longitude": 113.081542,
      "latitude": 22.57899
     },
     "level": "city",
     "districts": [
      {
       "name": "恩平市",
       "center": {
        "longitude": 112.305145,
        "latitude": 22.183206
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鹤山市",
       "center": {
        "longitude": 112.964252,
        "latitude": 22.76545
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江海区",
       "center": {
        "longitude": 113.111612,
        "latitude": 22.560473
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开平市",
       "center": {
        "longitude": 112.698545,
        "latitude": 22.376395
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蓬江区",
       "center": {
        "longitude": 113.078521,
        "latitude": 22.595149
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "台山市",
       "center": {
        "longitude": 112.794065,
        "latitude": 22.251924
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新会区",
       "center": {
        "longitude": 113.034187,
        "latitude": 22.4583
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "揭阳市",
     "center": {
      "longitude": 116.372708,
      "latitude": 23.549701
     },
     "level": "city",
     "districts": [
      {
       "name": "惠来县",
       "center": {
        "longitude": 116.29515,
        "latitude": 23.033266
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "揭东区",
       "center": {
        "longitude": 116.412015,
        "latitude": 23.566126
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "揭西县",
       "center": {
        "longitude": 115.841837,
        "latitude": 23.431294
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "普宁市",
       "center": {
        "longitude": 116.165777,
        "latitude": 23.297493
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "榕城区",
       "center": {
        "longitude": 116.367012,
        "latitude": 23.525382
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "茂名市",
     "center": {
      "longitude": 110.925439,
      "latitude": 21.662991
     },
     "level": "city",
     "districts": [
      {
       "name": "电白区",
       "center": {
        "longitude": 111.013556,
        "latitude": 21.514163
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高州市",
       "center": {
        "longitude": 110.853299,
        "latitude": 21.918203
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "化州市",
       "center": {
        "longitude": 110.639565,
        "latitude": 21.66463
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "茂南区",
       "center": {
        "longitude": 110.918026,
        "latitude": 21.641337
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "信宜市",
       "center": {
        "longitude": 110.947043,
        "latitude": 22.354385
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "梅州市",
     "center": {
      "longitude": 116.122523,
      "latitude": 24.288578
     },
     "level": "city",
     "districts": [
      {
       "name": "大埔县",
       "center": {
        "longitude": 116.695195,
        "latitude": 24.347782
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰顺县",
       "center": {
        "longitude": 116.181691,
        "latitude": 23.739343
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蕉岭县",
       "center": {
        "longitude": 116.171355,
        "latitude": 24.658699
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梅江区",
       "center": {
        "longitude": 116.116695,
        "latitude": 24.31049
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梅县区",
       "center": {
        "longitude": 116.081656,
        "latitude": 24.265926
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平远县",
       "center": {
        "longitude": 115.891638,
        "latitude": 24.567261
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五华县",
       "center": {
        "longitude": 115.775788,
        "latitude": 23.932409
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴宁市",
       "center": {
        "longitude": 115.731167,
        "latitude": 24.136708
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "清远市",
     "center": {
      "longitude": 113.056042,
      "latitude": 23.681774
     },
     "level": "city",
     "districts": [
      {
       "name": "佛冈县",
       "center": {
        "longitude": 113.531607,
        "latitude": 23.879192
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "连州市",
       "center": {
        "longitude": 112.377361,
        "latitude": 24.780966
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "连南瑶族自治县",
       "center": {
        "longitude": 112.287012,
        "latitude": 24.726017
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "连山壮族瑶族自治县",
       "center": {
        "longitude": 112.093617,
        "latitude": 24.570491
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清新区",
       "center": {
        "longitude": 113.017747,
        "latitude": 23.734677
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清城区",
       "center": {
        "longitude": 113.062692,
        "latitude": 23.697899
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳山县",
       "center": {
        "longitude": 112.641363,
        "latitude": 24.465359
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "英德市",
       "center": {
        "longitude": 113.401701,
        "latitude": 24.206986
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "汕头市",
     "center": {
      "longitude": 116.681972,
      "latitude": 23.354091
     },
     "level": "city",
     "districts": [
      {
       "name": "潮南区",
       "center": {
        "longitude": 116.439178,
        "latitude": 23.23865
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "澄海区",
       "center": {
        "longitude": 116.755992,
        "latitude": 23.466709
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "潮阳区",
       "center": {
        "longitude": 116.601509,
        "latitude": 23.265356
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "濠江区",
       "center": {
        "longitude": 116.726973,
        "latitude": 23.286079
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金平区",
       "center": {
        "longitude": 116.70345,
        "latitude": 23.365556
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙湖区",
       "center": {
        "longitude": 116.716446,
        "latitude": 23.372254
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南澳县",
       "center": {
        "longitude": 117.023374,
        "latitude": 23.421724
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "汕尾市",
     "center": {
      "longitude": 115.375431,
      "latitude": 22.78705
     },
     "level": "city",
     "districts": [
      {
       "name": "城区",
       "center": {
        "longitude": 115.365058,
        "latitude": 22.779207
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海丰县",
       "center": {
        "longitude": 115.323436,
        "latitude": 22.966585
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陆丰市",
       "center": {
        "longitude": 115.652151,
        "latitude": 22.919228
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陆河县",
       "center": {
        "longitude": 115.660143,
        "latitude": 23.301616
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "韶关市",
     "center": {
      "longitude": 113.59762,
      "latitude": 24.810879
     },
     "level": "city",
     "districts": [
      {
       "name": "乐昌市",
       "center": {
        "longitude": 113.347545,
        "latitude": 25.130602
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南雄市",
       "center": {
        "longitude": 114.311982,
        "latitude": 25.117753
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "曲江区",
       "center": {
        "longitude": 113.604535,
        "latitude": 24.682501
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仁化县",
       "center": {
        "longitude": 113.749027,
        "latitude": 25.085621
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乳源瑶族自治县",
       "center": {
        "longitude": 113.275883,
        "latitude": 24.776078
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "始兴县",
       "center": {
        "longitude": 114.061789,
        "latitude": 24.952976
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "翁源县",
       "center": {
        "longitude": 114.130342,
        "latitude": 24.350346
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武江区",
       "center": {
        "longitude": 113.587756,
        "latitude": 24.792926
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新丰县",
       "center": {
        "longitude": 114.206867,
        "latitude": 24.05976
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浈江区",
       "center": {
        "longitude": 113.611098,
        "latitude": 24.804381
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "深圳市",
     "center": {
      "longitude": 114.057939,
      "latitude": 22.543527
     },
     "level": "city",
     "districts": [
      {
       "name": "宝安区",
       "center": {
        "longitude": 113.883802,
        "latitude": 22.554996
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "福田区",
       "center": {
        "longitude": 114.055072,
        "latitude": 22.521521
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙岗区",
       "center": {
        "longitude": 114.246899,
        "latitude": 22.720974
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙华区",
       "center": {
        "longitude": 114.045422,
        "latitude": 22.696667
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "罗湖区",
       "center": {
        "longitude": 114.131459,
        "latitude": 22.548389
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南山区",
       "center": {
        "longitude": 113.930413,
        "latitude": 22.533287
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "坪山区",
       "center": {
        "longitude": 114.350584,
        "latitude": 22.708881
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盐田区",
       "center": {
        "longitude": 114.236739,
        "latitude": 22.557001
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "阳江市",
     "center": {
      "longitude": 111.982589,
      "latitude": 21.857887
     },
     "level": "city",
     "districts": [
      {
       "name": "江城区",
       "center": {
        "longitude": 111.955058,
        "latitude": 21.861786
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳西县",
       "center": {
        "longitude": 111.61766,
        "latitude": 21.752771
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳东区",
       "center": {
        "longitude": 112.006363,
        "latitude": 21.868337
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳春市",
       "center": {
        "longitude": 111.791587,
        "latitude": 22.17041
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "云浮市",
     "center": {
      "longitude": 112.044491,
      "latitude": 22.915094
     },
     "level": "city",
     "districts": [
      {
       "name": "罗定市",
       "center": {
        "longitude": 111.569892,
        "latitude": 22.768285
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新兴县",
       "center": {
        "longitude": 112.225334,
        "latitude": 22.69569
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云安区",
       "center": {
        "longitude": 112.003208,
        "latitude": 23.071019
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郁南县",
       "center": {
        "longitude": 111.535285,
        "latitude": 23.23456
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云城区",
       "center": {
        "longitude": 112.043945,
        "latitude": 22.92815
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "湛江市",
     "center": {
      "longitude": 110.356639,
      "latitude": 21.270145
     },
     "level": "city",
     "districts": [
      {
       "name": "赤坎区",
       "center": {
        "longitude": 110.365899,
        "latitude": 21.266119
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雷州市",
       "center": {
        "longitude": 110.096586,
        "latitude": 20.914178
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "廉江市",
       "center": {
        "longitude": 110.286208,
        "latitude": 21.6097
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麻章区",
       "center": {
        "longitude": 110.334387,
        "latitude": 21.263442
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "坡头区",
       "center": {
        "longitude": 110.455332,
        "latitude": 21.244721
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "遂溪县",
       "center": {
        "longitude": 110.250123,
        "latitude": 21.377246
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吴川市",
       "center": {
        "longitude": 110.778411,
        "latitude": 21.441808
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "霞山区",
       "center": {
        "longitude": 110.397656,
        "latitude": 21.192457
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "徐闻县",
       "center": {
        "longitude": 110.176749,
        "latitude": 20.325489
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "肇庆市",
     "center": {
      "longitude": 112.465091,
      "latitude": 23.047191
     },
     "level": "city",
     "districts": [
      {
       "name": "德庆县",
       "center": {
        "longitude": 111.785937,
        "latitude": 23.143722
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鼎湖区",
       "center": {
        "longitude": 112.567588,
        "latitude": 23.158447
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "端州区",
       "center": {
        "longitude": 112.484848,
        "latitude": 23.052101
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "封开县",
       "center": {
        "longitude": 111.512343,
        "latitude": 23.424033
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高要区",
       "center": {
        "longitude": 112.457981,
        "latitude": 23.025305
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广宁县",
       "center": {
        "longitude": 112.44069,
        "latitude": 23.634675
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "怀集县",
       "center": {
        "longitude": 112.167742,
        "latitude": 23.92035
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "四会市",
       "center": {
        "longitude": 112.734103,
        "latitude": 23.327001
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "珠海市",
     "center": {
      "longitude": 113.576677,
      "latitude": 22.270978
     },
     "level": "city",
     "districts": [
      {
       "name": "斗门区",
       "center": {
        "longitude": 113.296467,
        "latitude": 22.2092
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金湾区",
       "center": {
        "longitude": 113.362656,
        "latitude": 22.147471
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "香洲区",
       "center": {
        "longitude": 113.543784,
        "latitude": 22.265811
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "广西壮族自治区",
   "center": {
    "longitude": 108.327546,
    "latitude": 22.815478
   },
   "level": "province",
   "districts": [
    {
     "name": "北海市",
     "center": {
      "longitude": 109.120161,
      "latitude": 21.481291
     },
     "level": "city",
     "districts": [
      {
       "name": "海城区",
       "center": {
        "longitude": 109.117209,
        "latitude": 21.475004
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "合浦县",
       "center": {
        "longitude": 109.207335,
        "latitude": 21.660935
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁山港区",
       "center": {
        "longitude": 109.42158,
        "latitude": 21.529127
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "银海区",
       "center": {
        "longitude": 109.139862,
        "latitude": 21.449308
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "百色市",
     "center": {
      "longitude": 106.618202,
      "latitude": 23.90233
     },
     "level": "city",
     "districts": [
      {
       "name": "德保县",
       "center": {
        "longitude": 106.615373,
        "latitude": 23.32345
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "靖西市",
       "center": {
        "longitude": 106.417805,
        "latitude": 23.134117
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乐业县",
       "center": {
        "longitude": 106.556519,
        "latitude": 24.776827
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凌云县",
       "center": {
        "longitude": 106.56131,
        "latitude": 24.347557
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隆林各族自治县",
       "center": {
        "longitude": 105.34404,
        "latitude": 24.770896
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "那坡县",
       "center": {
        "longitude": 105.83253,
        "latitude": 23.387441
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平果县",
       "center": {
        "longitude": 107.589809,
        "latitude": 23.329376
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "田林县",
       "center": {
        "longitude": 106.228538,
        "latitude": 24.294487
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "田东县",
       "center": {
        "longitude": 107.12608,
        "latitude": 23.597194
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "田阳县",
       "center": {
        "longitude": 106.915496,
        "latitude": 23.735692
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西林县",
       "center": {
        "longitude": 105.093825,
        "latitude": 24.489823
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "右江区",
       "center": {
        "longitude": 106.618225,
        "latitude": 23.90097
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "崇左市",
     "center": {
      "longitude": 107.365094,
      "latitude": 22.377253
     },
     "level": "city",
     "districts": [
      {
       "name": "大新县",
       "center": {
        "longitude": 107.200654,
        "latitude": 22.829287
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "扶绥县",
       "center": {
        "longitude": 107.904186,
        "latitude": 22.635012
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江州区",
       "center": {
        "longitude": 107.353437,
        "latitude": 22.405325
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙州县",
       "center": {
        "longitude": 106.854482,
        "latitude": 22.342778
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁明县",
       "center": {
        "longitude": 107.076456,
        "latitude": 22.140192
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凭祥市",
       "center": {
        "longitude": 106.766293,
        "latitude": 22.094484
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天等县",
       "center": {
        "longitude": 107.143432,
        "latitude": 23.081394
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "防城港市",
     "center": {
      "longitude": 108.353846,
      "latitude": 21.68686
     },
     "level": "city",
     "districts": [
      {
       "name": "东兴市",
       "center": {
        "longitude": 107.971828,
        "latitude": 21.547821
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "防城区",
       "center": {
        "longitude": 108.353499,
        "latitude": 21.769211
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "港口区",
       "center": {
        "longitude": 108.380143,
        "latitude": 21.643383
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上思县",
       "center": {
        "longitude": 107.983627,
        "latitude": 22.153671
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "桂林市",
     "center": {
      "longitude": 110.179953,
      "latitude": 25.234479
     },
     "level": "city",
     "districts": [
      {
       "name": "叠彩区",
       "center": {
        "longitude": 110.301723,
        "latitude": 25.314
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灌阳县",
       "center": {
        "longitude": 111.160851,
        "latitude": 25.489383
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "恭城瑶族自治县",
       "center": {
        "longitude": 110.828409,
        "latitude": 24.831682
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荔浦县",
       "center": {
        "longitude": 110.395104,
        "latitude": 24.488342
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临桂区",
       "center": {
        "longitude": 110.212463,
        "latitude": 25.238628
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灵川县",
       "center": {
        "longitude": 110.319897,
        "latitude": 25.394781
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙胜各族自治县",
       "center": {
        "longitude": 110.011238,
        "latitude": 25.797931
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平乐县",
       "center": {
        "longitude": 110.643305,
        "latitude": 24.633362
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "七星区",
       "center": {
        "longitude": 110.317826,
        "latitude": 25.252701
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "全州县",
       "center": {
        "longitude": 111.072946,
        "latitude": 25.928387
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "象山区",
       "center": {
        "longitude": 110.281082,
        "latitude": 25.261686
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴安县",
       "center": {
        "longitude": 110.67167,
        "latitude": 25.611704
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秀峰区",
       "center": {
        "longitude": 110.264183,
        "latitude": 25.273625
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳朔县",
       "center": {
        "longitude": 110.496593,
        "latitude": 24.77848
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雁山区",
       "center": {
        "longitude": 110.28669,
        "latitude": 25.101934
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永福县",
       "center": {
        "longitude": 109.983076,
        "latitude": 24.979855
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "资源县",
       "center": {
        "longitude": 110.6527,
        "latitude": 26.042443
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "贵港市",
     "center": {
      "longitude": 109.598926,
      "latitude": 23.11153
     },
     "level": "city",
     "districts": [
      {
       "name": "港南区",
       "center": {
        "longitude": 109.599556,
        "latitude": 23.075573
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "港北区",
       "center": {
        "longitude": 109.57224,
        "latitude": 23.11153
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桂平市",
       "center": {
        "longitude": 110.079379,
        "latitude": 23.394325
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平南县",
       "center": {
        "longitude": 110.392311,
        "latitude": 23.539264
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "覃塘区",
       "center": {
        "longitude": 109.452662,
        "latitude": 23.127149
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "河池市",
     "center": {
      "longitude": 108.085261,
      "latitude": 24.692931
     },
     "level": "city",
     "districts": [
      {
       "name": "巴马瑶族自治县",
       "center": {
        "longitude": 107.258588,
        "latitude": 24.142298
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大化瑶族自治县",
       "center": {
        "longitude": 107.998149,
        "latitude": 23.736457
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东兰县",
       "center": {
        "longitude": 107.374293,
        "latitude": 24.510842
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "都安瑶族自治县",
       "center": {
        "longitude": 108.105311,
        "latitude": 23.932675
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤山县",
       "center": {
        "longitude": 107.04219,
        "latitude": 24.546876
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "环江毛南族自治县",
       "center": {
        "longitude": 108.258028,
        "latitude": 24.825664
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金城江区",
       "center": {
        "longitude": 108.037276,
        "latitude": 24.689703
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "罗城仫佬族自治县",
       "center": {
        "longitude": 108.904706,
        "latitude": 24.777411
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南丹县",
       "center": {
        "longitude": 107.541244,
        "latitude": 24.975631
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天峨县",
       "center": {
        "longitude": 107.173802,
        "latitude": 24.999108
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜州区",
       "center": {
        "longitude": 108.636414,
        "latitude": 24.485214
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "贺州市",
     "center": {
      "longitude": 111.566871,
      "latitude": 24.403528
     },
     "level": "city",
     "districts": [
      {
       "name": "八步区",
       "center": {
        "longitude": 111.552095,
        "latitude": 24.411805
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富川瑶族自治县",
       "center": {
        "longitude": 111.27745,
        "latitude": 24.814443
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平桂区",
       "center": {
        "longitude": 111.479923,
        "latitude": 24.453845
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昭平县",
       "center": {
        "longitude": 110.811325,
        "latitude": 24.169385
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "钟山县",
       "center": {
        "longitude": 111.303009,
        "latitude": 24.525957
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "来宾市",
     "center": {
      "longitude": 109.221465,
      "latitude": 23.750306
     },
     "level": "city",
     "districts": [
      {
       "name": "合山市",
       "center": {
        "longitude": 108.886082,
        "latitude": 23.806535
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金秀瑶族自治县",
       "center": {
        "longitude": 110.189462,
        "latitude": 24.130374
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武宣县",
       "center": {
        "longitude": 109.663206,
        "latitude": 23.59411
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "忻城县",
       "center": {
        "longitude": 108.665666,
        "latitude": 24.066234
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "象州县",
       "center": {
        "longitude": 109.705065,
        "latitude": 23.973793
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴宾区",
       "center": {
        "longitude": 109.183333,
        "latitude": 23.72892
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "柳州市",
     "center": {
      "longitude": 109.428608,
      "latitude": 24.326291
     },
     "level": "city",
     "districts": [
      {
       "name": "城中区",
       "center": {
        "longitude": 109.4273,
        "latitude": 24.366
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柳城县",
       "center": {
        "longitude": 109.24473,
        "latitude": 24.651518
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柳北区",
       "center": {
        "longitude": 109.402049,
        "latitude": 24.362691
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柳江区",
       "center": {
        "longitude": 109.32638,
        "latitude": 24.254891
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柳南区",
       "center": {
        "longitude": 109.385518,
        "latitude": 24.336229
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鹿寨县",
       "center": {
        "longitude": 109.750638,
        "latitude": 24.472897
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "融水苗族自治县",
       "center": {
        "longitude": 109.256334,
        "latitude": 25.065934
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "融安县",
       "center": {
        "longitude": 109.397538,
        "latitude": 25.224549
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三江侗族自治县",
       "center": {
        "longitude": 109.607675,
        "latitude": 25.783198
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鱼峰区",
       "center": {
        "longitude": 109.452442,
        "latitude": 24.318516
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "南宁市",
     "center": {
      "longitude": 108.366543,
      "latitude": 22.817002
     },
     "level": "city",
     "districts": [
      {
       "name": "宾阳县",
       "center": {
        "longitude": 108.810326,
        "latitude": 23.217786
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "横县",
       "center": {
        "longitude": 109.261384,
        "latitude": 22.679931
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江南区",
       "center": {
        "longitude": 108.273133,
        "latitude": 22.78136
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "良庆区",
       "center": {
        "longitude": 108.39301,
        "latitude": 22.752997
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隆安县",
       "center": {
        "longitude": 107.696153,
        "latitude": 23.166028
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "马山县",
       "center": {
        "longitude": 108.177019,
        "latitude": 23.708321
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青秀区",
       "center": {
        "longitude": 108.494024,
        "latitude": 22.785879
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上林县",
       "center": {
        "longitude": 108.602846,
        "latitude": 23.431908
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武鸣区",
       "center": {
        "longitude": 108.27467,
        "latitude": 23.158595
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西乡塘区",
       "center": {
        "longitude": 108.313494,
        "latitude": 22.833928
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴宁区",
       "center": {
        "longitude": 108.368871,
        "latitude": 22.854021
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邕宁区",
       "center": {
        "longitude": 108.487368,
        "latitude": 22.75839
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "钦州市",
     "center": {
      "longitude": 108.654146,
      "latitude": 21.979933
     },
     "level": "city",
     "districts": [
      {
       "name": "灵山县",
       "center": {
        "longitude": 109.291006,
        "latitude": 22.416536
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浦北县",
       "center": {
        "longitude": 109.556953,
        "latitude": 22.271651
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "钦北区",
       "center": {
        "longitude": 108.44911,
        "latitude": 22.132761
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "钦南区",
       "center": {
        "longitude": 108.657209,
        "latitude": 21.938859
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "梧州市",
     "center": {
      "longitude": 111.279115,
      "latitude": 23.476962
     },
     "level": "city",
     "districts": [
      {
       "name": "苍梧县",
       "center": {
        "longitude": 111.544007,
        "latitude": 23.845097
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岑溪市",
       "center": {
        "longitude": 110.994913,
        "latitude": 22.91835
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙圩区",
       "center": {
        "longitude": 111.246606,
        "latitude": 23.404772
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蒙山县",
       "center": {
        "longitude": 110.525003,
        "latitude": 24.19357
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "藤县",
       "center": {
        "longitude": 110.914849,
        "latitude": 23.374983
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万秀区",
       "center": {
        "longitude": 111.320518,
        "latitude": 23.472991
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长洲区",
       "center": {
        "longitude": 111.274673,
        "latitude": 23.485944
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "玉林市",
     "center": {
      "longitude": 110.18122,
      "latitude": 22.654032
     },
     "level": "city",
     "districts": [
      {
       "name": "博白县",
       "center": {
        "longitude": 109.975985,
        "latitude": 22.273048
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "北流市",
       "center": {
        "longitude": 110.354214,
        "latitude": 22.70831
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "福绵区",
       "center": {
        "longitude": 110.059439,
        "latitude": 22.585556
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陆川县",
       "center": {
        "longitude": 110.264052,
        "latitude": 22.321048
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "容县",
       "center": {
        "longitude": 110.558074,
        "latitude": 22.857839
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴业县",
       "center": {
        "longitude": 109.875304,
        "latitude": 22.736421
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玉州区",
       "center": {
        "longitude": 110.151153,
        "latitude": 22.628087
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "海南省",
   "center": {
    "longitude": 110.349228,
    "latitude": 20.017377
   },
   "level": "province",
   "districts": [
    {
     "name": "儋州市",
     "center": {
      "longitude": 109.580811,
      "latitude": 19.521134
     },
     "level": "city",
     "districts": [
      {
       "name": "海头镇",
       "center": {
        "longitude": 108.953392,
        "latitude": 19.503315
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "白马井镇",
       "center": {
        "longitude": 109.218734,
        "latitude": 19.696407
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新英湾街道",
       "center": {
        "longitude": 109.2224,
        "latitude": 19.745499
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "那大街道",
       "center": {
        "longitude": 109.573403,
        "latitude": 19.511799
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "木棠镇",
       "center": {
        "longitude": 109.35023,
        "latitude": 19.80393
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新州镇",
       "center": {
        "longitude": 109.316166,
        "latitude": 19.71431
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "中和镇",
       "center": {
        "longitude": 109.349583,
        "latitude": 19.743857
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "峨蔓镇",
       "center": {
        "longitude": 109.266778,
        "latitude": 19.854773
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "排浦镇",
       "center": {
        "longitude": 109.163254,
        "latitude": 19.638809
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "王五镇",
       "center": {
        "longitude": 109.29572,
        "latitude": 19.653711
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "光村镇",
       "center": {
        "longitude": 109.48132,
        "latitude": 19.818101
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "和庆镇",
       "center": {
        "longitude": 109.640854,
        "latitude": 19.525401
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大成镇",
       "center": {
        "longitude": 109.399661,
        "latitude": 19.507964
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "兰洋镇",
       "center": {
        "longitude": 109.664393,
        "latitude": 19.460398
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "雅星镇",
       "center": {
        "longitude": 109.269115,
        "latitude": 19.444076
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "三都镇",
       "center": {
        "longitude": 109.21922,
        "latitude": 19.786922
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东成镇",
       "center": {
        "longitude": 109.461375,
        "latitude": 19.703706
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "那大镇",
       "center": {
        "longitude": 109.546409,
        "latitude": 19.514878
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "兰训乡",
       "center": {
        "longitude": 109.361149,
        "latitude": 19.859648
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "海口市",
     "center": {
      "longitude": 110.198286,
      "latitude": 20.044412
     },
     "level": "city",
     "districts": [
      {
       "name": "龙华区",
       "center": {
        "longitude": 110.328492,
        "latitude": 20.031006
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "美兰区",
       "center": {
        "longitude": 110.366358,
        "latitude": 20.029083
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "琼山区",
       "center": {
        "longitude": 110.353972,
        "latitude": 20.003169
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秀英区",
       "center": {
        "longitude": 110.293603,
        "latitude": 20.007494
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "三沙市",
     "center": {
      "longitude": 112.338695,
      "latitude": 16.831839
     },
     "level": "city",
     "districts": [
      {
       "name": "南沙群岛",
       "center": {
        "longitude": 116.749997,
        "latitude": 11.471888
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西沙群岛",
       "center": {
        "longitude": 111.792944,
        "latitude": 16.204546
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "中沙群岛的岛礁及其海域",
       "center": {
        "longitude": 117.740071,
        "latitude": 15.112855
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "三亚市",
     "center": {
      "longitude": 109.511772,
      "latitude": 18.253135
     },
     "level": "city",
     "districts": [
      {
       "name": "海棠区",
       "center": {
        "longitude": 109.752569,
        "latitude": 18.400106
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉阳区",
       "center": {
        "longitude": 109.578336,
        "latitude": 18.281406
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天涯区",
       "center": {
        "longitude": 109.452378,
        "latitude": 18.298156
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "崖州区",
       "center": {
        "longitude": 109.171841,
        "latitude": 18.357291
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "白沙黎族自治县",
     "center": {
      "longitude": 109.451484,
      "latitude": 19.224823
     },
     "level": "city",
     "districts": [
      {
       "name": "细水乡",
       "center": {
        "longitude": 109.568501,
        "latitude": 19.206414
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "阜龙乡",
       "center": {
        "longitude": 109.460782,
        "latitude": 19.32259
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "邦溪镇",
       "center": {
        "longitude": 109.103544,
        "latitude": 19.369531
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "南开乡",
       "center": {
        "longitude": 109.41468,
        "latitude": 19.07781
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "七坊镇",
       "center": {
        "longitude": 109.24007,
        "latitude": 19.29558
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "金波乡",
       "center": {
        "longitude": 109.178467,
        "latitude": 19.236611
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "牙叉镇",
       "center": {
        "longitude": 109.445359,
        "latitude": 19.212209
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "青松乡",
       "center": {
        "longitude": 109.270939,
        "latitude": 19.155189
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "打安镇",
       "center": {
        "longitude": 109.373668,
        "latitude": 19.283887
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "荣邦乡",
       "center": {
        "longitude": 109.170727,
        "latitude": 19.41395
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "元门乡",
       "center": {
        "longitude": 109.486456,
        "latitude": 19.158071
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "保亭黎族苗族自治县",
     "center": {
      "longitude": 109.70259,
      "latitude": 18.63913
     },
     "level": "city",
     "districts": [
      {
       "name": "毛岸镇",
       "center": {
        "longitude": 109.581045,
        "latitude": 18.683945
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "三道镇",
       "center": {
        "longitude": 109.668672,
        "latitude": 18.464576
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "保城镇",
       "center": {
        "longitude": 109.703534,
        "latitude": 18.641565
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "六弓乡",
       "center": {
        "longitude": 109.78506,
        "latitude": 18.53984
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "什玲镇",
       "center": {
        "longitude": 109.78174,
        "latitude": 18.663921
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "响水镇",
       "center": {
        "longitude": 109.61628,
        "latitude": 18.592227
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "毛感乡",
       "center": {
        "longitude": 109.50901,
        "latitude": 18.613029
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新政镇",
       "center": {
        "longitude": 109.628914,
        "latitude": 18.541645
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "南林乡",
       "center": {
        "longitude": 109.617455,
        "latitude": 18.405241
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "加茂镇",
       "center": {
        "longitude": 109.707284,
        "latitude": 18.55223
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "昌江黎族自治县",
     "center": {
      "longitude": 109.055739,
      "latitude": 19.298184
     },
     "level": "city",
     "districts": [
      {
       "name": "石碌镇",
       "center": {
        "longitude": 109.055809,
        "latitude": 19.27755
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "乌烈镇",
       "center": {
        "longitude": 108.792324,
        "latitude": 19.288577
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "七叉镇",
       "center": {
        "longitude": 109.05128,
        "latitude": 19.11481
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "海尾镇",
       "center": {
        "longitude": 108.8183,
        "latitude": 19.422
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "叉河镇",
       "center": {
        "longitude": 108.957345,
        "latitude": 19.238934
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "昌化镇",
       "center": {
        "longitude": 108.685071,
        "latitude": 19.329235
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "十月田镇",
       "center": {
        "longitude": 108.952224,
        "latitude": 19.328109
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "王下乡",
       "center": {
        "longitude": 109.150473,
        "latitude": 19.003399
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "澄迈县",
     "center": {
      "longitude": 110.006754,
      "latitude": 19.738521
     },
     "level": "city",
     "districts": [
      {
       "name": "加乐镇",
       "center": {
        "longitude": 110.00106,
        "latitude": 19.584999
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "福山镇",
       "center": {
        "longitude": 109.92986,
        "latitude": 19.83004
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "瑞溪镇",
       "center": {
        "longitude": 110.12908,
        "latitude": 19.73183
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "文儒镇",
       "center": {
        "longitude": 110.053169,
        "latitude": 19.53708
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "仁兴镇",
       "center": {
        "longitude": 109.88194,
        "latitude": 19.492539
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "永发镇",
       "center": {
        "longitude": 110.19532,
        "latitude": 19.747359
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大丰镇",
       "center": {
        "longitude": 110.038147,
        "latitude": 19.855536
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "桥头镇",
       "center": {
        "longitude": 109.933531,
        "latitude": 19.954138
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "中兴镇",
       "center": {
        "longitude": 109.861281,
        "latitude": 19.564772
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "老城镇",
       "center": {
        "longitude": 110.126498,
        "latitude": 19.953144
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "金江镇",
       "center": {
        "longitude": 110.010187,
        "latitude": 19.736764
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "定安县",
     "center": {
      "longitude": 110.359339,
      "latitude": 19.681404
     },
     "level": "city",
     "districts": [
      {
       "name": "翰林镇",
       "center": {
        "longitude": 110.26473,
        "latitude": 19.333758
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "龙河镇",
       "center": {
        "longitude": 110.219091,
        "latitude": 19.381868
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "黄竹镇",
       "center": {
        "longitude": 110.446721,
        "latitude": 19.472782
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "龙门镇",
       "center": {
        "longitude": 110.328024,
        "latitude": 19.43916
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "定城镇",
       "center": {
        "longitude": 110.368432,
        "latitude": 19.680292
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "富文镇",
       "center": {
        "longitude": 110.26279,
        "latitude": 19.551585
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "龙州乡",
       "center": {
        "longitude": 110.266105,
        "latitude": 19.663599
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "龙湖镇",
       "center": {
        "longitude": 110.401161,
        "latitude": 19.573221
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "居丁镇",
       "center": {
        "longitude": 110.404932,
        "latitude": 19.574772
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "雷鸣镇",
       "center": {
        "longitude": 110.326015,
        "latitude": 19.553655
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "岭口镇",
       "center": {
        "longitude": 110.308233,
        "latitude": 19.342639
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新竹镇",
       "center": {
        "longitude": 110.208962,
        "latitude": 19.617783
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "东方市",
     "center": {
      "longitude": 108.651815,
      "latitude": 19.095351
     },
     "level": "city",
     "districts": [
      {
       "name": "江边乡",
       "center": {
        "longitude": 108.976837,
        "latitude": 18.894428
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新龙镇",
       "center": {
        "longitude": 108.684538,
        "latitude": 18.952023
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "四更镇",
       "center": {
        "longitude": 108.682117,
        "latitude": 19.225616
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "板桥镇",
       "center": {
        "longitude": 108.688613,
        "latitude": 18.794859
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "感城镇",
       "center": {
        "longitude": 108.64791,
        "latitude": 18.84991
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大田镇",
       "center": {
        "longitude": 108.874903,
        "latitude": 19.16498
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "天安乡",
       "center": {
        "longitude": 108.912763,
        "latitude": 19.017418
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "罗带乡",
       "center": {
        "longitude": 108.674143,
        "latitude": 19.059986
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "三家镇",
       "center": {
        "longitude": 108.758458,
        "latitude": 19.241239
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东河镇",
       "center": {
        "longitude": 108.93808,
        "latitude": 19.048051
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "八所镇",
       "center": {
        "longitude": 108.670497,
        "latitude": 19.091445
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "乐东黎族自治县",
     "center": {
      "longitude": 109.173054,
      "latitude": 18.750259
     },
     "level": "city",
     "districts": [
      {
       "name": "大安镇",
       "center": {
        "longitude": 109.214756,
        "latitude": 18.691329
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "莺歌海镇",
       "center": {
        "longitude": 108.697349,
        "latitude": 18.510154
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "黄流镇",
       "center": {
        "longitude": 108.794872,
        "latitude": 18.506684
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "万冲镇",
       "center": {
        "longitude": 109.32287,
        "latitude": 18.844711
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "志仲镇",
       "center": {
        "longitude": 109.265117,
        "latitude": 18.629241
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "九所镇",
       "center": {
        "longitude": 108.953913,
        "latitude": 18.453504
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "利国镇",
       "center": {
        "longitude": 108.897225,
        "latitude": 18.472095
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "佛罗镇",
       "center": {
        "longitude": 108.736344,
        "latitude": 18.578636
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "抱由镇",
       "center": {
        "longitude": 109.179533,
        "latitude": 18.74478
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "尖峰镇",
       "center": {
        "longitude": 108.792488,
        "latitude": 18.690415
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "冲坡镇",
       "center": {
        "longitude": 108.881852,
        "latitude": 18.473897
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "千家镇",
       "center": {
        "longitude": 109.086133,
        "latitude": 18.565577
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "临高县",
     "center": {
      "longitude": 109.690508,
      "latitude": 19.912025
     },
     "level": "city",
     "districts": [
      {
       "name": "东英镇",
       "center": {
        "longitude": 109.648634,
        "latitude": 19.959022
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "皇桐镇",
       "center": {
        "longitude": 109.849709,
        "latitude": 19.832893
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "南宝镇",
       "center": {
        "longitude": 109.599545,
        "latitude": 19.680461
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "和舍镇",
       "center": {
        "longitude": 109.727565,
        "latitude": 19.596205
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "多文镇",
       "center": {
        "longitude": 109.771058,
        "latitude": 19.773837
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "临城镇",
       "center": {
        "longitude": 109.696445,
        "latitude": 19.896521
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "博厚镇",
       "center": {
        "longitude": 109.745761,
        "latitude": 19.883726
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "波莲镇",
       "center": {
        "longitude": 109.648489,
        "latitude": 19.868223
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新盈镇",
       "center": {
        "longitude": 109.536349,
        "latitude": 19.89513
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "调楼镇",
       "center": {
        "longitude": 109.546479,
        "latitude": 19.928661
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "加来镇",
       "center": {
        "longitude": 109.699231,
        "latitude": 19.709883
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "陵水黎族自治县",
     "center": {
      "longitude": 110.037503,
      "latitude": 18.506048
     },
     "level": "city",
     "districts": [
      {
       "name": "光坡镇",
       "center": {
        "longitude": 110.048782,
        "latitude": 18.54339
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大里乡",
       "center": {
        "longitude": 109.95142,
        "latitude": 18.750483
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "英州镇",
       "center": {
        "longitude": 109.858895,
        "latitude": 18.427366
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "三才镇",
       "center": {
        "longitude": 110.003299,
        "latitude": 18.474578
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "本号镇",
       "center": {
        "longitude": 109.96248,
        "latitude": 18.608901
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "群英乡",
       "center": {
        "longitude": 109.87883,
        "latitude": 18.58299
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "隆广镇",
       "center": {
        "longitude": 109.89942,
        "latitude": 18.50198
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "提蒙乡",
       "center": {
        "longitude": 110.013034,
        "latitude": 18.564805
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "椰林镇",
       "center": {
        "longitude": 110.036325,
        "latitude": 18.506138
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新村镇",
       "center": {
        "longitude": 109.971328,
        "latitude": 18.412445
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "黎安镇",
       "center": {
        "longitude": 110.069641,
        "latitude": 18.437315
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "文罗镇",
       "center": {
        "longitude": 109.957227,
        "latitude": 18.515697
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "琼海市",
     "center": {
      "longitude": 110.474497,
      "latitude": 19.259134
     },
     "level": "city",
     "districts": [
      {
       "name": "博鳌镇",
       "center": {
        "longitude": 110.586606,
        "latitude": 19.159714
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "石壁镇",
       "center": {
        "longitude": 110.308524,
        "latitude": 19.163306
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "会山镇",
       "center": {
        "longitude": 110.269379,
        "latitude": 19.067147
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大路镇",
       "center": {
        "longitude": 110.476468,
        "latitude": 19.381023
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "万泉镇",
       "center": {
        "longitude": 110.409657,
        "latitude": 19.243071
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "潭门镇",
       "center": {
        "longitude": 110.61694,
        "latitude": 19.24169
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "加积街道",
       "center": {
        "longitude": 110.465066,
        "latitude": 19.241859
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "中原镇",
       "center": {
        "longitude": 110.468478,
        "latitude": 19.151912
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "阳江镇",
       "center": {
        "longitude": 110.349228,
        "latitude": 19.099221
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "朝阳乡",
       "center": {
        "longitude": 110.530134,
        "latitude": 19.152241
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "长坡镇",
       "center": {
        "longitude": 110.606781,
        "latitude": 19.33564
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "塔洋镇",
       "center": {
        "longitude": 110.508274,
        "latitude": 19.288196
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "嘉积镇",
       "center": {
        "longitude": 110.485992,
        "latitude": 19.242966
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "龙江镇",
       "center": {
        "longitude": 110.324964,
        "latitude": 19.146787
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "琼中黎族苗族自治县",
     "center": {
      "longitude": 109.838389,
      "latitude": 19.033369
     },
     "level": "city",
     "districts": [
      {
       "name": "中平镇",
       "center": {
        "longitude": 110.06023,
        "latitude": 19.061179
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "和平镇",
       "center": {
        "longitude": 110.029212,
        "latitude": 18.897423
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "什运乡",
       "center": {
        "longitude": 109.607969,
        "latitude": 18.992017
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "营根镇",
       "center": {
        "longitude": 109.83431,
        "latitude": 19.032547
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "红毛镇",
       "center": {
        "longitude": 109.689932,
        "latitude": 19.030684
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "吊罗山乡",
       "center": {
        "longitude": 109.878143,
        "latitude": 18.792633
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "上安乡",
       "center": {
        "longitude": 109.837283,
        "latitude": 18.876829
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "湾岭镇",
       "center": {
        "longitude": 109.900496,
        "latitude": 19.141306
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "黎母山镇",
       "center": {
        "longitude": 109.78685,
        "latitude": 19.267691
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "屯昌县",
     "center": {
      "longitude": 110.103415,
      "latitude": 19.351765
     },
     "level": "city",
     "districts": [
      {
       "name": "南吕镇",
       "center": {
        "longitude": 110.08253,
        "latitude": 19.2507
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "西昌镇",
       "center": {
        "longitude": 110.0455,
        "latitude": 19.433661
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新兴镇",
       "center": {
        "longitude": 110.182802,
        "latitude": 19.506743
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "乌坡镇",
       "center": {
        "longitude": 110.075965,
        "latitude": 19.180023
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "枫木镇",
       "center": {
        "longitude": 110.019489,
        "latitude": 19.214452
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "坡心镇",
       "center": {
        "longitude": 110.089942,
        "latitude": 19.307033
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "屯城镇",
       "center": {
        "longitude": 110.104886,
        "latitude": 19.371561
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "南坤镇",
       "center": {
        "longitude": 109.948275,
        "latitude": 19.318366
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "万宁市",
     "center": {
      "longitude": 110.391073,
      "latitude": 18.795143
     },
     "level": "city",
     "districts": [
      {
       "name": "龙滚镇",
       "center": {
        "longitude": 110.519209,
        "latitude": 19.058665
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "礼纪镇",
       "center": {
        "longitude": 110.317655,
        "latitude": 18.75043
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "后安镇",
       "center": {
        "longitude": 110.443872,
        "latitude": 18.867778
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大茂镇",
       "center": {
        "longitude": 110.396556,
        "latitude": 18.849039
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "北大镇",
       "center": {
        "longitude": 110.336053,
        "latitude": 18.920125
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "万城镇",
       "center": {
        "longitude": 110.397028,
        "latitude": 18.794435
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "南桥镇",
       "center": {
        "longitude": 110.152697,
        "latitude": 18.680116
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "长丰镇",
       "center": {
        "longitude": 110.327657,
        "latitude": 18.800665
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东澳镇",
       "center": {
        "longitude": 110.401814,
        "latitude": 18.714928
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "三更罗镇",
       "center": {
        "longitude": 110.186521,
        "latitude": 18.860493
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "和乐镇",
       "center": {
        "longitude": 110.477641,
        "latitude": 18.903521
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "山根镇",
       "center": {
        "longitude": 110.486591,
        "latitude": 18.967334
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "文昌市",
     "center": {
      "longitude": 110.797717,
      "latitude": 19.543422
     },
     "level": "city",
     "districts": [
      {
       "name": "重兴镇",
       "center": {
        "longitude": 110.59675,
        "latitude": 19.411589
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "潭牛镇",
       "center": {
        "longitude": 110.735357,
        "latitude": 19.710084
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "文城镇",
       "center": {
        "longitude": 110.753868,
        "latitude": 19.613781
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "会文镇",
       "center": {
        "longitude": 110.731756,
        "latitude": 19.462573
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东路镇",
       "center": {
        "longitude": 110.706497,
        "latitude": 19.791949
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "冯坡镇",
       "center": {
        "longitude": 110.783953,
        "latitude": 19.964651
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "文教镇",
       "center": {
        "longitude": 110.90782,
        "latitude": 19.66768
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "锦山镇",
       "center": {
        "longitude": 110.69748,
        "latitude": 19.99583
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "蓬莱镇",
       "center": {
        "longitude": 110.541209,
        "latitude": 19.536767
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东阁镇",
       "center": {
        "longitude": 110.849213,
        "latitude": 19.656873
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "昌洒镇",
       "center": {
        "longitude": 110.900498,
        "latitude": 19.76179
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "铺前镇",
       "center": {
        "longitude": 110.580002,
        "latitude": 20.023731
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "翁田镇",
       "center": {
        "longitude": 110.880179,
        "latitude": 19.931473
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东郊镇",
       "center": {
        "longitude": 110.851831,
        "latitude": 19.573201
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "抱罗镇",
       "center": {
        "longitude": 110.748935,
        "latitude": 19.843477
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "公坡镇",
       "center": {
        "longitude": 110.808679,
        "latitude": 19.789147
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "龙楼镇",
       "center": {
        "longitude": 110.968604,
        "latitude": 19.653286
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "五指山市",
     "center": {
      "longitude": 109.516925,
      "latitude": 18.775146
     },
     "level": "city",
     "districts": [
      {
       "name": "番阳镇",
       "center": {
        "longitude": 109.39785,
        "latitude": 18.874421
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "冲山镇",
       "center": {
        "longitude": 109.516626,
        "latitude": 18.780681
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "毛阳镇",
       "center": {
        "longitude": 109.50804,
        "latitude": 18.936964
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "水满乡",
       "center": {
        "longitude": 109.667012,
        "latitude": 18.881007
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "通什镇",
       "center": {
        "longitude": 109.517189,
        "latitude": 18.780692
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "南圣镇",
       "center": {
        "longitude": 109.592708,
        "latitude": 18.738439
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "毛道乡",
       "center": {
        "longitude": 109.410699,
        "latitude": 18.791255
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "畅好乡",
       "center": {
        "longitude": 109.48221,
        "latitude": 18.734951
       },
       "level": "street",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "贵州省",
   "center": {
    "longitude": 106.70546,
    "latitude": 26.600055
   },
   "level": "province",
   "districts": [
    {
     "name": "安顺市",
     "center": {
      "longitude": 105.947594,
      "latitude": 26.253088
     },
     "level": "city",
     "districts": [
      {
       "name": "关岭布依族苗族自治县",
       "center": {
        "longitude": 105.61933,
        "latitude": 25.94361
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平坝区",
       "center": {
        "longitude": 106.256412,
        "latitude": 26.405715
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "普定县",
       "center": {
        "longitude": 105.743277,
        "latitude": 26.301565
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西秀区",
       "center": {
        "longitude": 105.965116,
        "latitude": 26.245315
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇宁布依族苗族自治县",
       "center": {
        "longitude": 105.770283,
        "latitude": 26.058086
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "紫云苗族布依族自治县",
       "center": {
        "longitude": 106.084441,
        "latitude": 25.751047
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "毕节市",
     "center": {
      "longitude": 105.291702,
      "latitude": 27.283908
     },
     "level": "city",
     "districts": [
      {
       "name": "大方县",
       "center": {
        "longitude": 105.613037,
        "latitude": 27.141735
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "赫章县",
       "center": {
        "longitude": 104.727418,
        "latitude": 27.123078
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金沙县",
       "center": {
        "longitude": 106.220227,
        "latitude": 27.459214
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "纳雍县",
       "center": {
        "longitude": 105.382714,
        "latitude": 26.777645
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "七星关区",
       "center": {
        "longitude": 105.30474,
        "latitude": 27.298458
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黔西县",
       "center": {
        "longitude": 106.033544,
        "latitude": 27.007713
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "威宁彝族回族苗族自治县",
       "center": {
        "longitude": 104.253071,
        "latitude": 26.873806
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "织金县",
       "center": {
        "longitude": 105.770542,
        "latitude": 26.663449
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "贵阳市",
     "center": {
      "longitude": 106.630153,
      "latitude": 26.647661
     },
     "level": "city",
     "districts": [
      {
       "name": "白云区",
       "center": {
        "longitude": 106.623007,
        "latitude": 26.678561
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "观山湖区",
       "center": {
        "longitude": 106.622453,
        "latitude": 26.60145
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "花溪区",
       "center": {
        "longitude": 106.67026,
        "latitude": 26.409817
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开阳县",
       "center": {
        "longitude": 106.965089,
        "latitude": 27.057764
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南明区",
       "center": {
        "longitude": 106.714374,
        "latitude": 26.567944
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清镇市",
       "center": {
        "longitude": 106.470714,
        "latitude": 26.556079
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌当区",
       "center": {
        "longitude": 106.750625,
        "latitude": 26.630845
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "息烽县",
       "center": {
        "longitude": 106.740407,
        "latitude": 27.090479
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "修文县",
       "center": {
        "longitude": 106.592108,
        "latitude": 26.838926
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云岩区",
       "center": {
        "longitude": 106.724494,
        "latitude": 26.604688
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "六盘水市",
     "center": {
      "longitude": 104.830458,
      "latitude": 26.592707
     },
     "level": "city",
     "districts": [
      {
       "name": "六枝特区",
       "center": {
        "longitude": 105.476608,
        "latitude": 26.213108
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盘州市",
       "center": {
        "longitude": 104.471375,
        "latitude": 25.709852
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "水城县",
       "center": {
        "longitude": 104.95783,
        "latitude": 26.547904
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "钟山区",
       "center": {
        "longitude": 104.843555,
        "latitude": 26.574979
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "黔西南布依族苗族自治州",
     "center": {
      "longitude": 104.906397,
      "latitude": 25.087856
     },
     "level": "city",
     "districts": [
      {
       "name": "安龙县",
       "center": {
        "longitude": 105.442701,
        "latitude": 25.099014
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "册亨县",
       "center": {
        "longitude": 105.811592,
        "latitude": 24.983663
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "普安县",
       "center": {
        "longitude": 104.953062,
        "latitude": 25.784135
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "晴隆县",
       "center": {
        "longitude": 105.218991,
        "latitude": 25.834783
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "望谟县",
       "center": {
        "longitude": 106.099617,
        "latitude": 25.178421
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴仁县",
       "center": {
        "longitude": 105.186237,
        "latitude": 25.435183
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴义市",
       "center": {
        "longitude": 104.895467,
        "latitude": 25.09204
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贞丰县",
       "center": {
        "longitude": 105.649864,
        "latitude": 25.38576
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "黔南布依族苗族自治州",
     "center": {
      "longitude": 107.522171,
      "latitude": 26.253275
     },
     "level": "city",
     "districts": [
      {
       "name": "都匀市",
       "center": {
        "longitude": 107.518847,
        "latitude": 26.259427
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "独山县",
       "center": {
        "longitude": 107.545048,
        "latitude": 25.822132
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "福泉市",
       "center": {
        "longitude": 107.520386,
        "latitude": 26.686335
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贵定县",
       "center": {
        "longitude": 107.232793,
        "latitude": 26.557089
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "惠水县",
       "center": {
        "longitude": 106.656442,
        "latitude": 26.13278
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荔波县",
       "center": {
        "longitude": 107.898882,
        "latitude": 25.423895
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙里县",
       "center": {
        "longitude": 106.979524,
        "latitude": 26.453154
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "罗甸县",
       "center": {
        "longitude": 106.751589,
        "latitude": 25.426173
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平塘县",
       "center": {
        "longitude": 107.322323,
        "latitude": 25.822349
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三都水族自治县",
       "center": {
        "longitude": 107.869749,
        "latitude": 25.983202
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "瓮安县",
       "center": {
        "longitude": 107.470942,
        "latitude": 27.078441
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长顺县",
       "center": {
        "longitude": 106.441805,
        "latitude": 26.025626
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "黔东南苗族侗族自治州",
     "center": {
      "longitude": 107.982874,
      "latitude": 26.583457
     },
     "level": "city",
     "districts": [
      {
       "name": "岑巩县",
       "center": {
        "longitude": 108.81606,
        "latitude": 27.173887
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "从江县",
       "center": {
        "longitude": 108.905329,
        "latitude": 25.753009
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丹寨县",
       "center": {
        "longitude": 107.788727,
        "latitude": 26.19832
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄平县",
       "center": {
        "longitude": 107.916411,
        "latitude": 26.905396
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "剑河县",
       "center": {
        "longitude": 108.441501,
        "latitude": 26.728274
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "锦屏县",
       "center": {
        "longitude": 109.200534,
        "latitude": 26.676233
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凯里市",
       "center": {
        "longitude": 107.97754,
        "latitude": 26.582963
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雷山县",
       "center": {
        "longitude": 108.07754,
        "latitude": 26.378442
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黎平县",
       "center": {
        "longitude": 109.136932,
        "latitude": 26.230706
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麻江县",
       "center": {
        "longitude": 107.589359,
        "latitude": 26.491105
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三穗县",
       "center": {
        "longitude": 108.675267,
        "latitude": 26.952967
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "榕江县",
       "center": {
        "longitude": 108.52188,
        "latitude": 25.931893
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "施秉县",
       "center": {
        "longitude": 108.124379,
        "latitude": 27.03292
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "台江县",
       "center": {
        "longitude": 108.321245,
        "latitude": 26.667525
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天柱县",
       "center": {
        "longitude": 109.207751,
        "latitude": 26.909639
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇远县",
       "center": {
        "longitude": 108.429534,
        "latitude": 27.049497
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "铜仁市",
     "center": {
      "longitude": 109.189598,
      "latitude": 27.731514
     },
     "level": "city",
     "districts": [
      {
       "name": "碧江区",
       "center": {
        "longitude": 109.263998,
        "latitude": 27.815927
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "德江县",
       "center": {
        "longitude": 108.119807,
        "latitude": 28.263963
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江口县",
       "center": {
        "longitude": 108.839557,
        "latitude": 27.69965
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石阡县",
       "center": {
        "longitude": 108.223612,
        "latitude": 27.513829
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "思南县",
       "center": {
        "longitude": 108.253882,
        "latitude": 27.93755
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "松桃苗族自治县",
       "center": {
        "longitude": 109.202886,
        "latitude": 28.154071
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万山区",
       "center": {
        "longitude": 109.213644,
        "latitude": 27.517896
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沿河土家族自治县",
       "center": {
        "longitude": 108.50387,
        "latitude": 28.563927
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "印江土家族苗族自治县",
       "center": {
        "longitude": 108.409751,
        "latitude": 27.994246
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玉屏侗族自治县",
       "center": {
        "longitude": 108.906411,
        "latitude": 27.235813
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "遵义市",
     "center": {
      "longitude": 106.927389,
      "latitude": 27.725654
     },
     "level": "city",
     "districts": [
      {
       "name": "播州区",
       "center": {
        "longitude": 106.829574,
        "latitude": 27.536298
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "赤水市",
       "center": {
        "longitude": 105.697472,
        "latitude": 28.590337
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "道真仡佬族苗族自治县",
       "center": {
        "longitude": 107.613133,
        "latitude": 28.862425
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤冈县",
       "center": {
        "longitude": 107.716355,
        "latitude": 27.954695
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红花岗区",
       "center": {
        "longitude": 106.8937,
        "latitude": 27.644754
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汇川区",
       "center": {
        "longitude": 106.93427,
        "latitude": 27.750125
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湄潭县",
       "center": {
        "longitude": 107.465407,
        "latitude": 27.749055
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仁怀市",
       "center": {
        "longitude": 106.40109,
        "latitude": 27.792514
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绥阳县",
       "center": {
        "longitude": 107.191222,
        "latitude": 27.946222
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桐梓县",
       "center": {
        "longitude": 106.825198,
        "latitude": 28.133311
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "务川仡佬族苗族自治县",
       "center": {
        "longitude": 107.898956,
        "latitude": 28.563086
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "习水县",
       "center": {
        "longitude": 106.197137,
        "latitude": 28.33127
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "余庆县",
       "center": {
        "longitude": 107.905197,
        "latitude": 27.215491
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "正安县",
       "center": {
        "longitude": 107.453945,
        "latitude": 28.553285
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "山西省",
   "center": {
    "longitude": 112.562678,
    "latitude": 37.873499
   },
   "level": "province",
   "districts": [
    {
     "name": "大同市",
     "center": {
      "longitude": 113.300129,
      "latitude": 40.076763
     },
     "level": "city",
     "districts": [
      {
       "name": "城区",
       "center": {
        "longitude": 113.298026,
        "latitude": 40.075666
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大同县",
       "center": {
        "longitude": 113.61244,
        "latitude": 40.040294
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广灵县",
       "center": {
        "longitude": 114.282758,
        "latitude": 39.760281
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浑源县",
       "center": {
        "longitude": 113.699475,
        "latitude": 39.693406
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "矿区",
       "center": {
        "longitude": 113.177206,
        "latitude": 40.036858
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灵丘县",
       "center": {
        "longitude": 114.23435,
        "latitude": 39.442406
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南郊区",
       "center": {
        "longitude": 113.149693,
        "latitude": 40.005404
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天镇县",
       "center": {
        "longitude": 114.090867,
        "latitude": 40.420237
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新荣区",
       "center": {
        "longitude": 113.140004,
        "latitude": 40.255866
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳高县",
       "center": {
        "longitude": 113.748944,
        "latitude": 40.361059
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "左云县",
       "center": {
        "longitude": 112.703008,
        "latitude": 40.013442
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "晋城市",
     "center": {
      "longitude": 112.851486,
      "latitude": 35.490684
     },
     "level": "city",
     "districts": [
      {
       "name": "城区",
       "center": {
        "longitude": 112.853555,
        "latitude": 35.501571
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高平市",
       "center": {
        "longitude": 112.92392,
        "latitude": 35.797997
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陵川县",
       "center": {
        "longitude": 113.280688,
        "latitude": 35.775685
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沁水县",
       "center": {
        "longitude": 112.186738,
        "latitude": 35.690141
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳城县",
       "center": {
        "longitude": 112.414738,
        "latitude": 35.486029
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泽州县",
       "center": {
        "longitude": 112.899137,
        "latitude": 35.617221
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "晋中市",
     "center": {
      "longitude": 112.752652,
      "latitude": 37.687357
     },
     "level": "city",
     "districts": [
      {
       "name": "和顺县",
       "center": {
        "longitude": 113.570415,
        "latitude": 37.32957
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "介休市",
       "center": {
        "longitude": 111.916711,
        "latitude": 37.026944
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灵石县",
       "center": {
        "longitude": 111.77864,
        "latitude": 36.847927
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平遥县",
       "center": {
        "longitude": 112.176136,
        "latitude": 37.189421
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "祁县",
       "center": {
        "longitude": 112.335542,
        "latitude": 37.357869
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "寿阳县",
       "center": {
        "longitude": 113.176373,
        "latitude": 37.895191
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太谷县",
       "center": {
        "longitude": 112.551305,
        "latitude": 37.421307
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昔阳县",
       "center": {
        "longitude": 113.706977,
        "latitude": 37.61253
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "榆次区",
       "center": {
        "longitude": 112.708224,
        "latitude": 37.697794
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "榆社县",
       "center": {
        "longitude": 112.975209,
        "latitude": 37.070916
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "左权县",
       "center": {
        "longitude": 113.379403,
        "latitude": 37.082943
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "临汾市",
     "center": {
      "longitude": 111.518975,
      "latitude": 36.088005
     },
     "level": "city",
     "districts": [
      {
       "name": "安泽县",
       "center": {
        "longitude": 112.250144,
        "latitude": 36.147787
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大宁县",
       "center": {
        "longitude": 110.75291,
        "latitude": 36.465102
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汾西县",
       "center": {
        "longitude": 111.56395,
        "latitude": 36.652854
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浮山县",
       "center": {
        "longitude": 111.848883,
        "latitude": 35.968124
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "古县",
       "center": {
        "longitude": 111.920465,
        "latitude": 36.266914
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洪洞县",
       "center": {
        "longitude": 111.674965,
        "latitude": 36.253747
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "侯马市",
       "center": {
        "longitude": 111.372002,
        "latitude": 35.619105
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "霍州市",
       "center": {
        "longitude": 111.755398,
        "latitude": 36.56893
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉县",
       "center": {
        "longitude": 110.681763,
        "latitude": 36.098188
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蒲县",
       "center": {
        "longitude": 111.096439,
        "latitude": 36.411826
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "曲沃县",
       "center": {
        "longitude": 111.47586,
        "latitude": 35.641086
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隰县",
       "center": {
        "longitude": 110.940637,
        "latitude": 36.69333
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "襄汾县",
       "center": {
        "longitude": 111.441725,
        "latitude": 35.876293
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乡宁县",
       "center": {
        "longitude": 110.847021,
        "latitude": 35.970389
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尧都区",
       "center": {
        "longitude": 111.579554,
        "latitude": 36.07884
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "翼城县",
       "center": {
        "longitude": 111.718951,
        "latitude": 35.738576
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永和县",
       "center": {
        "longitude": 110.632006,
        "latitude": 36.759507
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "吕梁市",
     "center": {
      "longitude": 111.144699,
      "latitude": 37.519126
     },
     "level": "city",
     "districts": [
      {
       "name": "方山县",
       "center": {
        "longitude": 111.244098,
        "latitude": 37.894631
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汾阳市",
       "center": {
        "longitude": 111.770477,
        "latitude": 37.261756
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "交城县",
       "center": {
        "longitude": 112.156064,
        "latitude": 37.551963
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "交口县",
       "center": {
        "longitude": 111.181151,
        "latitude": 36.982186
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岚县",
       "center": {
        "longitude": 111.671917,
        "latitude": 38.279299
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "离石区",
       "center": {
        "longitude": 111.150695,
        "latitude": 37.51786
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柳林县",
       "center": {
        "longitude": 110.889007,
        "latitude": 37.429772
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临县",
       "center": {
        "longitude": 110.992093,
        "latitude": 37.950758
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石楼县",
       "center": {
        "longitude": 110.834634,
        "latitude": 36.99857
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "文水县",
       "center": {
        "longitude": 112.028866,
        "latitude": 37.438101
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "孝义市",
       "center": {
        "longitude": 111.778818,
        "latitude": 37.146294
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴县",
       "center": {
        "longitude": 111.127667,
        "latitude": 38.462389
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "中阳县",
       "center": {
        "longitude": 111.179657,
        "latitude": 37.357058
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "朔州市",
     "center": {
      "longitude": 112.432991,
      "latitude": 39.331855
     },
     "level": "city",
     "districts": [
      {
       "name": "怀仁县",
       "center": {
        "longitude": 113.131717,
        "latitude": 39.821627
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平鲁区",
       "center": {
        "longitude": 112.28833,
        "latitude": 39.512155
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "山阴县",
       "center": {
        "longitude": 112.816413,
        "latitude": 39.527893
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "朔城区",
       "center": {
        "longitude": 112.432312,
        "latitude": 39.319519
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "应县",
       "center": {
        "longitude": 113.191098,
        "latitude": 39.554247
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "右玉县",
       "center": {
        "longitude": 112.466989,
        "latitude": 39.989063
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "太原市",
     "center": {
      "longitude": 112.548879,
      "latitude": 37.87059
     },
     "level": "city",
     "districts": [
      {
       "name": "古交市",
       "center": {
        "longitude": 112.175853,
        "latitude": 37.907129
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尖草坪区",
       "center": {
        "longitude": 112.486691,
        "latitude": 37.940387
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "晋源区",
       "center": {
        "longitude": 112.47794,
        "latitude": 37.715193
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "娄烦县",
       "center": {
        "longitude": 111.797083,
        "latitude": 38.067932
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清徐县",
       "center": {
        "longitude": 112.358667,
        "latitude": 37.607443
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万柏林区",
       "center": {
        "longitude": 112.515937,
        "latitude": 37.85958
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "小店区",
       "center": {
        "longitude": 112.565659,
        "latitude": 37.736525
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "杏花岭区",
       "center": {
        "longitude": 112.570604,
        "latitude": 37.893955
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳曲县",
       "center": {
        "longitude": 112.672952,
        "latitude": 38.058488
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "迎泽区",
       "center": {
        "longitude": 112.5634,
        "latitude": 37.863451
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "阳泉市",
     "center": {
      "longitude": 113.580519,
      "latitude": 37.856971
     },
     "level": "city",
     "districts": [
      {
       "name": "城区",
       "center": {
        "longitude": 113.600669,
        "latitude": 37.847436
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郊区",
       "center": {
        "longitude": 113.594163,
        "latitude": 37.944679
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "矿区",
       "center": {
        "longitude": 113.555279,
        "latitude": 37.868494
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平定县",
       "center": {
        "longitude": 113.630107,
        "latitude": 37.804988
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盂县",
       "center": {
        "longitude": 113.41233,
        "latitude": 38.085619
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "忻州市",
     "center": {
      "longitude": 112.734174,
      "latitude": 38.416663
     },
     "level": "city",
     "districts": [
      {
       "name": "保德县",
       "center": {
        "longitude": 111.086564,
        "latitude": 39.022487
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "代县",
       "center": {
        "longitude": 112.960282,
        "latitude": 39.066917
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "定襄县",
       "center": {
        "longitude": 112.957237,
        "latitude": 38.473506
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "繁峙县",
       "center": {
        "longitude": 113.265563,
        "latitude": 39.188811
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "河曲县",
       "center": {
        "longitude": 111.138472,
        "latitude": 39.384482
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "静乐县",
       "center": {
        "longitude": 111.939498,
        "latitude": 38.359306
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岢岚县",
       "center": {
        "longitude": 111.57285,
        "latitude": 38.70418
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁武县",
       "center": {
        "longitude": 112.304722,
        "latitude": 39.001524
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "偏关县",
       "center": {
        "longitude": 111.508831,
        "latitude": 39.436306
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "神池县",
       "center": {
        "longitude": 112.211296,
        "latitude": 39.090552
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五寨县",
       "center": {
        "longitude": 111.846904,
        "latitude": 38.910726
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五台县",
       "center": {
        "longitude": 113.255309,
        "latitude": 38.728315
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "忻府区",
       "center": {
        "longitude": 112.746046,
        "latitude": 38.404242
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "原平市",
       "center": {
        "longitude": 112.711058,
        "latitude": 38.731402
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "运城市",
     "center": {
      "longitude": 111.00746,
      "latitude": 35.026516
     },
     "level": "city",
     "districts": [
      {
       "name": "河津市",
       "center": {
        "longitude": 110.712063,
        "latitude": 35.596383
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "稷山县",
       "center": {
        "longitude": 110.983333,
        "latitude": 35.604025
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绛县",
       "center": {
        "longitude": 111.568236,
        "latitude": 35.49119
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临猗县",
       "center": {
        "longitude": 110.774547,
        "latitude": 35.144277
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平陆县",
       "center": {
        "longitude": 111.194133,
        "latitude": 34.82926
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芮城县",
       "center": {
        "longitude": 110.694369,
        "latitude": 34.693579
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万荣县",
       "center": {
        "longitude": 110.838024,
        "latitude": 35.415253
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "闻喜县",
       "center": {
        "longitude": 111.22472,
        "latitude": 35.356644
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "夏县",
       "center": {
        "longitude": 111.220456,
        "latitude": 35.141363
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新绛县",
       "center": {
        "longitude": 111.224734,
        "latitude": 35.616251
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盐湖区",
       "center": {
        "longitude": 110.998272,
        "latitude": 35.015101
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永济市",
       "center": {
        "longitude": 110.447543,
        "latitude": 34.8671
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "垣曲县",
       "center": {
        "longitude": 111.670108,
        "latitude": 35.297369
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "长治市",
     "center": {
      "longitude": 113.116404,
      "latitude": 36.195409
     },
     "level": "city",
     "districts": [
      {
       "name": "城区",
       "center": {
        "longitude": 113.123088,
        "latitude": 36.20353
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "壶关县",
       "center": {
        "longitude": 113.207049,
        "latitude": 36.115448
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郊区",
       "center": {
        "longitude": 113.101211,
        "latitude": 36.218388
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黎城县",
       "center": {
        "longitude": 113.387155,
        "latitude": 36.502328
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "潞城市",
       "center": {
        "longitude": 113.228852,
        "latitude": 36.334104
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平顺县",
       "center": {
        "longitude": 113.435961,
        "latitude": 36.200179
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沁县",
       "center": {
        "longitude": 112.699226,
        "latitude": 36.756063
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沁源县",
       "center": {
        "longitude": 112.337446,
        "latitude": 36.5002
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "屯留县",
       "center": {
        "longitude": 112.891998,
        "latitude": 36.315663
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武乡县",
       "center": {
        "longitude": 112.864561,
        "latitude": 36.837625
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "襄垣县",
       "center": {
        "longitude": 113.051491,
        "latitude": 36.535817
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长治县",
       "center": {
        "longitude": 113.051407,
        "latitude": 36.052858
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长子县",
       "center": {
        "longitude": 112.8779,
        "latitude": 36.122334
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "台湾省",
   "center": {
    "longitude": 121.509062,
    "latitude": 25.044332
   },
   "level": "province",
   "districts": []
  },
  {
   "name": "甘肃省",
   "center": {
    "longitude": 103.826447,
    "latitude": 36.05956
   },
   "level": "province",
   "districts": [
    {
     "name": "白银市",
     "center": {
      "longitude": 104.138771,
      "latitude": 36.545261
     },
     "level": "city",
     "districts": [
      {
       "name": "白银区",
       "center": {
        "longitude": 104.148556,
        "latitude": 36.535398
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "会宁县",
       "center": {
        "longitude": 105.053358,
        "latitude": 35.692823
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "景泰县",
       "center": {
        "longitude": 104.063091,
        "latitude": 37.183804
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "靖远县",
       "center": {
        "longitude": 104.676774,
        "latitude": 36.571365
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平川区",
       "center": {
        "longitude": 104.825208,
        "latitude": 36.728304
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "甘南藏族自治州",
     "center": {
      "longitude": 102.910995,
      "latitude": 34.983409
     },
     "level": "city",
     "districts": [
      {
       "name": "迭部县",
       "center": {
        "longitude": 103.221869,
        "latitude": 34.055938
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "合作市",
       "center": {
        "longitude": 102.910484,
        "latitude": 35.000286
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临潭县",
       "center": {
        "longitude": 103.353919,
        "latitude": 34.692747
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "碌曲县",
       "center": {
        "longitude": 102.487327,
        "latitude": 34.590944
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玛曲县",
       "center": {
        "longitude": 102.072698,
        "latitude": 33.997712
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "夏河县",
       "center": {
        "longitude": 102.521807,
        "latitude": 35.202503
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "舟曲县",
       "center": {
        "longitude": 104.251482,
        "latitude": 33.793631
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "卓尼县",
       "center": {
        "longitude": 103.507109,
        "latitude": 34.589588
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "定西市",
     "center": {
      "longitude": 104.592225,
      "latitude": 35.606978
     },
     "level": "city",
     "districts": [
      {
       "name": "安定区",
       "center": {
        "longitude": 104.610668,
        "latitude": 35.580629
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临洮县",
       "center": {
        "longitude": 103.859565,
        "latitude": 35.394988
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陇西县",
       "center": {
        "longitude": 104.634983,
        "latitude": 35.00394
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岷县",
       "center": {
        "longitude": 104.03688,
        "latitude": 34.438075
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通渭县",
       "center": {
        "longitude": 105.24206,
        "latitude": 35.210831
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "渭源县",
       "center": {
        "longitude": 104.215467,
        "latitude": 35.136755
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "漳县",
       "center": {
        "longitude": 104.471572,
        "latitude": 34.848444
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "嘉峪关市",
     "center": {
      "longitude": 98.289419,
      "latitude": 39.772554
     },
     "level": "city",
     "districts": [
      {
       "name": "嘉峪关乡",
       "center": {
        "longitude": 98.225891,
        "latitude": 39.812293
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "前进路街道",
       "center": {
        "longitude": 98.261242,
        "latitude": 39.767627
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "五一路街道",
       "center": {
        "longitude": 98.272798,
        "latitude": 39.788242
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "建设路街道",
       "center": {
        "longitude": 98.280403,
        "latitude": 39.785651
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新华路街道",
       "center": {
        "longitude": 98.268344,
        "latitude": 39.808651
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "前进街道",
       "center": {
        "longitude": 98.260744,
        "latitude": 39.763898
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "峪泉镇",
       "center": {
        "longitude": 98.231491,
        "latitude": 39.807959
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新城镇",
       "center": {
        "longitude": 98.451709,
        "latitude": 39.875401
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "文殊镇",
       "center": {
        "longitude": 98.378358,
        "latitude": 39.693957
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "金昌市",
     "center": {
      "longitude": 102.188117,
      "latitude": 38.520717
     },
     "level": "city",
     "districts": [
      {
       "name": "金川区",
       "center": {
        "longitude": 102.194015,
        "latitude": 38.521087
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永昌县",
       "center": {
        "longitude": 101.984458,
        "latitude": 38.243434
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "酒泉市",
     "center": {
      "longitude": 98.493927,
      "latitude": 39.732795
     },
     "level": "city",
     "districts": [
      {
       "name": "阿克塞哈萨克族自治县",
       "center": {
        "longitude": 94.340204,
        "latitude": 39.633943
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "敦煌市",
       "center": {
        "longitude": 94.661941,
        "latitude": 40.142089
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "瓜州县",
       "center": {
        "longitude": 95.782318,
        "latitude": 40.520538
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金塔县",
       "center": {
        "longitude": 98.901252,
        "latitude": 39.983955
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肃州区",
       "center": {
        "longitude": 98.507843,
        "latitude": 39.744953
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肃北蒙古族自治县",
       "center": {
        "longitude": 94.876579,
        "latitude": 39.51245
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玉门市",
       "center": {
        "longitude": 97.045661,
        "latitude": 40.292106
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "兰州市",
     "center": {
      "longitude": 103.834303,
      "latitude": 36.061089
     },
     "level": "city",
     "districts": [
      {
       "name": "安宁区",
       "center": {
        "longitude": 103.719054,
        "latitude": 36.104579
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "城关区",
       "center": {
        "longitude": 103.825307,
        "latitude": 36.057464
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "皋兰县",
       "center": {
        "longitude": 103.947377,
        "latitude": 36.332663
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红古区",
       "center": {
        "longitude": 102.859323,
        "latitude": 36.345669
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "七里河区",
       "center": {
        "longitude": 103.785949,
        "latitude": 36.066146
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西固区",
       "center": {
        "longitude": 103.627951,
        "latitude": 36.088552
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永登县",
       "center": {
        "longitude": 103.26038,
        "latitude": 36.736513
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "榆中县",
       "center": {
        "longitude": 104.112527,
        "latitude": 35.843056
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "临夏回族自治州",
     "center": {
      "longitude": 103.210655,
      "latitude": 35.601352
     },
     "level": "city",
     "districts": [
      {
       "name": "东乡族自治县",
       "center": {
        "longitude": 103.389346,
        "latitude": 35.663752
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广河县",
       "center": {
        "longitude": 103.575834,
        "latitude": 35.488051
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和政县",
       "center": {
        "longitude": 103.350997,
        "latitude": 35.424603
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "积石山保安族东乡族撒拉族自治县",
       "center": {
        "longitude": 102.875843,
        "latitude": 35.71766
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "康乐县",
       "center": {
        "longitude": 103.708354,
        "latitude": 35.370505
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临夏市",
       "center": {
        "longitude": 103.243021,
        "latitude": 35.604376
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临夏县",
       "center": {
        "longitude": 103.039826,
        "latitude": 35.478722
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永靖县",
       "center": {
        "longitude": 103.285853,
        "latitude": 35.958306
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "陇南市",
     "center": {
      "longitude": 104.960851,
      "latitude": 33.37068
     },
     "level": "city",
     "districts": [
      {
       "name": "成县",
       "center": {
        "longitude": 105.742424,
        "latitude": 33.75061
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宕昌县",
       "center": {
        "longitude": 104.393385,
        "latitude": 34.047261
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "徽县",
       "center": {
        "longitude": 106.08778,
        "latitude": 33.768826
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "康县",
       "center": {
        "longitude": 105.609169,
        "latitude": 33.329136
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "礼县",
       "center": {
        "longitude": 105.17864,
        "latitude": 34.189345
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "两当县",
       "center": {
        "longitude": 106.304966,
        "latitude": 33.908917
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "文县",
       "center": {
        "longitude": 104.683433,
        "latitude": 32.943815
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武都区",
       "center": {
        "longitude": 104.926337,
        "latitude": 33.392211
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西和县",
       "center": {
        "longitude": 105.298756,
        "latitude": 34.014215
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "平凉市",
     "center": {
      "longitude": 106.665061,
      "latitude": 35.542606
     },
     "level": "city",
     "districts": [
      {
       "name": "崇信县",
       "center": {
        "longitude": 107.025763,
        "latitude": 35.305596
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华亭县",
       "center": {
        "longitude": 106.653158,
        "latitude": 35.218292
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泾川县",
       "center": {
        "longitude": 107.36785,
        "latitude": 35.332666
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "静宁县",
       "center": {
        "longitude": 105.732556,
        "latitude": 35.521976
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "崆峒区",
       "center": {
        "longitude": 106.674767,
        "latitude": 35.542491
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灵台县",
       "center": {
        "longitude": 107.595874,
        "latitude": 35.070027
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "庄浪县",
       "center": {
        "longitude": 106.036686,
        "latitude": 35.202385
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "庆阳市",
     "center": {
      "longitude": 107.643571,
      "latitude": 35.70898
     },
     "level": "city",
     "districts": [
      {
       "name": "合水县",
       "center": {
        "longitude": 108.019554,
        "latitude": 35.819194
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华池县",
       "center": {
        "longitude": 107.990062,
        "latitude": 36.461306
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "环县",
       "center": {
        "longitude": 107.308501,
        "latitude": 36.568434
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁县",
       "center": {
        "longitude": 107.928371,
        "latitude": 35.502176
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "庆城县",
       "center": {
        "longitude": 107.881802,
        "latitude": 36.016299
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西峰区",
       "center": {
        "longitude": 107.651077,
        "latitude": 35.730652
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇原县",
       "center": {
        "longitude": 107.200832,
        "latitude": 35.677462
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "正宁县",
       "center": {
        "longitude": 108.359865,
        "latitude": 35.49178
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "天水市",
     "center": {
      "longitude": 105.724979,
      "latitude": 34.580885
     },
     "level": "city",
     "districts": [
      {
       "name": "甘谷县",
       "center": {
        "longitude": 105.340747,
        "latitude": 34.745486
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麦积区",
       "center": {
        "longitude": 105.889556,
        "latitude": 34.570384
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秦安县",
       "center": {
        "longitude": 105.674982,
        "latitude": 34.858916
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秦州区",
       "center": {
        "longitude": 105.724215,
        "latitude": 34.580888
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清水县",
       "center": {
        "longitude": 106.137293,
        "latitude": 34.749864
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武山县",
       "center": {
        "longitude": 104.890587,
        "latitude": 34.72139
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "张家川回族自治县",
       "center": {
        "longitude": 106.204517,
        "latitude": 34.988037
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "武威市",
     "center": {
      "longitude": 102.638201,
      "latitude": 37.928267
     },
     "level": "city",
     "districts": [
      {
       "name": "古浪县",
       "center": {
        "longitude": 102.897533,
        "latitude": 37.47012
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凉州区",
       "center": {
        "longitude": 102.642184,
        "latitude": 37.928224
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "民勤县",
       "center": {
        "longitude": 103.093791,
        "latitude": 38.62435
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天祝藏族自治县",
       "center": {
        "longitude": 103.141757,
        "latitude": 36.97174
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "张掖市",
     "center": {
      "longitude": 100.449913,
      "latitude": 38.925548
     },
     "level": "city",
     "districts": [
      {
       "name": "甘州区",
       "center": {
        "longitude": 100.415096,
        "latitude": 38.944662
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高台县",
       "center": {
        "longitude": 99.819519,
        "latitude": 39.378311
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临泽县",
       "center": {
        "longitude": 100.164283,
        "latitude": 39.152462
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "民乐县",
       "center": {
        "longitude": 100.812629,
        "latitude": 38.430347
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "山丹县",
       "center": {
        "longitude": 101.088529,
        "latitude": 38.784505
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肃南裕固族自治县",
       "center": {
        "longitude": 99.615601,
        "latitude": 38.836931
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "上海市",
   "center": {
    "longitude": 121.473662,
    "latitude": 31.230372
   },
   "level": "province",
   "districts": [
    {
     "name": "上海城区",
     "center": {
      "longitude": 121.473662,
      "latitude": 31.230372
     },
     "level": "city",
     "districts": [
      {
       "name": "宝山区",
       "center": {
        "longitude": 121.489612,
        "latitude": 31.405457
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "崇明区",
       "center": {
        "longitude": 121.397421,
        "latitude": 31.623728
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "奉贤区",
       "center": {
        "longitude": 121.474055,
        "latitude": 30.917766
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "虹口区",
       "center": {
        "longitude": 121.505133,
        "latitude": 31.2646
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄浦区",
       "center": {
        "longitude": 121.484428,
        "latitude": 31.231739
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嘉定区",
       "center": {
        "longitude": 121.265374,
        "latitude": 31.375869
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金山区",
       "center": {
        "longitude": 121.342455,
        "latitude": 30.741798
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "静安区",
       "center": {
        "longitude": 121.447453,
        "latitude": 31.227906
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "闵行区",
       "center": {
        "longitude": 121.380831,
        "latitude": 31.1129
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浦东新区",
       "center": {
        "longitude": 121.544379,
        "latitude": 31.221517
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "普陀区",
       "center": {
        "longitude": 121.395514,
        "latitude": 31.249603
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青浦区",
       "center": {
        "longitude": 121.124178,
        "latitude": 31.150681
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "松江区",
       "center": {
        "longitude": 121.227747,
        "latitude": 31.032243
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "徐汇区",
       "center": {
        "longitude": 121.436128,
        "latitude": 31.188464
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "杨浦区",
       "center": {
        "longitude": 121.525727,
        "latitude": 31.259822
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长宁区",
       "center": {
        "longitude": 121.424622,
        "latitude": 31.220372
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "安徽省",
   "center": {
    "longitude": 117.329949,
    "latitude": 31.733806
   },
   "level": "province",
   "districts": [
    {
     "name": "安庆市",
     "center": {
      "longitude": 117.115101,
      "latitude": 30.531919
     },
     "level": "city",
     "districts": [
      {
       "name": "大观区",
       "center": {
        "longitude": 117.013469,
        "latitude": 30.553697
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "怀宁县",
       "center": {
        "longitude": 116.829475,
        "latitude": 30.733824
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "潜山县",
       "center": {
        "longitude": 116.581371,
        "latitude": 30.631136
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宿松县",
       "center": {
        "longitude": 116.129105,
        "latitude": 30.153746
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太湖县",
       "center": {
        "longitude": 116.308795,
        "latitude": 30.45422
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桐城市",
       "center": {
        "longitude": 116.936748,
        "latitude": 31.035848
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "望江县",
       "center": {
        "longitude": 116.706498,
        "latitude": 30.128002
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜秀区",
       "center": {
        "longitude": 116.987542,
        "latitude": 30.613332
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "迎江区",
       "center": {
        "longitude": 117.09115,
        "latitude": 30.511548
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岳西县",
       "center": {
        "longitude": 116.359692,
        "latitude": 30.849762
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "蚌埠市",
     "center": {
      "longitude": 117.388512,
      "latitude": 32.91663
     },
     "level": "city",
     "districts": [
      {
       "name": "蚌山区",
       "center": {
        "longitude": 117.373595,
        "latitude": 32.917048
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "固镇县",
       "center": {
        "longitude": 117.316913,
        "latitude": 33.31688
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淮上区",
       "center": {
        "longitude": 117.35933,
        "latitude": 32.965435
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "怀远县",
       "center": {
        "longitude": 117.205237,
        "latitude": 32.970031
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙子湖区",
       "center": {
        "longitude": 117.379778,
        "latitude": 32.950611
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五河县",
       "center": {
        "longitude": 117.879486,
        "latitude": 33.127823
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "禹会区",
       "center": {
        "longitude": 117.342155,
        "latitude": 32.929799
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "亳州市",
     "center": {
      "longitude": 115.77867,
      "latitude": 33.844592
     },
     "level": "city",
     "districts": [
      {
       "name": "利辛县",
       "center": {
        "longitude": 116.208564,
        "latitude": 33.144515
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蒙城县",
       "center": {
        "longitude": 116.564247,
        "latitude": 33.26583
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "谯城区",
       "center": {
        "longitude": 115.779025,
        "latitude": 33.876235
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涡阳县",
       "center": {
        "longitude": 116.215665,
        "latitude": 33.492921
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "滁州市",
     "center": {
      "longitude": 118.327944,
      "latitude": 32.255636
     },
     "level": "city",
     "districts": [
      {
       "name": "定远县",
       "center": {
        "longitude": 117.698562,
        "latitude": 32.530981
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤阳县",
       "center": {
        "longitude": 117.531622,
        "latitude": 32.874735
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "来安县",
       "center": {
        "longitude": 118.435718,
        "latitude": 32.452199
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "琅琊区",
       "center": {
        "longitude": 118.305961,
        "latitude": 32.294631
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "明光市",
       "center": {
        "longitude": 118.018193,
        "latitude": 32.78196
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南谯区",
       "center": {
        "longitude": 118.41697,
        "latitude": 32.200197
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "全椒县",
       "center": {
        "longitude": 118.274149,
        "latitude": 32.08593
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天长市",
       "center": {
        "longitude": 119.004816,
        "latitude": 32.667571
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "池州市",
     "center": {
      "longitude": 117.491592,
      "latitude": 30.664779
     },
     "level": "city",
     "districts": [
      {
       "name": "东至县",
       "center": {
        "longitude": 117.027618,
        "latitude": 30.111163
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贵池区",
       "center": {
        "longitude": 117.567264,
        "latitude": 30.687219
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青阳县",
       "center": {
        "longitude": 117.84743,
        "latitude": 30.63923
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石台县",
       "center": {
        "longitude": 117.486306,
        "latitude": 30.210313
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "阜阳市",
     "center": {
      "longitude": 115.814504,
      "latitude": 32.890479
     },
     "level": "city",
     "districts": [
      {
       "name": "阜南县",
       "center": {
        "longitude": 115.595643,
        "latitude": 32.658297
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "界首市",
       "center": {
        "longitude": 115.374821,
        "latitude": 33.258244
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临泉县",
       "center": {
        "longitude": 115.263115,
        "latitude": 33.039715
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太和县",
       "center": {
        "longitude": 115.621941,
        "latitude": 33.160327
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "颍东区",
       "center": {
        "longitude": 115.856762,
        "latitude": 32.912477
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "颍泉区",
       "center": {
        "longitude": 115.80835,
        "latitude": 32.925211
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "颍上县",
       "center": {
        "longitude": 116.256772,
        "latitude": 32.653211
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "颍州区",
       "center": {
        "longitude": 115.806942,
        "latitude": 32.883468
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "合肥市",
     "center": {
      "longitude": 117.227219,
      "latitude": 31.820591
     },
     "level": "city",
     "districts": [
      {
       "name": "包河区",
       "center": {
        "longitude": 117.309519,
        "latitude": 31.793859
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巢湖市",
       "center": {
        "longitude": 117.890354,
        "latitude": 31.624522
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肥西县",
       "center": {
        "longitude": 117.157981,
        "latitude": 31.706809
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肥东县",
       "center": {
        "longitude": 117.469382,
        "latitude": 31.88794
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "庐阳区",
       "center": {
        "longitude": 117.264786,
        "latitude": 31.878589
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "庐江县",
       "center": {
        "longitude": 117.2882,
        "latitude": 31.256524
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蜀山区",
       "center": {
        "longitude": 117.260521,
        "latitude": 31.85124
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "瑶海区",
       "center": {
        "longitude": 117.309546,
        "latitude": 31.857917
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长丰县",
       "center": {
        "longitude": 117.167564,
        "latitude": 32.478018
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "黄山市",
     "center": {
      "longitude": 118.338272,
      "latitude": 29.715185
     },
     "level": "city",
     "districts": [
      {
       "name": "黄山区",
       "center": {
        "longitude": 118.141567,
        "latitude": 30.272942
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "徽州区",
       "center": {
        "longitude": 118.336743,
        "latitude": 29.827271
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "祁门县",
       "center": {
        "longitude": 117.717396,
        "latitude": 29.854055
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "歙县",
       "center": {
        "longitude": 118.415345,
        "latitude": 29.861379
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "屯溪区",
       "center": {
        "longitude": 118.315329,
        "latitude": 29.696108
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "休宁县",
       "center": {
        "longitude": 118.193618,
        "latitude": 29.784124
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黟县",
       "center": {
        "longitude": 117.938373,
        "latitude": 29.924805
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "淮南市",
     "center": {
      "longitude": 117.018399,
      "latitude": 32.587117
     },
     "level": "city",
     "districts": [
      {
       "name": "八公山区",
       "center": {
        "longitude": 116.83349,
        "latitude": 32.631379
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大通区",
       "center": {
        "longitude": 117.053314,
        "latitude": 32.631519
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤台县",
       "center": {
        "longitude": 116.71105,
        "latitude": 32.709444
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "潘集区",
       "center": {
        "longitude": 116.834715,
        "latitude": 32.77208
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "寿县",
       "center": {
        "longitude": 116.798232,
        "latitude": 32.545109
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "田家庵区",
       "center": {
        "longitude": 117.017349,
        "latitude": 32.647277
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "谢家集区",
       "center": {
        "longitude": 116.859188,
        "latitude": 32.600037
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "淮北市",
     "center": {
      "longitude": 116.798265,
      "latitude": 33.955844
     },
     "level": "city",
     "districts": [
      {
       "name": "杜集区",
       "center": {
        "longitude": 116.828133,
        "latitude": 33.991451
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "烈山区",
       "center": {
        "longitude": 116.813042,
        "latitude": 33.895139
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "濉溪县",
       "center": {
        "longitude": 116.766298,
        "latitude": 33.915477
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "相山区",
       "center": {
        "longitude": 116.794344,
        "latitude": 33.959892
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "六安市",
     "center": {
      "longitude": 116.520139,
      "latitude": 31.735456
     },
     "level": "city",
     "districts": [
      {
       "name": "霍邱县",
       "center": {
        "longitude": 116.277911,
        "latitude": 32.353038
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "霍山县",
       "center": {
        "longitude": 116.351892,
        "latitude": 31.410561
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金寨县",
       "center": {
        "longitude": 115.934366,
        "latitude": 31.72717
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金安区",
       "center": {
        "longitude": 116.539173,
        "latitude": 31.750119
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "舒城县",
       "center": {
        "longitude": 116.948736,
        "latitude": 31.462234
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "叶集区",
       "center": {
        "longitude": 115.925271,
        "latitude": 31.863693
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "裕安区",
       "center": {
        "longitude": 116.479829,
        "latitude": 31.738183
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "马鞍山市",
     "center": {
      "longitude": 118.507011,
      "latitude": 31.67044
     },
     "level": "city",
     "districts": [
      {
       "name": "博望区",
       "center": {
        "longitude": 118.844538,
        "latitude": 31.558471
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "当涂县",
       "center": {
        "longitude": 118.497972,
        "latitude": 31.571213
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "含山县",
       "center": {
        "longitude": 118.101421,
        "latitude": 31.735598
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和县",
       "center": {
        "longitude": 118.353667,
        "latitude": 31.742293
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "花山区",
       "center": {
        "longitude": 118.492565,
        "latitude": 31.71971
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雨山区",
       "center": {
        "longitude": 118.498578,
        "latitude": 31.682132
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "铜陵市",
     "center": {
      "longitude": 117.81154,
      "latitude": 30.945515
     },
     "level": "city",
     "districts": [
      {
       "name": "枞阳县",
       "center": {
        "longitude": 117.250594,
        "latitude": 30.706018
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郊区",
       "center": {
        "longitude": 117.768026,
        "latitude": 30.821069
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铜官区",
       "center": {
        "longitude": 117.85616,
        "latitude": 30.936272
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "义安区",
       "center": {
        "longitude": 117.791544,
        "latitude": 30.952823
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "宿州市",
     "center": {
      "longitude": 116.964195,
      "latitude": 33.647309
     },
     "level": "city",
     "districts": [
      {
       "name": "砀山县",
       "center": {
        "longitude": 116.367095,
        "latitude": 34.442561
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灵璧县",
       "center": {
        "longitude": 117.549395,
        "latitude": 33.554604
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泗县",
       "center": {
        "longitude": 117.910629,
        "latitude": 33.482982
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "萧县",
       "center": {
        "longitude": 116.947349,
        "latitude": 34.188732
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "埇桥区",
       "center": {
        "longitude": 116.977203,
        "latitude": 33.64059
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "芜湖市",
     "center": {
      "longitude": 118.432941,
      "latitude": 31.352859
     },
     "level": "city",
     "districts": [
      {
       "name": "繁昌县",
       "center": {
        "longitude": 118.198703,
        "latitude": 31.101782
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镜湖区",
       "center": {
        "longitude": 118.385009,
        "latitude": 31.340728
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鸠江区",
       "center": {
        "longitude": 118.391734,
        "latitude": 31.369373
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南陵县",
       "center": {
        "longitude": 118.334359,
        "latitude": 30.914922
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三山区",
       "center": {
        "longitude": 118.268101,
        "latitude": 31.219568
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "无为县",
       "center": {
        "longitude": 117.902366,
        "latitude": 31.303167
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芜湖县",
       "center": {
        "longitude": 118.576124,
        "latitude": 31.134809
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "弋江区",
       "center": {
        "longitude": 118.372655,
        "latitude": 31.311756
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "宣城市",
     "center": {
      "longitude": 118.75868,
      "latitude": 30.940195
     },
     "level": "city",
     "districts": [
      {
       "name": "广德县",
       "center": {
        "longitude": 119.420935,
        "latitude": 30.877555
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绩溪县",
       "center": {
        "longitude": 118.578519,
        "latitude": 30.067533
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泾县",
       "center": {
        "longitude": 118.419859,
        "latitude": 30.688634
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "旌德县",
       "center": {
        "longitude": 118.549861,
        "latitude": 30.298142
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郎溪县",
       "center": {
        "longitude": 119.179656,
        "latitude": 31.126412
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁国市",
       "center": {
        "longitude": 118.983171,
        "latitude": 30.633882
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宣州区",
       "center": {
        "longitude": 118.785561,
        "latitude": 30.944076
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "河南省",
   "center": {
    "longitude": 113.753394,
    "latitude": 34.765869
   },
   "level": "province",
   "districts": [
    {
     "name": "安阳市",
     "center": {
      "longitude": 114.392392,
      "latitude": 36.097577
     },
     "level": "city",
     "districts": [
      {
       "name": "安阳县",
       "center": {
        "longitude": 114.130207,
        "latitude": 36.130584
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "北关区",
       "center": {
        "longitude": 114.355742,
        "latitude": 36.10766
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "滑县",
       "center": {
        "longitude": 114.519311,
        "latitude": 35.575417
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "林州市",
       "center": {
        "longitude": 113.820129,
        "latitude": 36.083046
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙安区",
       "center": {
        "longitude": 114.301331,
        "latitude": 36.076225
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "内黄县",
       "center": {
        "longitude": 114.901452,
        "latitude": 35.971704
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汤阴县",
       "center": {
        "longitude": 114.357763,
        "latitude": 35.924514
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "文峰区",
       "center": {
        "longitude": 114.357082,
        "latitude": 36.090468
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "殷都区",
       "center": {
        "longitude": 114.303553,
        "latitude": 36.10989
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "鹤壁市",
     "center": {
      "longitude": 114.297309,
      "latitude": 35.748325
     },
     "level": "city",
     "districts": [
      {
       "name": "鹤山区",
       "center": {
        "longitude": 114.163258,
        "latitude": 35.954611
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浚县",
       "center": {
        "longitude": 114.55091,
        "latitude": 35.67636
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淇滨区",
       "center": {
        "longitude": 114.298789,
        "latitude": 35.741592
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淇县",
       "center": {
        "longitude": 114.208828,
        "latitude": 35.622507
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "山城区",
       "center": {
        "longitude": 114.184318,
        "latitude": 35.898033
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "焦作市",
     "center": {
      "longitude": 113.241823,
      "latitude": 35.215893
     },
     "level": "city",
     "districts": [
      {
       "name": "博爱县",
       "center": {
        "longitude": 113.064379,
        "latitude": 35.171045
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "解放区",
       "center": {
        "longitude": 113.230816,
        "latitude": 35.240282
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "马村区",
       "center": {
        "longitude": 113.322332,
        "latitude": 35.256108
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "孟州市",
       "center": {
        "longitude": 112.791401,
        "latitude": 34.907315
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沁阳市",
       "center": {
        "longitude": 112.950716,
        "latitude": 35.087539
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "山阳区",
       "center": {
        "longitude": 113.254881,
        "latitude": 35.214507
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "温县",
       "center": {
        "longitude": 113.08053,
        "latitude": 34.940189
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武陟县",
       "center": {
        "longitude": 113.401679,
        "latitude": 35.099378
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "修武县",
       "center": {
        "longitude": 113.447755,
        "latitude": 35.223514
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "中站区",
       "center": {
        "longitude": 113.182946,
        "latitude": 35.236819
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "开封市",
     "center": {
      "longitude": 114.307677,
      "latitude": 34.797966
     },
     "level": "city",
     "districts": [
      {
       "name": "鼓楼区",
       "center": {
        "longitude": 114.348306,
        "latitude": 34.78856
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兰考县",
       "center": {
        "longitude": 114.821348,
        "latitude": 34.822211
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙亭区",
       "center": {
        "longitude": 114.356076,
        "latitude": 34.815565
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "杞县",
       "center": {
        "longitude": 114.783139,
        "latitude": 34.549174
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "顺河回族区",
       "center": {
        "longitude": 114.364875,
        "latitude": 34.800458
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通许县",
       "center": {
        "longitude": 114.467467,
        "latitude": 34.480433
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尉氏县",
       "center": {
        "longitude": 114.193081,
        "latitude": 34.411494
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "祥符区",
       "center": {
        "longitude": 114.441285,
        "latitude": 34.756916
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "禹王台区",
       "center": {
        "longitude": 114.34817,
        "latitude": 34.777104
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "漯河市",
     "center": {
      "longitude": 114.016536,
      "latitude": 33.580873
     },
     "level": "city",
     "districts": [
      {
       "name": "临颍县",
       "center": {
        "longitude": 113.931261,
        "latitude": 33.828042
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "舞阳县",
       "center": {
        "longitude": 113.609286,
        "latitude": 33.437876
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郾城区",
       "center": {
        "longitude": 114.006943,
        "latitude": 33.587409
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "源汇区",
       "center": {
        "longitude": 114.017948,
        "latitude": 33.565441
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "召陵区",
       "center": {
        "longitude": 114.093902,
        "latitude": 33.586565
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "洛阳市",
     "center": {
      "longitude": 112.453926,
      "latitude": 34.620202
     },
     "level": "city",
     "districts": [
      {
       "name": "瀍河回族区",
       "center": {
        "longitude": 112.500131,
        "latitude": 34.679773
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉利区",
       "center": {
        "longitude": 112.589112,
        "latitude": 34.900467
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涧西区",
       "center": {
        "longitude": 112.395756,
        "latitude": 34.658033
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "老城区",
       "center": {
        "longitude": 112.469766,
        "latitude": 34.6842
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "栾川县",
       "center": {
        "longitude": 111.615768,
        "latitude": 33.785698
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洛宁县",
       "center": {
        "longitude": 111.653111,
        "latitude": 34.389197
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洛龙区",
       "center": {
        "longitude": 112.463833,
        "latitude": 34.619711
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "孟津县",
       "center": {
        "longitude": 112.445354,
        "latitude": 34.825638
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汝阳县",
       "center": {
        "longitude": 112.473139,
        "latitude": 34.153939
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嵩县",
       "center": {
        "longitude": 112.085634,
        "latitude": 34.134516
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西工区",
       "center": {
        "longitude": 112.427914,
        "latitude": 34.660378
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新安县",
       "center": {
        "longitude": 112.13244,
        "latitude": 34.728284
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伊川县",
       "center": {
        "longitude": 112.425676,
        "latitude": 34.421323
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "偃师市",
       "center": {
        "longitude": 112.789534,
        "latitude": 34.72722
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜阳县",
       "center": {
        "longitude": 112.179238,
        "latitude": 34.514644
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "南阳市",
     "center": {
      "longitude": 112.528308,
      "latitude": 32.990664
     },
     "level": "city",
     "districts": [
      {
       "name": "邓州市",
       "center": {
        "longitude": 112.087493,
        "latitude": 32.68758
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "方城县",
       "center": {
        "longitude": 113.012494,
        "latitude": 33.254391
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南召县",
       "center": {
        "longitude": 112.429133,
        "latitude": 33.489877
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "内乡县",
       "center": {
        "longitude": 111.849392,
        "latitude": 33.044864
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "社旗县",
       "center": {
        "longitude": 112.948245,
        "latitude": 33.056109
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "唐河县",
       "center": {
        "longitude": 112.807636,
        "latitude": 32.681335
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桐柏县",
       "center": {
        "longitude": 113.428287,
        "latitude": 32.380073
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宛城区",
       "center": {
        "longitude": 112.539558,
        "latitude": 33.003784
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "卧龙区",
       "center": {
        "longitude": 112.528789,
        "latitude": 32.989877
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淅川县",
       "center": {
        "longitude": 111.490964,
        "latitude": 33.13782
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西峡县",
       "center": {
        "longitude": 111.47353,
        "latitude": 33.307294
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新野县",
       "center": {
        "longitude": 112.360026,
        "latitude": 32.520805
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇平县",
       "center": {
        "longitude": 112.234697,
        "latitude": 33.03411
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "平顶山市",
     "center": {
      "longitude": 113.192661,
      "latitude": 33.766169
     },
     "level": "city",
     "districts": [
      {
       "name": "宝丰县",
       "center": {
        "longitude": 113.054801,
        "latitude": 33.868434
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郏县",
       "center": {
        "longitude": 113.212609,
        "latitude": 33.971787
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鲁山县",
       "center": {
        "longitude": 112.908202,
        "latitude": 33.738293
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汝州市",
       "center": {
        "longitude": 112.844517,
        "latitude": 34.167029
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石龙区",
       "center": {
        "longitude": 112.898818,
        "latitude": 33.898713
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "卫东区",
       "center": {
        "longitude": 113.335192,
        "latitude": 33.734706
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "舞钢市",
       "center": {
        "longitude": 113.516343,
        "latitude": 33.314033
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新华区",
       "center": {
        "longitude": 113.293977,
        "latitude": 33.737251
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "叶县",
       "center": {
        "longitude": 113.357239,
        "latitude": 33.626731
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湛河区",
       "center": {
        "longitude": 113.320873,
        "latitude": 33.725681
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "濮阳市",
     "center": {
      "longitude": 115.029216,
      "latitude": 35.761829
     },
     "level": "city",
     "districts": [
      {
       "name": "范县",
       "center": {
        "longitude": 115.504201,
        "latitude": 35.851906
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华龙区",
       "center": {
        "longitude": 115.074151,
        "latitude": 35.777346
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南乐县",
       "center": {
        "longitude": 115.204675,
        "latitude": 36.069476
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "濮阳县",
       "center": {
        "longitude": 115.029078,
        "latitude": 35.712193
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清丰县",
       "center": {
        "longitude": 115.104389,
        "latitude": 35.88518
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "台前县",
       "center": {
        "longitude": 115.871906,
        "latitude": 35.96939
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "商丘市",
     "center": {
      "longitude": 115.656339,
      "latitude": 34.414961
     },
     "level": "city",
     "districts": [
      {
       "name": "梁园区",
       "center": {
        "longitude": 115.613965,
        "latitude": 34.443893
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "民权县",
       "center": {
        "longitude": 115.173971,
        "latitude": 34.648191
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁陵县",
       "center": {
        "longitude": 115.313743,
        "latitude": 34.460399
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "睢县",
       "center": {
        "longitude": 115.071879,
        "latitude": 34.445655
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "睢阳区",
       "center": {
        "longitude": 115.653301,
        "latitude": 34.388389
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "夏邑县",
       "center": {
        "longitude": 116.131447,
        "latitude": 34.237553
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永城市",
       "center": {
        "longitude": 116.4495,
        "latitude": 33.929291
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "虞城县",
       "center": {
        "longitude": 115.828319,
        "latitude": 34.400835
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柘城县",
       "center": {
        "longitude": 115.305708,
        "latitude": 34.091082
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "三门峡市",
     "center": {
      "longitude": 111.200367,
      "latitude": 34.772792
     },
     "level": "city",
     "districts": [
      {
       "name": "湖滨区",
       "center": {
        "longitude": 111.188397,
        "latitude": 34.770886
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灵宝市",
       "center": {
        "longitude": 110.89422,
        "latitude": 34.516828
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "卢氏县",
       "center": {
        "longitude": 111.047858,
        "latitude": 34.054324
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "渑池县",
       "center": {
        "longitude": 111.761797,
        "latitude": 34.767951
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陕州区",
       "center": {
        "longitude": 111.103563,
        "latitude": 34.720547
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "义马市",
       "center": {
        "longitude": 111.87448,
        "latitude": 34.7474
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "许昌市",
     "center": {
      "longitude": 113.852454,
      "latitude": 34.035771
     },
     "level": "city",
     "districts": [
      {
       "name": "建安区",
       "center": {
        "longitude": 113.822983,
        "latitude": 34.12466
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "魏都区",
       "center": {
        "longitude": 113.822647,
        "latitude": 34.025341
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "襄城县",
       "center": {
        "longitude": 113.505874,
        "latitude": 33.851459
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄢陵县",
       "center": {
        "longitude": 114.177399,
        "latitude": 34.102332
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "禹州市",
       "center": {
        "longitude": 113.488478,
        "latitude": 34.140701
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长葛市",
       "center": {
        "longitude": 113.813714,
        "latitude": 34.19592
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "新乡市",
     "center": {
      "longitude": 113.926763,
      "latitude": 35.303704
     },
     "level": "city",
     "districts": [
      {
       "name": "封丘县",
       "center": {
        "longitude": 114.418882,
        "latitude": 35.041198
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤泉区",
       "center": {
        "longitude": 113.915184,
        "latitude": 35.383978
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红旗区",
       "center": {
        "longitude": 113.875245,
        "latitude": 35.30385
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "辉县市",
       "center": {
        "longitude": 113.805468,
        "latitude": 35.462312
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "获嘉县",
       "center": {
        "longitude": 113.657433,
        "latitude": 35.259808
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "牧野区",
       "center": {
        "longitude": 113.908772,
        "latitude": 35.315039
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "卫辉市",
       "center": {
        "longitude": 114.064907,
        "latitude": 35.398494
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "卫滨区",
       "center": {
        "longitude": 113.865663,
        "latitude": 35.301992
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新乡县",
       "center": {
        "longitude": 113.805205,
        "latitude": 35.190836
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "延津县",
       "center": {
        "longitude": 114.20509,
        "latitude": 35.141889
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "原阳县",
       "center": {
        "longitude": 113.940046,
        "latitude": 35.065587
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长垣县",
       "center": {
        "longitude": 114.668936,
        "latitude": 35.201548
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "信阳市",
     "center": {
      "longitude": 114.091193,
      "latitude": 32.147679
     },
     "level": "city",
     "districts": [
      {
       "name": "固始县",
       "center": {
        "longitude": 115.654481,
        "latitude": 32.168137
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "光山县",
       "center": {
        "longitude": 114.919152,
        "latitude": 32.010002
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淮滨县",
       "center": {
        "longitude": 115.419537,
        "latitude": 32.473258
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "潢川县",
       "center": {
        "longitude": 115.051908,
        "latitude": 32.131522
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "罗山县",
       "center": {
        "longitude": 114.512872,
        "latitude": 32.203883
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平桥区",
       "center": {
        "longitude": 114.125656,
        "latitude": 32.101031
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "商城县",
       "center": {
        "longitude": 115.406862,
        "latitude": 31.798377
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浉河区",
       "center": {
        "longitude": 114.058713,
        "latitude": 32.116803
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "息县",
       "center": {
        "longitude": 114.740456,
        "latitude": 32.342792
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新县",
       "center": {
        "longitude": 114.879239,
        "latitude": 31.643918
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "郑州市",
     "center": {
      "longitude": 113.625328,
      "latitude": 34.746611
     },
     "level": "city",
     "districts": [
      {
       "name": "登封市",
       "center": {
        "longitude": 113.050581,
        "latitude": 34.454443
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "二七区",
       "center": {
        "longitude": 113.640211,
        "latitude": 34.724114
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巩义市",
       "center": {
        "longitude": 113.022406,
        "latitude": 34.7481
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "管城回族区",
       "center": {
        "longitude": 113.6775,
        "latitude": 34.75429
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "惠济区",
       "center": {
        "longitude": 113.6169,
        "latitude": 34.867457
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金水区",
       "center": {
        "longitude": 113.660617,
        "latitude": 34.800004
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上街区",
       "center": {
        "longitude": 113.30893,
        "latitude": 34.802752
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新密市",
       "center": {
        "longitude": 113.391087,
        "latitude": 34.539376
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新郑市",
       "center": {
        "longitude": 113.740662,
        "latitude": 34.395949
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荥阳市",
       "center": {
        "longitude": 113.38324,
        "latitude": 34.786948
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "中牟县",
       "center": {
        "longitude": 113.976253,
        "latitude": 34.718936
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "中原区",
       "center": {
        "longitude": 113.613337,
        "latitude": 34.748256
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "周口市",
     "center": {
      "longitude": 114.69695,
      "latitude": 33.626149
     },
     "level": "city",
     "districts": [
      {
       "name": "沈丘县",
       "center": {
        "longitude": 115.098583,
        "latitude": 33.409369
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "川汇区",
       "center": {
        "longitude": 114.650628,
        "latitude": 33.647598
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郸城县",
       "center": {
        "longitude": 115.177188,
        "latitude": 33.644743
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "扶沟县",
       "center": {
        "longitude": 114.394821,
        "latitude": 34.059968
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淮阳县",
       "center": {
        "longitude": 114.886153,
        "latitude": 33.731561
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鹿邑县",
       "center": {
        "longitude": 115.484454,
        "latitude": 33.86
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "商水县",
       "center": {
        "longitude": 114.611651,
        "latitude": 33.542138
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太康县",
       "center": {
        "longitude": 114.837888,
        "latitude": 34.064463
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西华县",
       "center": {
        "longitude": 114.529756,
        "latitude": 33.767407
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "项城市",
       "center": {
        "longitude": 114.875333,
        "latitude": 33.465838
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "驻马店市",
     "center": {
      "longitude": 114.022247,
      "latitude": 33.012885
     },
     "level": "city",
     "districts": [
      {
       "name": "泌阳县",
       "center": {
        "longitude": 113.327144,
        "latitude": 32.723975
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平舆县",
       "center": {
        "longitude": 114.619159,
        "latitude": 32.96271
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "确山县",
       "center": {
        "longitude": 114.026429,
        "latitude": 32.802064
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上蔡县",
       "center": {
        "longitude": 114.264381,
        "latitude": 33.262439
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汝南县",
       "center": {
        "longitude": 114.362379,
        "latitude": 33.006729
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "遂平县",
       "center": {
        "longitude": 114.013182,
        "latitude": 33.145649
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西平县",
       "center": {
        "longitude": 114.021538,
        "latitude": 33.387684
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新蔡县",
       "center": {
        "longitude": 114.96547,
        "latitude": 32.744896
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "驿城区",
       "center": {
        "longitude": 113.993914,
        "latitude": 32.973054
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "正阳县",
       "center": {
        "longitude": 114.392773,
        "latitude": 32.605697
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "济源市",
     "center": {
      "longitude": 112.602256,
      "latitude": 35.067199
     },
     "level": "city",
     "districts": [
      {
       "name": "坡头镇",
       "center": {
        "longitude": 112.524757,
        "latitude": 34.928431
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "轵城镇",
       "center": {
        "longitude": 112.600987,
        "latitude": 35.04613
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "大峪镇",
       "center": {
        "longitude": 112.396154,
        "latitude": 34.937623
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "天坛街道",
       "center": {
        "longitude": 112.565589,
        "latitude": 35.094593
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "济水街道",
       "center": {
        "longitude": 112.588928,
        "latitude": 35.091632
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "玉泉街道",
       "center": {
        "longitude": 112.615791,
        "latitude": 35.092594
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "邵原镇",
       "center": {
        "longitude": 112.133528,
        "latitude": 35.160959
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "思礼镇",
       "center": {
        "longitude": 112.507286,
        "latitude": 35.101133
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "下冶镇",
       "center": {
        "longitude": 112.200224,
        "latitude": 35.03283
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "五龙口镇",
       "center": {
        "longitude": 112.68937,
        "latitude": 35.135041
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "梨林镇",
       "center": {
        "longitude": 112.713491,
        "latitude": 35.077678
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "王屋镇",
       "center": {
        "longitude": 112.272468,
        "latitude": 35.113906
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "克井镇",
       "center": {
        "longitude": 112.543028,
        "latitude": 35.160298
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "承留镇",
       "center": {
        "longitude": 112.499266,
        "latitude": 35.077712
       },
       "level": "street",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "河北省",
   "center": {
    "longitude": 114.530235,
    "latitude": 38.037433
   },
   "level": "province",
   "districts": [
    {
     "name": "保定市",
     "center": {
      "longitude": 115.464589,
      "latitude": 38.874434
     },
     "level": "city",
     "districts": [
      {
       "name": "安国市",
       "center": {
        "longitude": 115.326646,
        "latitude": 38.418439
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "安新县",
       "center": {
        "longitude": 115.935603,
        "latitude": 38.935369
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "博野县",
       "center": {
        "longitude": 115.46438,
        "latitude": 38.457364
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "定州市",
       "center": {
        "longitude": 114.990392,
        "latitude": 38.516461
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "定兴县",
       "center": {
        "longitude": 115.808296,
        "latitude": 39.263145
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阜平县",
       "center": {
        "longitude": 114.195104,
        "latitude": 38.849152
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高阳县",
       "center": {
        "longitude": 115.778965,
        "latitude": 38.700088
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高碑店市",
       "center": {
        "longitude": 115.873886,
        "latitude": 39.326839
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "竞秀区",
       "center": {
        "longitude": 115.45877,
        "latitude": 38.877449
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涞水县",
       "center": {
        "longitude": 115.713904,
        "latitude": 39.394316
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莲池区",
       "center": {
        "longitude": 115.497097,
        "latitude": 38.883582
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蠡县",
       "center": {
        "longitude": 115.583854,
        "latitude": 38.488055
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涞源县",
       "center": {
        "longitude": 114.694283,
        "latitude": 39.360247
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "满城区",
       "center": {
        "longitude": 115.322334,
        "latitude": 38.949119
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清苑区",
       "center": {
        "longitude": 115.489959,
        "latitude": 38.765148
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "曲阳县",
       "center": {
        "longitude": 114.745008,
        "latitude": 38.622248
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "容城县",
       "center": {
        "longitude": 115.861657,
        "latitude": 39.042784
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "顺平县",
       "center": {
        "longitude": 115.13547,
        "latitude": 38.837487
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "唐县",
       "center": {
        "longitude": 114.982972,
        "latitude": 38.748203
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "望都县",
       "center": {
        "longitude": 115.155128,
        "latitude": 38.695842
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雄县",
       "center": {
        "longitude": 116.10865,
        "latitude": 38.99455
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "徐水区",
       "center": {
        "longitude": 115.655774,
        "latitude": 39.018736
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "易县",
       "center": {
        "longitude": 115.497457,
        "latitude": 39.349393
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涿州市",
       "center": {
        "longitude": 115.974422,
        "latitude": 39.485282
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "沧州市",
     "center": {
      "longitude": 116.838834,
      "latitude": 38.304477
     },
     "level": "city",
     "districts": [
      {
       "name": "沧县",
       "center": {
        "longitude": 117.007478,
        "latitude": 38.219856
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东光县",
       "center": {
        "longitude": 116.537067,
        "latitude": 37.888248
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海兴县",
       "center": {
        "longitude": 117.497651,
        "latitude": 38.143169
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "河间市",
       "center": {
        "longitude": 116.099517,
        "latitude": 38.446624
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄骅市",
       "center": {
        "longitude": 117.329949,
        "latitude": 38.371402
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "孟村回族自治县",
       "center": {
        "longitude": 117.104298,
        "latitude": 38.053409
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南皮县",
       "center": {
        "longitude": 116.708347,
        "latitude": 38.038421
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泊头市",
       "center": {
        "longitude": 116.578367,
        "latitude": 38.083437
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青县",
       "center": {
        "longitude": 116.804305,
        "latitude": 38.583021
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "任丘市",
       "center": {
        "longitude": 116.082917,
        "latitude": 38.683591
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肃宁县",
       "center": {
        "longitude": 115.829758,
        "latitude": 38.422801
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吴桥县",
       "center": {
        "longitude": 116.391508,
        "latitude": 37.627661
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "献县",
       "center": {
        "longitude": 116.122725,
        "latitude": 38.190185
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新华区",
       "center": {
        "longitude": 116.866284,
        "latitude": 38.314416
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盐山县",
       "center": {
        "longitude": 117.230602,
        "latitude": 38.058087
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "运河区",
       "center": {
        "longitude": 116.843673,
        "latitude": 38.283749
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "承德市",
     "center": {
      "longitude": 117.962749,
      "latitude": 40.952942
     },
     "level": "city",
     "districts": [
      {
       "name": "承德县",
       "center": {
        "longitude": 118.173824,
        "latitude": 40.768238
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰宁满族自治县",
       "center": {
        "longitude": 116.646051,
        "latitude": 41.209069
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宽城满族自治县",
       "center": {
        "longitude": 118.485313,
        "latitude": 40.611391
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隆化县",
       "center": {
        "longitude": 117.738937,
        "latitude": 41.313791
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "滦平县",
       "center": {
        "longitude": 117.332801,
        "latitude": 40.941482
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平泉市",
       "center": {
        "longitude": 118.701951,
        "latitude": 41.018405
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双桥区",
       "center": {
        "longitude": 117.943466,
        "latitude": 40.974643
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双滦区",
       "center": {
        "longitude": 117.799888,
        "latitude": 40.959236
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "围场满族蒙古族自治县",
       "center": {
        "longitude": 117.760159,
        "latitude": 41.938529
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴隆县",
       "center": {
        "longitude": 117.500558,
        "latitude": 40.417358
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鹰手营子矿区",
       "center": {
        "longitude": 117.659499,
        "latitude": 40.546361
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "邯郸市",
     "center": {
      "longitude": 114.538959,
      "latitude": 36.625594
     },
     "level": "city",
     "districts": [
      {
       "name": "成安县",
       "center": {
        "longitude": 114.670032,
        "latitude": 36.444317
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "磁县",
       "center": {
        "longitude": 114.373946,
        "latitude": 36.374011
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丛台区",
       "center": {
        "longitude": 114.492896,
        "latitude": 36.636409
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大名县",
       "center": {
        "longitude": 115.147814,
        "latitude": 36.285616
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肥乡区",
       "center": {
        "longitude": 114.800166,
        "latitude": 36.548131
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "峰峰矿区",
       "center": {
        "longitude": 114.212802,
        "latitude": 36.419739
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "复兴区",
       "center": {
        "longitude": 114.462061,
        "latitude": 36.639033
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广平县",
       "center": {
        "longitude": 114.948606,
        "latitude": 36.483484
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "馆陶县",
       "center": {
        "longitude": 115.282467,
        "latitude": 36.547556
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邯山区",
       "center": {
        "longitude": 114.531002,
        "latitude": 36.594313
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鸡泽县",
       "center": {
        "longitude": 114.889376,
        "latitude": 36.91034
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临漳县",
       "center": {
        "longitude": 114.619536,
        "latitude": 36.335025
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "曲周县",
       "center": {
        "longitude": 114.957504,
        "latitude": 36.76607
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邱县",
       "center": {
        "longitude": 115.200589,
        "latitude": 36.811148
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涉县",
       "center": {
        "longitude": 113.6914,
        "latitude": 36.584994
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "魏县",
       "center": {
        "longitude": 114.93892,
        "latitude": 36.359868
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武安市",
       "center": {
        "longitude": 114.203697,
        "latitude": 36.696506
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永年区",
       "center": {
        "longitude": 114.543832,
        "latitude": 36.743966
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "衡水市",
     "center": {
      "longitude": 115.670177,
      "latitude": 37.73892
     },
     "level": "city",
     "districts": [
      {
       "name": "安平县",
       "center": {
        "longitude": 115.519278,
        "latitude": 38.234501
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阜城县",
       "center": {
        "longitude": 116.175262,
        "latitude": 37.862505
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "故城县",
       "center": {
        "longitude": 115.965874,
        "latitude": 37.347409
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "冀州区",
       "center": {
        "longitude": 115.579308,
        "latitude": 37.550856
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "景县",
       "center": {
        "longitude": 116.270648,
        "latitude": 37.69229
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "饶阳县",
       "center": {
        "longitude": 115.725833,
        "latitude": 38.235892
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "深州市",
       "center": {
        "longitude": 115.559574,
        "latitude": 38.001535
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桃城区",
       "center": {
        "longitude": 115.67545,
        "latitude": 37.735465
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武强县",
       "center": {
        "longitude": 115.982461,
        "latitude": 38.041368
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武邑县",
       "center": {
        "longitude": 115.887531,
        "latitude": 37.801665
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "枣强县",
       "center": {
        "longitude": 115.724259,
        "latitude": 37.513417
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "廊坊市",
     "center": {
      "longitude": 116.683752,
      "latitude": 39.538047
     },
     "level": "city",
     "districts": [
      {
       "name": "霸州市",
       "center": {
        "longitude": 116.391484,
        "latitude": 39.125744
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "安次区",
       "center": {
        "longitude": 116.694544,
        "latitude": 39.502569
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大厂回族自治县",
       "center": {
        "longitude": 116.989574,
        "latitude": 39.886547
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大城县",
       "center": {
        "longitude": 116.653793,
        "latitude": 38.705449
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "固安县",
       "center": {
        "longitude": 116.298657,
        "latitude": 39.438214
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广阳区",
       "center": {
        "longitude": 116.71069,
        "latitude": 39.522786
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三河市",
       "center": {
        "longitude": 117.078294,
        "latitude": 39.982718
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "文安县",
       "center": {
        "longitude": 116.457898,
        "latitude": 38.87292
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "香河县",
       "center": {
        "longitude": 117.006093,
        "latitude": 39.761424
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永清县",
       "center": {
        "longitude": 116.50568,
        "latitude": 39.330689
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "秦皇岛市",
     "center": {
      "longitude": 119.518197,
      "latitude": 39.888701
     },
     "level": "city",
     "districts": [
      {
       "name": "北戴河区",
       "center": {
        "longitude": 119.484522,
        "latitude": 39.834596
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昌黎县",
       "center": {
        "longitude": 119.199551,
        "latitude": 39.700911
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "抚宁区",
       "center": {
        "longitude": 119.244847,
        "latitude": 39.876253
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海港区",
       "center": {
        "longitude": 119.564962,
        "latitude": 39.94756
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "卢龙县",
       "center": {
        "longitude": 118.892986,
        "latitude": 39.891946
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青龙满族自治县",
       "center": {
        "longitude": 118.949684,
        "latitude": 40.407578
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "山海关区",
       "center": {
        "longitude": 119.775799,
        "latitude": 39.978848
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "石家庄市",
     "center": {
      "longitude": 114.514793,
      "latitude": 38.042228
     },
     "level": "city",
     "districts": [
      {
       "name": "藁城区",
       "center": {
        "longitude": 114.847023,
        "latitude": 38.021453
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高邑县",
       "center": {
        "longitude": 114.611121,
        "latitude": 37.615534
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "井陉县",
       "center": {
        "longitude": 114.145242,
        "latitude": 38.032118
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "晋州市",
       "center": {
        "longitude": 115.044213,
        "latitude": 38.033671
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "井陉矿区",
       "center": {
        "longitude": 114.062062,
        "latitude": 38.065151
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灵寿县",
       "center": {
        "longitude": 114.382614,
        "latitude": 38.308665
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鹿泉区",
       "center": {
        "longitude": 114.313654,
        "latitude": 38.085953
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "栾城区",
       "center": {
        "longitude": 114.648318,
        "latitude": 37.900199
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平山县",
       "center": {
        "longitude": 114.195918,
        "latitude": 38.247888
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桥西区",
       "center": {
        "longitude": 114.461088,
        "latitude": 38.004193
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "深泽县",
       "center": {
        "longitude": 115.20092,
        "latitude": 38.184033
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "无极县",
       "center": {
        "longitude": 114.97634,
        "latitude": 38.179192
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "辛集市",
       "center": {
        "longitude": 115.217658,
        "latitude": 37.943121
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "行唐县",
       "center": {
        "longitude": 114.552714,
        "latitude": 38.438377
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新乐市",
       "center": {
        "longitude": 114.683776,
        "latitude": 38.343319
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新华区",
       "center": {
        "longitude": 114.463377,
        "latitude": 38.05095
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "裕华区",
       "center": {
        "longitude": 114.531202,
        "latitude": 38.00643
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "元氏县",
       "center": {
        "longitude": 114.525409,
        "latitude": 37.766513
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "赞皇县",
       "center": {
        "longitude": 114.386111,
        "latitude": 37.665663
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长安区",
       "center": {
        "longitude": 114.539395,
        "latitude": 38.036347
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "正定县",
       "center": {
        "longitude": 114.570941,
        "latitude": 38.146444
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "赵县",
       "center": {
        "longitude": 114.776297,
        "latitude": 37.756578
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "唐山市",
     "center": {
      "longitude": 118.180193,
      "latitude": 39.630867
     },
     "level": "city",
     "districts": [
      {
       "name": "曹妃甸区",
       "center": {
        "longitude": 118.460379,
        "latitude": 39.27307
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰润区",
       "center": {
        "longitude": 118.162215,
        "latitude": 39.832582
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰南区",
       "center": {
        "longitude": 118.085169,
        "latitude": 39.576031
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "古冶区",
       "center": {
        "longitude": 118.447635,
        "latitude": 39.733578
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开平区",
       "center": {
        "longitude": 118.261841,
        "latitude": 39.671001
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乐亭县",
       "center": {
        "longitude": 118.912571,
        "latitude": 39.425608
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "路北区",
       "center": {
        "longitude": 118.200692,
        "latitude": 39.624437
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "路南区",
       "center": {
        "longitude": 118.154354,
        "latitude": 39.625058
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "滦南县",
       "center": {
        "longitude": 118.682379,
        "latitude": 39.518996
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "滦县",
       "center": {
        "longitude": 118.703598,
        "latitude": 39.740593
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "迁安市",
       "center": {
        "longitude": 118.701144,
        "latitude": 39.999174
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "迁西县",
       "center": {
        "longitude": 118.314715,
        "latitude": 40.1415
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玉田县",
       "center": {
        "longitude": 117.738658,
        "latitude": 39.900401
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "遵化市",
       "center": {
        "longitude": 117.965892,
        "latitude": 40.189201
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "邢台市",
     "center": {
      "longitude": 114.504677,
      "latitude": 37.070834
     },
     "level": "city",
     "districts": [
      {
       "name": "柏乡县",
       "center": {
        "longitude": 114.693425,
        "latitude": 37.482422
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广宗县",
       "center": {
        "longitude": 115.142626,
        "latitude": 37.074661
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巨鹿县",
       "center": {
        "longitude": 115.037477,
        "latitude": 37.221112
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临城县",
       "center": {
        "longitude": 114.498761,
        "latitude": 37.444498
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临西县",
       "center": {
        "longitude": 115.501048,
        "latitude": 36.870811
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隆尧县",
       "center": {
        "longitude": 114.770419,
        "latitude": 37.350172
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南宫市",
       "center": {
        "longitude": 115.408747,
        "latitude": 37.359264
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南和县",
       "center": {
        "longitude": 114.683863,
        "latitude": 37.005017
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "内丘县",
       "center": {
        "longitude": 114.512128,
        "latitude": 37.286669
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁晋县",
       "center": {
        "longitude": 114.93992,
        "latitude": 37.624564
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平乡县",
       "center": {
        "longitude": 115.030075,
        "latitude": 37.063148
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桥东区",
       "center": {
        "longitude": 114.507058,
        "latitude": 37.071287
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桥西区",
       "center": {
        "longitude": 114.468601,
        "latitude": 37.059827
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清河县",
       "center": {
        "longitude": 115.667208,
        "latitude": 37.039991
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "任县",
       "center": {
        "longitude": 114.671936,
        "latitude": 37.120982
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙河市",
       "center": {
        "longitude": 114.503339,
        "latitude": 36.854929
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "威县",
       "center": {
        "longitude": 115.266703,
        "latitude": 36.975478
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新河县",
       "center": {
        "longitude": 115.250907,
        "latitude": 37.520862
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邢台县",
       "center": {
        "longitude": 114.561132,
        "latitude": 37.05073
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "张家口市",
     "center": {
      "longitude": 114.886252,
      "latitude": 40.768493
     },
     "level": "city",
     "districts": [
      {
       "name": "赤城县",
       "center": {
        "longitude": 115.831498,
        "latitude": 40.912921
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "崇礼区",
       "center": {
        "longitude": 115.282668,
        "latitude": 40.974675
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沽源县",
       "center": {
        "longitude": 115.688692,
        "latitude": 41.669668
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "怀安县",
       "center": {
        "longitude": 114.385791,
        "latitude": 40.674193
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "怀来县",
       "center": {
        "longitude": 115.517861,
        "latitude": 40.415343
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "康保县",
       "center": {
        "longitude": 114.600404,
        "latitude": 41.852368
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桥西区",
       "center": {
        "longitude": 114.869657,
        "latitude": 40.819581
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桥东区",
       "center": {
        "longitude": 114.894189,
        "latitude": 40.788434
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尚义县",
       "center": {
        "longitude": 113.969618,
        "latitude": 41.076226
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万全区",
       "center": {
        "longitude": 114.740557,
        "latitude": 40.766965
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蔚县",
       "center": {
        "longitude": 114.588903,
        "latitude": 39.840842
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "下花园区",
       "center": {
        "longitude": 115.287352,
        "latitude": 40.502652
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宣化区",
       "center": {
        "longitude": 115.099494,
        "latitude": 40.608793
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳原县",
       "center": {
        "longitude": 114.150348,
        "latitude": 40.104663
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "张北县",
       "center": {
        "longitude": 114.720077,
        "latitude": 41.158596
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涿鹿县",
       "center": {
        "longitude": 115.205345,
        "latitude": 40.379562
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "湖北省",
   "center": {
    "longitude": 114.341745,
    "latitude": 30.546557
   },
   "level": "province",
   "districts": [
    {
     "name": "鄂州市",
     "center": {
      "longitude": 114.894935,
      "latitude": 30.391141
     },
     "level": "city",
     "districts": [
      {
       "name": "鄂城区",
       "center": {
        "longitude": 114.891586,
        "latitude": 30.400651
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华容区",
       "center": {
        "longitude": 114.729878,
        "latitude": 30.534309
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梁子湖区",
       "center": {
        "longitude": 114.684731,
        "latitude": 30.100141
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "恩施土家族苗族自治州",
     "center": {
      "longitude": 109.488172,
      "latitude": 30.272156
     },
     "level": "city",
     "districts": [
      {
       "name": "巴东县",
       "center": {
        "longitude": 110.340756,
        "latitude": 31.042324
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "恩施市",
       "center": {
        "longitude": 109.479664,
        "latitude": 30.29468
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鹤峰县",
       "center": {
        "longitude": 110.033662,
        "latitude": 29.890171
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建始县",
       "center": {
        "longitude": 109.722109,
        "latitude": 30.602129
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "来凤县",
       "center": {
        "longitude": 109.407828,
        "latitude": 29.493484
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "利川市",
       "center": {
        "longitude": 108.936452,
        "latitude": 30.29098
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "咸丰县",
       "center": {
        "longitude": 109.139726,
        "latitude": 29.665202
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宣恩县",
       "center": {
        "longitude": 109.489926,
        "latitude": 29.98692
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "黄石市",
     "center": {
      "longitude": 115.038962,
      "latitude": 30.201038
     },
     "level": "city",
     "districts": [
      {
       "name": "大冶市",
       "center": {
        "longitude": 114.980424,
        "latitude": 30.096147
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄石港区",
       "center": {
        "longitude": 115.065849,
        "latitude": 30.222938
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁山区",
       "center": {
        "longitude": 114.891605,
        "latitude": 30.203118
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西塞山区",
       "center": {
        "longitude": 115.109955,
        "latitude": 30.204924
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "下陆区",
       "center": {
        "longitude": 114.961327,
        "latitude": 30.173912
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳新县",
       "center": {
        "longitude": 115.215227,
        "latitude": 29.830257
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "黄冈市",
     "center": {
      "longitude": 114.872199,
      "latitude": 30.453667
     },
     "level": "city",
     "districts": [
      {
       "name": "红安县",
       "center": {
        "longitude": 114.618236,
        "latitude": 31.288153
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄梅县",
       "center": {
        "longitude": 115.944219,
        "latitude": 30.070453
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄州区",
       "center": {
        "longitude": 114.880104,
        "latitude": 30.434354
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "罗田县",
       "center": {
        "longitude": 115.399222,
        "latitude": 30.78429
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麻城市",
       "center": {
        "longitude": 115.008163,
        "latitude": 31.172739
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蕲春县",
       "center": {
        "longitude": 115.437007,
        "latitude": 30.225964
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "团风县",
       "center": {
        "longitude": 114.872191,
        "latitude": 30.643569
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浠水县",
       "center": {
        "longitude": 115.265355,
        "latitude": 30.452115
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武穴市",
       "center": {
        "longitude": 115.561217,
        "latitude": 29.844107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "英山县",
       "center": {
        "longitude": 115.681359,
        "latitude": 30.735157
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "荆门市",
     "center": {
      "longitude": 112.199427,
      "latitude": 31.035395
     },
     "level": "city",
     "districts": [
      {
       "name": "东宝区",
       "center": {
        "longitude": 112.201493,
        "latitude": 31.051852
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "掇刀区",
       "center": {
        "longitude": 112.207962,
        "latitude": 30.973451
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "京山县",
       "center": {
        "longitude": 113.119566,
        "latitude": 31.018457
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙洋县",
       "center": {
        "longitude": 112.588581,
        "latitude": 30.709221
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "钟祥市",
       "center": {
        "longitude": 112.58812,
        "latitude": 31.167819
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "荆州市",
     "center": {
      "longitude": 112.239746,
      "latitude": 30.335184
     },
     "level": "city",
     "districts": [
      {
       "name": "公安县",
       "center": {
        "longitude": 112.229648,
        "latitude": 30.058336
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洪湖市",
       "center": {
        "longitude": 113.475801,
        "latitude": 29.826916
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "监利县",
       "center": {
        "longitude": 112.904788,
        "latitude": 29.840179
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江陵县",
       "center": {
        "longitude": 112.424664,
        "latitude": 30.041822
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荆州区",
       "center": {
        "longitude": 112.190185,
        "latitude": 30.352853
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙市区",
       "center": {
        "longitude": 112.25193,
        "latitude": 30.326009
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石首市",
       "center": {
        "longitude": 112.425454,
        "latitude": 29.720938
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "松滋市",
       "center": {
        "longitude": 111.756781,
        "latitude": 30.174529
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "随州市",
     "center": {
      "longitude": 113.382515,
      "latitude": 31.690191
     },
     "level": "city",
     "districts": [
      {
       "name": "曾都区",
       "center": {
        "longitude": 113.37112,
        "latitude": 31.71628
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广水市",
       "center": {
        "longitude": 113.825889,
        "latitude": 31.616853
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "随县",
       "center": {
        "longitude": 113.290634,
        "latitude": 31.883739
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "十堰市",
     "center": {
      "longitude": 110.799291,
      "latitude": 32.629462
     },
     "level": "city",
     "districts": [
      {
       "name": "丹江口市",
       "center": {
        "longitude": 111.513127,
        "latitude": 32.540157
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "房县",
       "center": {
        "longitude": 110.733181,
        "latitude": 32.050378
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "茅箭区",
       "center": {
        "longitude": 110.813719,
        "latitude": 32.591904
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郧西县",
       "center": {
        "longitude": 110.425983,
        "latitude": 32.993182
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郧阳区",
       "center": {
        "longitude": 110.81205,
        "latitude": 32.834775
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "张湾区",
       "center": {
        "longitude": 110.769132,
        "latitude": 32.652297
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "竹山县",
       "center": {
        "longitude": 110.228747,
        "latitude": 32.224808
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "竹溪县",
       "center": {
        "longitude": 109.715304,
        "latitude": 32.318255
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "武汉市",
     "center": {
      "longitude": 114.305469,
      "latitude": 30.593175
     },
     "level": "city",
     "districts": [
      {
       "name": "蔡甸区",
       "center": {
        "longitude": 114.087285,
        "latitude": 30.536454
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东西湖区",
       "center": {
        "longitude": 114.137116,
        "latitude": 30.619917
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汉阳区",
       "center": {
        "longitude": 114.21861,
        "latitude": 30.553983
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汉南区",
       "center": {
        "longitude": 114.084597,
        "latitude": 30.308829
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洪山区",
       "center": {
        "longitude": 114.343796,
        "latitude": 30.500247
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄陂区",
       "center": {
        "longitude": 114.375725,
        "latitude": 30.882174
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江汉区",
       "center": {
        "longitude": 114.270867,
        "latitude": 30.601475
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江夏区",
       "center": {
        "longitude": 114.319097,
        "latitude": 30.376308
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江岸区",
       "center": {
        "longitude": 114.30911,
        "latitude": 30.600052
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "硚口区",
       "center": {
        "longitude": 114.21492,
        "latitude": 30.582202
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青山区",
       "center": {
        "longitude": 114.384968,
        "latitude": 30.640191
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武昌区",
       "center": {
        "longitude": 114.31665,
        "latitude": 30.554408
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新洲区",
       "center": {
        "longitude": 114.801096,
        "latitude": 30.841425
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "孝感市",
     "center": {
      "longitude": 113.957037,
      "latitude": 30.917766
     },
     "level": "city",
     "districts": [
      {
       "name": "安陆市",
       "center": {
        "longitude": 113.688941,
        "latitude": 31.25561
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大悟县",
       "center": {
        "longitude": 114.127022,
        "latitude": 31.561164
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汉川市",
       "center": {
        "longitude": 113.839149,
        "latitude": 30.661243
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "孝南区",
       "center": {
        "longitude": 113.910705,
        "latitude": 30.916812
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "孝昌县",
       "center": {
        "longitude": 113.998009,
        "latitude": 31.258159
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "应城市",
       "center": {
        "longitude": 113.572707,
        "latitude": 30.92837
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云梦县",
       "center": {
        "longitude": 113.753554,
        "latitude": 31.020983
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "襄阳市",
     "center": {
      "longitude": 112.122426,
      "latitude": 32.009016
     },
     "level": "city",
     "districts": [
      {
       "name": "保康县",
       "center": {
        "longitude": 111.261308,
        "latitude": 31.87831
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "樊城区",
       "center": {
        "longitude": 112.135684,
        "latitude": 32.044832
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "谷城县",
       "center": {
        "longitude": 111.652982,
        "latitude": 32.263849
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "老河口市",
       "center": {
        "longitude": 111.683861,
        "latitude": 32.359068
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南漳县",
       "center": {
        "longitude": 111.838905,
        "latitude": 31.774636
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "襄城区",
       "center": {
        "longitude": 112.134052,
        "latitude": 32.010366
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "襄州区",
       "center": {
        "longitude": 112.211982,
        "latitude": 32.087127
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜城市",
       "center": {
        "longitude": 112.257788,
        "latitude": 31.719806
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "枣阳市",
       "center": {
        "longitude": 112.771959,
        "latitude": 32.128818
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "咸宁市",
     "center": {
      "longitude": 114.322616,
      "latitude": 29.841362
     },
     "level": "city",
     "districts": [
      {
       "name": "赤壁市",
       "center": {
        "longitude": 113.90038,
        "latitude": 29.725184
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "崇阳县",
       "center": {
        "longitude": 114.039523,
        "latitude": 29.556688
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嘉鱼县",
       "center": {
        "longitude": 113.939271,
        "latitude": 29.970676
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通城县",
       "center": {
        "longitude": 113.816966,
        "latitude": 29.245269
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通山县",
       "center": {
        "longitude": 114.482622,
        "latitude": 29.606372
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "咸安区",
       "center": {
        "longitude": 114.298711,
        "latitude": 29.852891
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "宜昌市",
     "center": {
      "longitude": 111.286445,
      "latitude": 30.691865
     },
     "level": "city",
     "districts": [
      {
       "name": "点军区",
       "center": {
        "longitude": 111.268119,
        "latitude": 30.693247
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "当阳市",
       "center": {
        "longitude": 111.788312,
        "latitude": 30.821266
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五峰土家族自治县",
       "center": {
        "longitude": 111.07374,
        "latitude": 30.156741
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伍家岗区",
       "center": {
        "longitude": 111.361037,
        "latitude": 30.644334
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西陵区",
       "center": {
        "longitude": 111.285646,
        "latitude": 30.710781
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "猇亭区",
       "center": {
        "longitude": 111.43462,
        "latitude": 30.530903
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴山县",
       "center": {
        "longitude": 110.746804,
        "latitude": 31.348196
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "夷陵区",
       "center": {
        "longitude": 111.32638,
        "latitude": 30.770006
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜都市",
       "center": {
        "longitude": 111.450096,
        "latitude": 30.378299
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "远安县",
       "center": {
        "longitude": 111.640508,
        "latitude": 31.060869
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长阳土家族自治县",
       "center": {
        "longitude": 111.207242,
        "latitude": 30.472763
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "枝江市",
       "center": {
        "longitude": 111.76053,
        "latitude": 30.42594
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秭归县",
       "center": {
        "longitude": 110.977711,
        "latitude": 30.825897
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "潜江市",
     "center": {
      "longitude": 112.899762,
      "latitude": 30.402167
     },
     "level": "city",
     "districts": [
      {
       "name": "积玉口镇",
       "center": {
        "longitude": 112.602848,
        "latitude": 30.445452
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "浩口镇",
       "center": {
        "longitude": 112.649998,
        "latitude": 30.378737
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "张金镇",
       "center": {
        "longitude": 112.596542,
        "latitude": 30.191927
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "龙湾镇",
       "center": {
        "longitude": 112.716783,
        "latitude": 30.229497
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "杨市街道",
       "center": {
        "longitude": 112.906177,
        "latitude": 30.368621
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "广华街道",
       "center": {
        "longitude": 112.698707,
        "latitude": 30.4433
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "周矶街道",
       "center": {
        "longitude": 112.809903,
        "latitude": 30.413886
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "园林街道",
       "center": {
        "longitude": 112.892257,
        "latitude": 30.412252
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "泽口街道",
       "center": {
        "longitude": 112.878264,
        "latitude": 30.484583
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "渔洋镇",
       "center": {
        "longitude": 112.908916,
        "latitude": 30.172423
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "兴隆镇",
       "center": {
        "longitude": 112.669031,
        "latitude": 30.61437
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "老新镇",
       "center": {
        "longitude": 112.85718,
        "latitude": 30.188774
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "竹根滩镇",
       "center": {
        "longitude": 112.906645,
        "latitude": 30.493505
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "高石碑镇",
       "center": {
        "longitude": 112.673268,
        "latitude": 30.547511
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "熊口镇",
       "center": {
        "longitude": 112.781307,
        "latitude": 30.306017
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "王场镇",
       "center": {
        "longitude": 112.774326,
        "latitude": 30.504891
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "神农架林区",
     "center": {
      "longitude": 110.675743,
      "latitude": 31.744915
     },
     "level": "city",
     "districts": [
      {
       "name": "新华镇",
       "center": {
        "longitude": 110.891544,
        "latitude": 31.592996
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "宋洛乡",
       "center": {
        "longitude": 110.607962,
        "latitude": 31.660861
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "阳日镇",
       "center": {
        "longitude": 110.819531,
        "latitude": 31.737393
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "九湖乡",
       "center": {
        "longitude": 110.11101,
        "latitude": 31.459682
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "下谷坪土家族乡",
       "center": {
        "longitude": 110.245252,
        "latitude": 31.365767
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "木鱼镇",
       "center": {
        "longitude": 110.482912,
        "latitude": 31.40142
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "红坪镇",
       "center": {
        "longitude": 110.429295,
        "latitude": 31.672835
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "松柏镇",
       "center": {
        "longitude": 110.661631,
        "latitude": 31.746937
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "天门市",
     "center": {
      "longitude": 113.166078,
      "latitude": 30.663337
     },
     "level": "city",
     "districts": [
      {
       "name": "净潭乡",
       "center": {
        "longitude": 113.400546,
        "latitude": 30.655127
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "麻洋镇",
       "center": {
        "longitude": 113.267873,
        "latitude": 30.435305
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "多祥镇",
       "center": {
        "longitude": 113.367061,
        "latitude": 30.427415
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "拖市镇",
       "center": {
        "longitude": 112.83882,
        "latitude": 30.727032
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "蒋场镇",
       "center": {
        "longitude": 112.945059,
        "latitude": 30.605892
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "汪场镇",
       "center": {
        "longitude": 113.041017,
        "latitude": 30.613778
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "马湾镇",
       "center": {
        "longitude": 113.334657,
        "latitude": 30.573309
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "横林镇",
       "center": {
        "longitude": 113.188343,
        "latitude": 30.536738
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "九真镇",
       "center": {
        "longitude": 113.220017,
        "latitude": 30.741711
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "石河镇",
       "center": {
        "longitude": 113.086015,
        "latitude": 30.75847
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "张港镇",
       "center": {
        "longitude": 112.881476,
        "latitude": 30.567657
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "小板镇",
       "center": {
        "longitude": 113.224975,
        "latitude": 30.608035
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "彭市镇",
       "center": {
        "longitude": 113.187885,
        "latitude": 30.456585
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "岳口街道",
       "center": {
        "longitude": 113.084237,
        "latitude": 30.509648
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "候口街道",
       "center": {
        "longitude": 113.147037,
        "latitude": 30.622951
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "杨林街道",
       "center": {
        "longitude": 113.194881,
        "latitude": 30.639918
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "竟陵街道",
       "center": {
        "longitude": 113.167089,
        "latitude": 30.645679
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "皂市镇",
       "center": {
        "longitude": 113.349357,
        "latitude": 30.856178
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "岳口镇",
       "center": {
        "longitude": 113.093585,
        "latitude": 30.507143
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "渔薪镇",
       "center": {
        "longitude": 112.990563,
        "latitude": 30.675337
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "多宝镇",
       "center": {
        "longitude": 112.697695,
        "latitude": 30.668163
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "卢市镇",
       "center": {
        "longitude": 113.343274,
        "latitude": 30.666241
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "胡市镇",
       "center": {
        "longitude": 113.389611,
        "latitude": 30.779595
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "佛子山镇",
       "center": {
        "longitude": 113.011283,
        "latitude": 30.752449
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "黄潭镇",
       "center": {
        "longitude": 113.090808,
        "latitude": 30.659423
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "干驿镇",
       "center": {
        "longitude": 113.386195,
        "latitude": 30.543403
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "仙桃市",
     "center": {
      "longitude": 113.423583,
      "latitude": 30.361438
     },
     "level": "city",
     "districts": [
      {
       "name": "郑场镇",
       "center": {
        "longitude": 113.033681,
        "latitude": 30.487221
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "西流河镇",
       "center": {
        "longitude": 113.677656,
        "latitude": 30.314502
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "郭河镇",
       "center": {
        "longitude": 113.293617,
        "latitude": 30.240359
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "干河街道",
       "center": {
        "longitude": 113.426439,
        "latitude": 30.374458
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "毛嘴镇",
       "center": {
        "longitude": 113.035343,
        "latitude": 30.417299
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "龙华山街道",
       "center": {
        "longitude": 113.461331,
        "latitude": 30.369509
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "沙咀街道",
       "center": {
        "longitude": 113.452657,
        "latitude": 30.35672
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "袁市街道",
       "center": {
        "longitude": 113.405411,
        "latitude": 30.378631
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "沙嘴街道",
       "center": {
        "longitude": 113.451741,
        "latitude": 30.357096
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "剅河镇",
       "center": {
        "longitude": 113.085477,
        "latitude": 30.33957
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "三伏潭镇",
       "center": {
        "longitude": 113.201557,
        "latitude": 30.375224
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "胡场镇",
       "center": {
        "longitude": 113.308093,
        "latitude": 30.377514
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "长埫口镇",
       "center": {
        "longitude": 113.564459,
        "latitude": 30.400802
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "张沟镇",
       "center": {
        "longitude": 113.38053,
        "latitude": 30.250066
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "陈场镇",
       "center": {
        "longitude": 113.087722,
        "latitude": 30.235173
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "通海口镇",
       "center": {
        "longitude": 113.153309,
        "latitude": 30.198244
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "彭场镇",
       "center": {
        "longitude": 113.506437,
        "latitude": 30.263346
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "杨林尾镇",
       "center": {
        "longitude": 113.509285,
        "latitude": 30.137065
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "沙湖镇",
       "center": {
        "longitude": 113.67514,
        "latitude": 30.169374
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "沔城回族镇",
       "center": {
        "longitude": 113.230882,
        "latitude": 30.19298
       },
       "level": "street",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "湖南省",
   "center": {
    "longitude": 112.9836,
    "latitude": 28.112743
   },
   "level": "province",
   "districts": [
    {
     "name": "常德市",
     "center": {
      "longitude": 111.698784,
      "latitude": 29.031654
     },
     "level": "city",
     "districts": [
      {
       "name": "安乡县",
       "center": {
        "longitude": 112.171131,
        "latitude": 29.411309
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鼎城区",
       "center": {
        "longitude": 111.680783,
        "latitude": 29.018593
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汉寿县",
       "center": {
        "longitude": 111.970514,
        "latitude": 28.906106
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "津市市",
       "center": {
        "longitude": 111.877499,
        "latitude": 29.60548
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "澧县",
       "center": {
        "longitude": 111.758702,
        "latitude": 29.633236
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临澧县",
       "center": {
        "longitude": 111.647517,
        "latitude": 29.440793
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石门县",
       "center": {
        "longitude": 111.380014,
        "latitude": 29.584292
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桃源县",
       "center": {
        "longitude": 111.488925,
        "latitude": 28.902503
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武陵区",
       "center": {
        "longitude": 111.683153,
        "latitude": 29.055163
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "郴州市",
     "center": {
      "longitude": 113.014984,
      "latitude": 25.770532
     },
     "level": "city",
     "districts": [
      {
       "name": "安仁县",
       "center": {
        "longitude": 113.26932,
        "latitude": 26.709061
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "北湖区",
       "center": {
        "longitude": 113.011035,
        "latitude": 25.784054
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桂阳县",
       "center": {
        "longitude": 112.734173,
        "latitude": 25.754172
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桂东县",
       "center": {
        "longitude": 113.944614,
        "latitude": 26.077616
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嘉禾县",
       "center": {
        "longitude": 112.36902,
        "latitude": 25.587519
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临武县",
       "center": {
        "longitude": 112.563456,
        "latitude": 25.27556
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汝城县",
       "center": {
        "longitude": 113.684727,
        "latitude": 25.532816
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "苏仙区",
       "center": {
        "longitude": 113.112105,
        "latitude": 25.797013
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永兴县",
       "center": {
        "longitude": 113.116527,
        "latitude": 26.12715
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜章县",
       "center": {
        "longitude": 112.948712,
        "latitude": 25.399938
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "资兴市",
       "center": {
        "longitude": 113.236146,
        "latitude": 25.976243
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "衡阳市",
     "center": {
      "longitude": 112.572018,
      "latitude": 26.893368
     },
     "level": "city",
     "districts": [
      {
       "name": "常宁市",
       "center": {
        "longitude": 112.399878,
        "latitude": 26.421956
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "衡南县",
       "center": {
        "longitude": 112.677877,
        "latitude": 26.738247
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "衡山县",
       "center": {
        "longitude": 112.868268,
        "latitude": 27.23029
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "衡阳县",
       "center": {
        "longitude": 112.370546,
        "latitude": 26.969577
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "衡东县",
       "center": {
        "longitude": 112.953168,
        "latitude": 27.08117
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "耒阳市",
       "center": {
        "longitude": 112.859759,
        "latitude": 26.422277
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南岳区",
       "center": {
        "longitude": 112.738604,
        "latitude": 27.232443
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "祁东县",
       "center": {
        "longitude": 112.090356,
        "latitude": 26.799896
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石鼓区",
       "center": {
        "longitude": 112.597992,
        "latitude": 26.943755
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雁峰区",
       "center": {
        "longitude": 112.6154,
        "latitude": 26.840602
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蒸湘区",
       "center": {
        "longitude": 112.567107,
        "latitude": 26.911854
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "珠晖区",
       "center": {
        "longitude": 112.620209,
        "latitude": 26.894765
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "娄底市",
     "center": {
      "longitude": 111.994482,
      "latitude": 27.70027
     },
     "level": "city",
     "districts": [
      {
       "name": "冷水江市",
       "center": {
        "longitude": 111.434984,
        "latitude": 27.686251
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涟源市",
       "center": {
        "longitude": 111.664329,
        "latitude": 27.692577
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "娄星区",
       "center": {
        "longitude": 112.001914,
        "latitude": 27.729863
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双峰县",
       "center": {
        "longitude": 112.175163,
        "latitude": 27.457172
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新化县",
       "center": {
        "longitude": 111.327412,
        "latitude": 27.726514
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "邵阳市",
     "center": {
      "longitude": 111.467674,
      "latitude": 27.23895
     },
     "level": "city",
     "districts": [
      {
       "name": "北塔区",
       "center": {
        "longitude": 111.452196,
        "latitude": 27.246489
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "城步苗族自治县",
       "center": {
        "longitude": 110.322239,
        "latitude": 26.390598
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大祥区",
       "center": {
        "longitude": 111.439091,
        "latitude": 27.221452
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洞口县",
       "center": {
        "longitude": 110.575846,
        "latitude": 27.06032
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隆回县",
       "center": {
        "longitude": 111.032437,
        "latitude": 27.113978
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邵东县",
       "center": {
        "longitude": 111.74427,
        "latitude": 27.258987
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邵阳县",
       "center": {
        "longitude": 111.273805,
        "latitude": 26.990637
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双清区",
       "center": {
        "longitude": 111.496341,
        "latitude": 27.232708
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绥宁县",
       "center": {
        "longitude": 110.155655,
        "latitude": 26.581954
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武冈市",
       "center": {
        "longitude": 110.631884,
        "latitude": 26.726599
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新邵县",
       "center": {
        "longitude": 111.458656,
        "latitude": 27.320917
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新宁县",
       "center": {
        "longitude": 110.856988,
        "latitude": 26.433367
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "湘西土家族苗族自治州",
     "center": {
      "longitude": 109.738906,
      "latitude": 28.31195
     },
     "level": "city",
     "districts": [
      {
       "name": "保靖县",
       "center": {
        "longitude": 109.660559,
        "latitude": 28.699878
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤凰县",
       "center": {
        "longitude": 109.581083,
        "latitude": 27.958081
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "古丈县",
       "center": {
        "longitude": 109.950728,
        "latitude": 28.616935
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "花垣县",
       "center": {
        "longitude": 109.482078,
        "latitude": 28.572029
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉首市",
       "center": {
        "longitude": 109.698015,
        "latitude": 28.262376
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泸溪县",
       "center": {
        "longitude": 110.21961,
        "latitude": 28.216641
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙山县",
       "center": {
        "longitude": 109.443938,
        "latitude": 29.457663
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永顺县",
       "center": {
        "longitude": 109.856933,
        "latitude": 28.979955
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "湘潭市",
     "center": {
      "longitude": 112.944026,
      "latitude": 27.829795
     },
     "level": "city",
     "districts": [
      {
       "name": "韶山市",
       "center": {
        "longitude": 112.52667,
        "latitude": 27.915008
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湘潭县",
       "center": {
        "longitude": 112.950831,
        "latitude": 27.778958
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湘乡市",
       "center": {
        "longitude": 112.550205,
        "latitude": 27.718549
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雨湖区",
       "center": {
        "longitude": 112.907162,
        "latitude": 27.856325
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岳塘区",
       "center": {
        "longitude": 112.969479,
        "latitude": 27.872028
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "永州市",
     "center": {
      "longitude": 111.613418,
      "latitude": 26.419641
     },
     "level": "city",
     "districts": [
      {
       "name": "道县",
       "center": {
        "longitude": 111.600795,
        "latitude": 25.526437
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东安县",
       "center": {
        "longitude": 111.316464,
        "latitude": 26.392183
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江华瑶族自治县",
       "center": {
        "longitude": 111.579535,
        "latitude": 25.185809
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江永县",
       "center": {
        "longitude": 111.343911,
        "latitude": 25.273539
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "冷水滩区",
       "center": {
        "longitude": 111.592343,
        "latitude": 26.46128
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蓝山县",
       "center": {
        "longitude": 112.196567,
        "latitude": 25.369725
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "零陵区",
       "center": {
        "longitude": 111.631109,
        "latitude": 26.221936
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁远县",
       "center": {
        "longitude": 111.945844,
        "latitude": 25.570888
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "祁阳县",
       "center": {
        "longitude": 111.840657,
        "latitude": 26.58012
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双牌县",
       "center": {
        "longitude": 111.659967,
        "latitude": 25.961909
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新田县",
       "center": {
        "longitude": 112.203287,
        "latitude": 25.904305
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "益阳市",
     "center": {
      "longitude": 112.355129,
      "latitude": 28.554349
     },
     "level": "city",
     "districts": [
      {
       "name": "安化县",
       "center": {
        "longitude": 111.212846,
        "latitude": 28.374107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "赫山区",
       "center": {
        "longitude": 112.374145,
        "latitude": 28.579494
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南县",
       "center": {
        "longitude": 112.396337,
        "latitude": 29.362275
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桃江县",
       "center": {
        "longitude": 112.155822,
        "latitude": 28.518084
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沅江市",
       "center": {
        "longitude": 112.355954,
        "latitude": 28.847045
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "资阳区",
       "center": {
        "longitude": 112.324272,
        "latitude": 28.59111
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "张家界市",
     "center": {
      "longitude": 110.479148,
      "latitude": 29.117013
     },
     "level": "city",
     "districts": [
      {
       "name": "慈利县",
       "center": {
        "longitude": 111.139775,
        "latitude": 29.429999
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桑植县",
       "center": {
        "longitude": 110.204652,
        "latitude": 29.414111
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武陵源区",
       "center": {
        "longitude": 110.550433,
        "latitude": 29.34573
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永定区",
       "center": {
        "longitude": 110.537138,
        "latitude": 29.119855
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "株洲市",
     "center": {
      "longitude": 113.133853,
      "latitude": 27.827986
     },
     "level": "city",
     "districts": [
      {
       "name": "茶陵县",
       "center": {
        "longitude": 113.539094,
        "latitude": 26.777521
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荷塘区",
       "center": {
        "longitude": 113.173487,
        "latitude": 27.855928
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "醴陵市",
       "center": {
        "longitude": 113.496999,
        "latitude": 27.646096
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芦淞区",
       "center": {
        "longitude": 113.152724,
        "latitude": 27.78507
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石峰区",
       "center": {
        "longitude": 113.117731,
        "latitude": 27.875445
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天元区",
       "center": {
        "longitude": 113.082216,
        "latitude": 27.826866
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "炎陵县",
       "center": {
        "longitude": 113.772655,
        "latitude": 26.489902
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "攸县",
       "center": {
        "longitude": 113.396385,
        "latitude": 27.014583
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "株洲县",
       "center": {
        "longitude": 113.144109,
        "latitude": 27.699232
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "岳阳市",
     "center": {
      "longitude": 113.12873,
      "latitude": 29.356803
     },
     "level": "city",
     "districts": [
      {
       "name": "华容县",
       "center": {
        "longitude": 112.540463,
        "latitude": 29.531057
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "君山区",
       "center": {
        "longitude": 113.006435,
        "latitude": 29.461106
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临湘市",
       "center": {
        "longitude": 113.450423,
        "latitude": 29.476849
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汨罗市",
       "center": {
        "longitude": 113.067251,
        "latitude": 28.806881
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平江县",
       "center": {
        "longitude": 113.581234,
        "latitude": 28.701868
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湘阴县",
       "center": {
        "longitude": 112.909426,
        "latitude": 28.689104
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云溪区",
       "center": {
        "longitude": 113.272312,
        "latitude": 29.472745
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岳阳楼区",
       "center": {
        "longitude": 113.129684,
        "latitude": 29.371814
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岳阳县",
       "center": {
        "longitude": 113.116418,
        "latitude": 29.144066
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "长沙市",
     "center": {
      "longitude": 112.938884,
      "latitude": 28.22808
     },
     "level": "city",
     "districts": [
      {
       "name": "芙蓉区",
       "center": {
        "longitude": 113.032539,
        "latitude": 28.185389
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开福区",
       "center": {
        "longitude": 112.985884,
        "latitude": 28.256298
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浏阳市",
       "center": {
        "longitude": 113.643076,
        "latitude": 28.162833
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁乡市",
       "center": {
        "longitude": 112.551885,
        "latitude": 28.277483
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天心区",
       "center": {
        "longitude": 112.989897,
        "latitude": 28.114526
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "望城区",
       "center": {
        "longitude": 112.831176,
        "latitude": 28.353434
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雨花区",
       "center": {
        "longitude": 113.03826,
        "latitude": 28.135722
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岳麓区",
       "center": {
        "longitude": 112.93132,
        "latitude": 28.234538
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长沙县",
       "center": {
        "longitude": 113.081097,
        "latitude": 28.246918
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "怀化市",
     "center": {
      "longitude": 110.001923,
      "latitude": 27.569517
     },
     "level": "city",
     "districts": [
      {
       "name": "辰溪县",
       "center": {
        "longitude": 110.183917,
        "latitude": 28.006336
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洪江市",
       "center": {
        "longitude": 109.836669,
        "latitude": 27.208609
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鹤城区",
       "center": {
        "longitude": 110.040315,
        "latitude": 27.578926
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "会同县",
       "center": {
        "longitude": 109.735661,
        "latitude": 26.887238
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "靖州苗族侗族自治县",
       "center": {
        "longitude": 109.696273,
        "latitude": 26.575107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麻阳苗族自治县",
       "center": {
        "longitude": 109.81701,
        "latitude": 27.857569
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通道侗族自治县",
       "center": {
        "longitude": 109.784412,
        "latitude": 26.158054
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新晃侗族自治县",
       "center": {
        "longitude": 109.174932,
        "latitude": 27.352673
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "溆浦县",
       "center": {
        "longitude": 110.594879,
        "latitude": 27.908267
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沅陵县",
       "center": {
        "longitude": 110.393844,
        "latitude": 28.452686
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芷江侗族自治县",
       "center": {
        "longitude": 109.684629,
        "latitude": 27.443499
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "中方县",
       "center": {
        "longitude": 109.944711,
        "latitude": 27.440138
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "黑龙江省",
   "center": {
    "longitude": 126.661665,
    "latitude": 45.742366
   },
   "level": "province",
   "districts": [
    {
     "name": "大庆市",
     "center": {
      "longitude": 125.103784,
      "latitude": 46.589309
     },
     "level": "city",
     "districts": [
      {
       "name": "大同区",
       "center": {
        "longitude": 124.812364,
        "latitude": 46.039827
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "杜尔伯特蒙古族自治县",
       "center": {
        "longitude": 124.442572,
        "latitude": 46.862817
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红岗区",
       "center": {
        "longitude": 124.891039,
        "latitude": 46.398418
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "林甸县",
       "center": {
        "longitude": 124.863603,
        "latitude": 47.171717
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙凤区",
       "center": {
        "longitude": 125.135326,
        "latitude": 46.562247
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "萨尔图区",
       "center": {
        "longitude": 125.135591,
        "latitude": 46.629092
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "让胡路区",
       "center": {
        "longitude": 124.870596,
        "latitude": 46.652357
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肇州县",
       "center": {
        "longitude": 125.268643,
        "latitude": 45.699066
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肇源县",
       "center": {
        "longitude": 125.078223,
        "latitude": 45.51932
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "大兴安岭地区",
     "center": {
      "longitude": 124.711526,
      "latitude": 52.335262
     },
     "level": "city",
     "districts": [
      {
       "name": "呼玛县",
       "center": {
        "longitude": 126.652396,
        "latitude": 51.726091
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "加格达奇区",
       "center": {
        "longitude": 124.139595,
        "latitude": 50.408735
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "漠河县",
       "center": {
        "longitude": 122.538591,
        "latitude": 52.972272
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "塔河县",
       "center": {
        "longitude": 124.709996,
        "latitude": 52.334456
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "哈尔滨市",
     "center": {
      "longitude": 126.534967,
      "latitude": 45.803775
     },
     "level": "city",
     "districts": [
      {
       "name": "阿城区",
       "center": {
        "longitude": 126.958098,
        "latitude": 45.548669
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巴彦县",
       "center": {
        "longitude": 127.403781,
        "latitude": 46.086549
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宾县",
       "center": {
        "longitude": 127.466634,
        "latitude": 45.745917
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "道里区",
       "center": {
        "longitude": 126.616973,
        "latitude": 45.75577
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "道外区",
       "center": {
        "longitude": 126.64939,
        "latitude": 45.792057
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "方正县",
       "center": {
        "longitude": 128.829536,
        "latitude": 45.851694
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "呼兰区",
       "center": {
        "longitude": 126.587905,
        "latitude": 45.889457
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "木兰县",
       "center": {
        "longitude": 128.043466,
        "latitude": 45.950582
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南岗区",
       "center": {
        "longitude": 126.668784,
        "latitude": 45.760174
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平房区",
       "center": {
        "longitude": 126.637611,
        "latitude": 45.597911
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尚志市",
       "center": {
        "longitude": 128.009894,
        "latitude": 45.209586
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双城区",
       "center": {
        "longitude": 126.312624,
        "latitude": 45.383218
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "松北区",
       "center": {
        "longitude": 126.516914,
        "latitude": 45.794504
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通河县",
       "center": {
        "longitude": 128.746124,
        "latitude": 45.990205
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五常市",
       "center": {
        "longitude": 127.167618,
        "latitude": 44.931991
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "香坊区",
       "center": {
        "longitude": 126.662593,
        "latitude": 45.707716
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "延寿县",
       "center": {
        "longitude": 128.331643,
        "latitude": 45.451897
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "依兰县",
       "center": {
        "longitude": 129.567877,
        "latitude": 46.325419
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "鹤岗市",
     "center": {
      "longitude": 130.297943,
      "latitude": 47.350189
     },
     "level": "city",
     "districts": [
      {
       "name": "东山区",
       "center": {
        "longitude": 130.317002,
        "latitude": 47.338537
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "工农区",
       "center": {
        "longitude": 130.274684,
        "latitude": 47.31878
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "萝北县",
       "center": {
        "longitude": 130.85155,
        "latitude": 47.576444
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南山区",
       "center": {
        "longitude": 130.286788,
        "latitude": 47.315174
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绥滨县",
       "center": {
        "longitude": 131.852759,
        "latitude": 47.289115
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "向阳区",
       "center": {
        "longitude": 130.294235,
        "latitude": 47.342468
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴山区",
       "center": {
        "longitude": 130.303481,
        "latitude": 47.357702
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴安区",
       "center": {
        "longitude": 130.239245,
        "latitude": 47.252849
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "黑河市",
     "center": {
      "longitude": 127.528293,
      "latitude": 50.245129
     },
     "level": "city",
     "districts": [
      {
       "name": "爱辉区",
       "center": {
        "longitude": 127.50045,
        "latitude": 50.252105
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "北安市",
       "center": {
        "longitude": 126.490864,
        "latitude": 48.241365
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嫩江县",
       "center": {
        "longitude": 125.221192,
        "latitude": 49.185766
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "孙吴县",
       "center": {
        "longitude": 127.336303,
        "latitude": 49.425647
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五大连池市",
       "center": {
        "longitude": 126.205516,
        "latitude": 48.517257
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "逊克县",
       "center": {
        "longitude": 128.478749,
        "latitude": 49.564252
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "鸡西市",
     "center": {
      "longitude": 130.969333,
      "latitude": 45.295075
     },
     "level": "city",
     "districts": [
      {
       "name": "城子河区",
       "center": {
        "longitude": 131.011304,
        "latitude": 45.33697
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "滴道区",
       "center": {
        "longitude": 130.843613,
        "latitude": 45.348763
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "恒山区",
       "center": {
        "longitude": 130.904963,
        "latitude": 45.210668
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "虎林市",
       "center": {
        "longitude": 132.93721,
        "latitude": 45.762685
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鸡冠区",
       "center": {
        "longitude": 130.981185,
        "latitude": 45.304355
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鸡东县",
       "center": {
        "longitude": 131.124079,
        "latitude": 45.260412
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梨树区",
       "center": {
        "longitude": 130.69699,
        "latitude": 45.092046
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麻山区",
       "center": {
        "longitude": 130.478187,
        "latitude": 45.212088
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "密山市",
       "center": {
        "longitude": 131.846635,
        "latitude": 45.529774
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "佳木斯市",
     "center": {
      "longitude": 130.318878,
      "latitude": 46.799777
     },
     "level": "city",
     "districts": [
      {
       "name": "东风区",
       "center": {
        "longitude": 130.403664,
        "latitude": 46.822571
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富锦市",
       "center": {
        "longitude": 132.037686,
        "latitude": 47.250107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "抚远市",
       "center": {
        "longitude": 134.307884,
        "latitude": 48.364687
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桦川县",
       "center": {
        "longitude": 130.71908,
        "latitude": 47.023001
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桦南县",
       "center": {
        "longitude": 130.553343,
        "latitude": 46.239184
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郊区",
       "center": {
        "longitude": 130.327194,
        "latitude": 46.810085
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "前进区",
       "center": {
        "longitude": 130.375062,
        "latitude": 46.814102
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汤原县",
       "center": {
        "longitude": 129.905072,
        "latitude": 46.730706
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "同江市",
       "center": {
        "longitude": 132.510919,
        "latitude": 47.642707
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "向阳区",
       "center": {
        "longitude": 130.365346,
        "latitude": 46.80779
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "牡丹江市",
     "center": {
      "longitude": 129.633168,
      "latitude": 44.551653
     },
     "level": "city",
     "districts": [
      {
       "name": "爱民区",
       "center": {
        "longitude": 129.591537,
        "latitude": 44.596042
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东安区",
       "center": {
        "longitude": 129.626641,
        "latitude": 44.58136
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东宁市",
       "center": {
        "longitude": 131.122915,
        "latitude": 44.087585
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海林市",
       "center": {
        "longitude": 129.380481,
        "latitude": 44.594213
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "林口县",
       "center": {
        "longitude": 130.284033,
        "latitude": 45.278046
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "穆棱市",
       "center": {
        "longitude": 130.524436,
        "latitude": 44.918813
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁安市",
       "center": {
        "longitude": 129.482851,
        "latitude": 44.34072
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绥芬河市",
       "center": {
        "longitude": 131.152545,
        "latitude": 44.412308
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西安区",
       "center": {
        "longitude": 129.616058,
        "latitude": 44.577625
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳明区",
       "center": {
        "longitude": 129.635615,
        "latitude": 44.596104
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "齐齐哈尔市",
     "center": {
      "longitude": 123.918186,
      "latitude": 47.354348
     },
     "level": "city",
     "districts": [
      {
       "name": "昂昂溪区",
       "center": {
        "longitude": 123.8224,
        "latitude": 47.15516
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "拜泉县",
       "center": {
        "longitude": 126.100213,
        "latitude": 47.595851
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富裕县",
       "center": {
        "longitude": 124.473793,
        "latitude": 47.774347
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富拉尔基区",
       "center": {
        "longitude": 123.629189,
        "latitude": 47.208843
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "甘南县",
       "center": {
        "longitude": 123.507429,
        "latitude": 47.922405
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建华区",
       "center": {
        "longitude": 123.955464,
        "latitude": 47.354364
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "克山县",
       "center": {
        "longitude": 125.875705,
        "latitude": 48.037031
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "克东县",
       "center": {
        "longitude": 126.24872,
        "latitude": 48.04206
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙江县",
       "center": {
        "longitude": 123.205323,
        "latitude": 47.338665
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙沙区",
       "center": {
        "longitude": 123.957531,
        "latitude": 47.317308
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梅里斯达斡尔族区",
       "center": {
        "longitude": 123.75291,
        "latitude": 47.309537
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "碾子山区",
       "center": {
        "longitude": 122.887775,
        "latitude": 47.516872
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "讷河市",
       "center": {
        "longitude": 124.88287,
        "latitude": 48.466592
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泰来县",
       "center": {
        "longitude": 123.416631,
        "latitude": 46.393694
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁锋区",
       "center": {
        "longitude": 123.978293,
        "latitude": 47.340517
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "依安县",
       "center": {
        "longitude": 125.306278,
        "latitude": 47.893548
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "七台河市",
     "center": {
      "longitude": 131.003082,
      "latitude": 45.771396
     },
     "level": "city",
     "districts": [
      {
       "name": "勃利县",
       "center": {
        "longitude": 130.59217,
        "latitude": 45.755063
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "茄子河区",
       "center": {
        "longitude": 131.068075,
        "latitude": 45.785215
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桃山区",
       "center": {
        "longitude": 131.020202,
        "latitude": 45.765705
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新兴区",
       "center": {
        "longitude": 130.932143,
        "latitude": 45.81593
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "绥化市",
     "center": {
      "longitude": 126.968887,
      "latitude": 46.653845
     },
     "level": "city",
     "districts": [
      {
       "name": "安达市",
       "center": {
        "longitude": 125.346156,
        "latitude": 46.419633
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "北林区",
       "center": {
        "longitude": 126.985504,
        "latitude": 46.6375
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海伦市",
       "center": {
        "longitude": 126.930106,
        "latitude": 47.45117
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兰西县",
       "center": {
        "longitude": 126.288117,
        "latitude": 46.25245
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "明水县",
       "center": {
        "longitude": 125.906301,
        "latitude": 47.173426
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青冈县",
       "center": {
        "longitude": 126.099195,
        "latitude": 46.70391
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "庆安县",
       "center": {
        "longitude": 127.507824,
        "latitude": 46.880102
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绥棱县",
       "center": {
        "longitude": 127.114832,
        "latitude": 47.236015
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "望奎县",
       "center": {
        "longitude": 126.486075,
        "latitude": 46.832719
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肇东市",
       "center": {
        "longitude": 125.961814,
        "latitude": 46.051126
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "双鸭山市",
     "center": {
      "longitude": 131.141195,
      "latitude": 46.676418
     },
     "level": "city",
     "districts": [
      {
       "name": "宝山区",
       "center": {
        "longitude": 131.401589,
        "latitude": 46.577167
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宝清县",
       "center": {
        "longitude": 132.196853,
        "latitude": 46.327457
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "集贤县",
       "center": {
        "longitude": 131.141311,
        "latitude": 46.728412
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尖山区",
       "center": {
        "longitude": 131.158415,
        "latitude": 46.64635
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岭东区",
       "center": {
        "longitude": 131.164723,
        "latitude": 46.592721
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "饶河县",
       "center": {
        "longitude": 134.013872,
        "latitude": 46.798163
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "四方台区",
       "center": {
        "longitude": 131.337592,
        "latitude": 46.597264
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "友谊县",
       "center": {
        "longitude": 131.808063,
        "latitude": 46.767299
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "伊春市",
     "center": {
      "longitude": 128.841125,
      "latitude": 47.727535
     },
     "level": "city",
     "districts": [
      {
       "name": "翠峦区",
       "center": {
        "longitude": 128.669754,
        "latitude": 47.726394
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "带岭区",
       "center": {
        "longitude": 129.020888,
        "latitude": 47.028379
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红星区",
       "center": {
        "longitude": 129.390983,
        "latitude": 48.239431
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嘉荫县",
       "center": {
        "longitude": 130.403134,
        "latitude": 48.888972
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金山屯区",
       "center": {
        "longitude": 129.429117,
        "latitude": 47.413074
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "美溪区",
       "center": {
        "longitude": 129.129314,
        "latitude": 47.63509
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南岔区",
       "center": {
        "longitude": 129.283467,
        "latitude": 47.138034
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上甘岭区",
       "center": {
        "longitude": 129.02426,
        "latitude": 47.974707
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汤旺河区",
       "center": {
        "longitude": 129.571108,
        "latitude": 48.454651
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁力市",
       "center": {
        "longitude": 128.032424,
        "latitude": 46.986633
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌马河区",
       "center": {
        "longitude": 128.799477,
        "latitude": 47.727687
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌伊岭区",
       "center": {
        "longitude": 129.43792,
        "latitude": 48.590322
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五营区",
       "center": {
        "longitude": 129.245343,
        "latitude": 48.10791
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西林区",
       "center": {
        "longitude": 129.312851,
        "latitude": 47.480735
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伊春区",
       "center": {
        "longitude": 128.907257,
        "latitude": 47.728237
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新青区",
       "center": {
        "longitude": 129.533599,
        "latitude": 48.290455
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "友好区",
       "center": {
        "longitude": 128.836291,
        "latitude": 47.841032
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "江苏省",
   "center": {
    "longitude": 118.762765,
    "latitude": 32.060875
   },
   "level": "province",
   "districts": [
    {
     "name": "常州市",
     "center": {
      "longitude": 119.974061,
      "latitude": 31.811226
     },
     "level": "city",
     "districts": [
      {
       "name": "金坛区",
       "center": {
        "longitude": 119.597811,
        "latitude": 31.723219
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "溧阳市",
       "center": {
        "longitude": 119.48421,
        "latitude": 31.416911
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天宁区",
       "center": {
        "longitude": 119.999219,
        "latitude": 31.792787
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武进区",
       "center": {
        "longitude": 119.942437,
        "latitude": 31.701187
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新北区",
       "center": {
        "longitude": 119.971697,
        "latitude": 31.830427
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "钟楼区",
       "center": {
        "longitude": 119.902369,
        "latitude": 31.802089
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "淮安市",
     "center": {
      "longitude": 119.113185,
      "latitude": 33.551052
     },
     "level": "city",
     "districts": [
      {
       "name": "洪泽区",
       "center": {
        "longitude": 118.873241,
        "latitude": 33.294214
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淮安区",
       "center": {
        "longitude": 119.141099,
        "latitude": 33.502868
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淮阴区",
       "center": {
        "longitude": 119.034725,
        "latitude": 33.631892
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金湖县",
       "center": {
        "longitude": 119.020584,
        "latitude": 33.025433
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涟水县",
       "center": {
        "longitude": 119.260227,
        "latitude": 33.781331
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清江浦区",
       "center": {
        "longitude": 119.026718,
        "latitude": 33.552627
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盱眙县",
       "center": {
        "longitude": 118.54436,
        "latitude": 33.011971
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "连云港市",
     "center": {
      "longitude": 119.221611,
      "latitude": 34.596653
     },
     "level": "city",
     "districts": [
      {
       "name": "东海县",
       "center": {
        "longitude": 118.752842,
        "latitude": 34.542308
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "赣榆区",
       "center": {
        "longitude": 119.17333,
        "latitude": 34.841348
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灌云县",
       "center": {
        "longitude": 119.239381,
        "latitude": 34.284381
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灌南县",
       "center": {
        "longitude": 119.315651,
        "latitude": 34.087134
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海州区",
       "center": {
        "longitude": 119.163509,
        "latitude": 34.572274
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "连云区",
       "center": {
        "longitude": 119.338788,
        "latitude": 34.760249
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "南京市",
     "center": {
      "longitude": 118.796682,
      "latitude": 32.05957
     },
     "level": "city",
     "districts": [
      {
       "name": "高淳区",
       "center": {
        "longitude": 118.89222,
        "latitude": 31.327586
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鼓楼区",
       "center": {
        "longitude": 118.770182,
        "latitude": 32.066601
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江宁区",
       "center": {
        "longitude": 118.840015,
        "latitude": 31.952612
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建邺区",
       "center": {
        "longitude": 118.731793,
        "latitude": 32.003731
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "溧水区",
       "center": {
        "longitude": 119.028288,
        "latitude": 31.651099
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "六合区",
       "center": {
        "longitude": 118.822132,
        "latitude": 32.323584
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浦口区",
       "center": {
        "longitude": 118.628003,
        "latitude": 32.058903
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "栖霞区",
       "center": {
        "longitude": 118.909153,
        "latitude": 32.096388
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秦淮区",
       "center": {
        "longitude": 118.79476,
        "latitude": 32.039113
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玄武区",
       "center": {
        "longitude": 118.797757,
        "latitude": 32.048498
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雨花台区",
       "center": {
        "longitude": 118.779051,
        "latitude": 31.99126
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "南通市",
     "center": {
      "longitude": 120.894676,
      "latitude": 31.981143
     },
     "level": "city",
     "districts": [
      {
       "name": "崇川区",
       "center": {
        "longitude": 120.857434,
        "latitude": 32.009875
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "港闸区",
       "center": {
        "longitude": 120.818526,
        "latitude": 32.032441
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海安县",
       "center": {
        "longitude": 120.467343,
        "latitude": 32.533572
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海门市",
       "center": {
        "longitude": 121.18181,
        "latitude": 31.869483
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "启东市",
       "center": {
        "longitude": 121.655432,
        "latitude": 31.793278
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "如皋市",
       "center": {
        "longitude": 120.573803,
        "latitude": 32.371562
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "如东县",
       "center": {
        "longitude": 121.185201,
        "latitude": 32.331765
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通州区",
       "center": {
        "longitude": 121.073828,
        "latitude": 32.06568
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "苏州市",
     "center": {
      "longitude": 120.585728,
      "latitude": 31.2974
     },
     "level": "city",
     "districts": [
      {
       "name": "常熟市",
       "center": {
        "longitude": 120.752481,
        "latitude": 31.654375
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "姑苏区",
       "center": {
        "longitude": 120.617369,
        "latitude": 31.33565
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "虎丘区",
       "center": {
        "longitude": 120.434238,
        "latitude": 31.329601
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昆山市",
       "center": {
        "longitude": 120.980736,
        "latitude": 31.385597
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太仓市",
       "center": {
        "longitude": 121.13055,
        "latitude": 31.457735
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吴江区",
       "center": {
        "longitude": 120.645157,
        "latitude": 31.138677
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吴中区",
       "center": {
        "longitude": 120.632308,
        "latitude": 31.263183
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "相城区",
       "center": {
        "longitude": 120.642626,
        "latitude": 31.369089
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "张家港市",
       "center": {
        "longitude": 120.555982,
        "latitude": 31.875571
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "宿迁市",
     "center": {
      "longitude": 118.275198,
      "latitude": 33.963232
     },
     "level": "city",
     "districts": [
      {
       "name": "沭阳县",
       "center": {
        "longitude": 118.804784,
        "latitude": 34.111022
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泗洪县",
       "center": {
        "longitude": 118.223591,
        "latitude": 33.476051
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泗阳县",
       "center": {
        "longitude": 118.703424,
        "latitude": 33.722478
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宿豫区",
       "center": {
        "longitude": 118.330781,
        "latitude": 33.946822
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宿城区",
       "center": {
        "longitude": 118.242533,
        "latitude": 33.963029
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "泰州市",
     "center": {
      "longitude": 119.922933,
      "latitude": 32.455536
     },
     "level": "city",
     "districts": [
      {
       "name": "高港区",
       "center": {
        "longitude": 119.881717,
        "latitude": 32.318821
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海陵区",
       "center": {
        "longitude": 119.919424,
        "latitude": 32.491016
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "姜堰区",
       "center": {
        "longitude": 120.127934,
        "latitude": 32.509155
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "靖江市",
       "center": {
        "longitude": 120.277138,
        "latitude": 31.982751
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泰兴市",
       "center": {
        "longitude": 120.051743,
        "latitude": 32.171853
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴化市",
       "center": {
        "longitude": 119.852541,
        "latitude": 32.910459
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "无锡市",
     "center": {
      "longitude": 120.31191,
      "latitude": 31.491169
     },
     "level": "city",
     "districts": [
      {
       "name": "滨湖区",
       "center": {
        "longitude": 120.283811,
        "latitude": 31.527276
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "惠山区",
       "center": {
        "longitude": 120.298433,
        "latitude": 31.680335
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江阴市",
       "center": {
        "longitude": 120.286129,
        "latitude": 31.921345
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梁溪区",
       "center": {
        "longitude": 120.303108,
        "latitude": 31.566155
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "锡山区",
       "center": {
        "longitude": 120.357858,
        "latitude": 31.589715
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新吴区",
       "center": {
        "longitude": 120.352782,
        "latitude": 31.550966
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜兴市",
       "center": {
        "longitude": 119.823308,
        "latitude": 31.340637
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "徐州市",
     "center": {
      "longitude": 117.284124,
      "latitude": 34.205768
     },
     "level": "city",
     "districts": [
      {
       "name": "丰县",
       "center": {
        "longitude": 116.59539,
        "latitude": 34.693906
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鼓楼区",
       "center": {
        "longitude": 117.185576,
        "latitude": 34.288646
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贾汪区",
       "center": {
        "longitude": 117.464958,
        "latitude": 34.436936
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沛县",
       "center": {
        "longitude": 116.936353,
        "latitude": 34.760761
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邳州市",
       "center": {
        "longitude": 118.012531,
        "latitude": 34.338888
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泉山区",
       "center": {
        "longitude": 117.194469,
        "latitude": 34.225522
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "睢宁县",
       "center": {
        "longitude": 117.941563,
        "latitude": 33.912597
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铜山区",
       "center": {
        "longitude": 117.169461,
        "latitude": 34.180779
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新沂市",
       "center": {
        "longitude": 118.354537,
        "latitude": 34.36958
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云龙区",
       "center": {
        "longitude": 117.251076,
        "latitude": 34.253164
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "盐城市",
     "center": {
      "longitude": 120.163107,
      "latitude": 33.347708
     },
     "level": "city",
     "districts": [
      {
       "name": "滨海县",
       "center": {
        "longitude": 119.82083,
        "latitude": 33.990334
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大丰区",
       "center": {
        "longitude": 120.50085,
        "latitude": 33.200333
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东台市",
       "center": {
        "longitude": 120.320328,
        "latitude": 32.868426
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阜宁县",
       "center": {
        "longitude": 119.802527,
        "latitude": 33.759325
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建湖县",
       "center": {
        "longitude": 119.7886,
        "latitude": 33.439067
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "射阳县",
       "center": {
        "longitude": 120.229986,
        "latitude": 33.758361
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "亭湖区",
       "center": {
        "longitude": 120.197358,
        "latitude": 33.390536
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "响水县",
       "center": {
        "longitude": 119.578364,
        "latitude": 34.199479
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盐都区",
       "center": {
        "longitude": 120.153712,
        "latitude": 33.338283
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "扬州市",
     "center": {
      "longitude": 119.412939,
      "latitude": 32.394209
     },
     "level": "city",
     "districts": [
      {
       "name": "宝应县",
       "center": {
        "longitude": 119.360729,
        "latitude": 33.240391
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高邮市",
       "center": {
        "longitude": 119.459161,
        "latitude": 32.781659
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广陵区",
       "center": {
        "longitude": 119.431849,
        "latitude": 32.39472
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邗江区",
       "center": {
        "longitude": 119.397994,
        "latitude": 32.377655
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江都区",
       "center": {
        "longitude": 119.569989,
        "latitude": 32.434672
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仪征市",
       "center": {
        "longitude": 119.184766,
        "latitude": 32.272258
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "镇江市",
     "center": {
      "longitude": 119.425836,
      "latitude": 32.187849
     },
     "level": "city",
     "districts": [
      {
       "name": "丹徒区",
       "center": {
        "longitude": 119.433853,
        "latitude": 32.131962
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丹阳市",
       "center": {
        "longitude": 119.606439,
        "latitude": 32.010214
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "京口区",
       "center": {
        "longitude": 119.47016,
        "latitude": 32.19828
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "句容市",
       "center": {
        "longitude": 119.168695,
        "latitude": 31.944998
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "润州区",
       "center": {
        "longitude": 119.411959,
        "latitude": 32.195264
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "扬中市",
       "center": {
        "longitude": 119.797634,
        "latitude": 32.23483
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "江西省",
   "center": {
    "longitude": 115.81635,
    "latitude": 28.63666
   },
   "level": "province",
   "districts": [
    {
     "name": "抚州市",
     "center": {
      "longitude": 116.358181,
      "latitude": 27.949217
     },
     "level": "city",
     "districts": [
      {
       "name": "崇仁县",
       "center": {
        "longitude": 116.07626,
        "latitude": 27.754466
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东乡区",
       "center": {
        "longitude": 116.603559,
        "latitude": 28.247696
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广昌县",
       "center": {
        "longitude": 116.335686,
        "latitude": 26.843684
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金溪县",
       "center": {
        "longitude": 116.755058,
        "latitude": 27.918959
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黎川县",
       "center": {
        "longitude": 116.907681,
        "latitude": 27.282333
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乐安县",
       "center": {
        "longitude": 115.83048,
        "latitude": 27.428765
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临川区",
       "center": {
        "longitude": 116.312166,
        "latitude": 27.934572
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南城县",
       "center": {
        "longitude": 116.63704,
        "latitude": 27.569678
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南丰县",
       "center": {
        "longitude": 116.525725,
        "latitude": 27.218444
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜黄县",
       "center": {
        "longitude": 116.236201,
        "latitude": 27.554886
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "资溪县",
       "center": {
        "longitude": 117.060263,
        "latitude": 27.706101
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "赣州市",
     "center": {
      "longitude": 114.933546,
      "latitude": 25.830694
     },
     "level": "city",
     "districts": [
      {
       "name": "安远县",
       "center": {
        "longitude": 115.393922,
        "latitude": 25.136927
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "崇义县",
       "center": {
        "longitude": 114.308267,
        "latitude": 25.681784
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大余县",
       "center": {
        "longitude": 114.362112,
        "latitude": 25.401313
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "定南县",
       "center": {
        "longitude": 115.027845,
        "latitude": 24.78441
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "赣县区",
       "center": {
        "longitude": 115.011561,
        "latitude": 25.86069
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "会昌县",
       "center": {
        "longitude": 115.786056,
        "latitude": 25.600272
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙南县",
       "center": {
        "longitude": 114.789873,
        "latitude": 24.911069
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南康区",
       "center": {
        "longitude": 114.765412,
        "latitude": 25.66145
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁都县",
       "center": {
        "longitude": 116.009472,
        "latitude": 26.470116
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "全南县",
       "center": {
        "longitude": 114.530125,
        "latitude": 24.742403
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "瑞金市",
       "center": {
        "longitude": 116.027134,
        "latitude": 25.885555
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上犹县",
       "center": {
        "longitude": 114.551138,
        "latitude": 25.785172
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石城县",
       "center": {
        "longitude": 116.346995,
        "latitude": 26.314775
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "信丰县",
       "center": {
        "longitude": 114.922922,
        "latitude": 25.386379
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴国县",
       "center": {
        "longitude": 115.363189,
        "latitude": 26.337937
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "寻乌县",
       "center": {
        "longitude": 115.637933,
        "latitude": 24.969167
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "于都县",
       "center": {
        "longitude": 115.415508,
        "latitude": 25.952068
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "章贡区",
       "center": {
        "longitude": 114.921171,
        "latitude": 25.817816
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "吉安市",
     "center": {
      "longitude": 114.966567,
      "latitude": 27.090763
     },
     "level": "city",
     "districts": [
      {
       "name": "安福县",
       "center": {
        "longitude": 114.619893,
        "latitude": 27.392873
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉州区",
       "center": {
        "longitude": 114.994763,
        "latitude": 27.143801
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉安县",
       "center": {
        "longitude": 114.907875,
        "latitude": 27.039787
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉水县",
       "center": {
        "longitude": 115.135507,
        "latitude": 27.229632
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "井冈山市",
       "center": {
        "longitude": 114.289228,
        "latitude": 26.748081
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青原区",
       "center": {
        "longitude": 115.014811,
        "latitude": 27.081977
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泰和县",
       "center": {
        "longitude": 114.92299,
        "latitude": 26.801628
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "遂川县",
       "center": {
        "longitude": 114.520537,
        "latitude": 26.313737
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万安县",
       "center": {
        "longitude": 114.759364,
        "latitude": 26.456553
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "峡江县",
       "center": {
        "longitude": 115.316566,
        "latitude": 27.582901
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新干县",
       "center": {
        "longitude": 115.387052,
        "latitude": 27.740191
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永新县",
       "center": {
        "longitude": 114.243072,
        "latitude": 26.944962
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永丰县",
       "center": {
        "longitude": 115.421344,
        "latitude": 27.316939
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "九江市",
     "center": {
      "longitude": 115.952914,
      "latitude": 29.662117
     },
     "level": "city",
     "districts": [
      {
       "name": "德安县",
       "center": {
        "longitude": 115.767447,
        "latitude": 29.298696
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "都昌县",
       "center": {
        "longitude": 116.203979,
        "latitude": 29.273239
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "共青城市",
       "center": {
        "longitude": 115.808844,
        "latitude": 29.248316
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湖口县",
       "center": {
        "longitude": 116.251947,
        "latitude": 29.731101
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柴桑区",
       "center": {
        "longitude": 115.911323,
        "latitude": 29.608431
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "濂溪区",
       "center": {
        "longitude": 115.992842,
        "latitude": 29.668064
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "庐山市",
       "center": {
        "longitude": 116.04506,
        "latitude": 29.448128
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "彭泽县",
       "center": {
        "longitude": 116.56438,
        "latitude": 29.876991
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "瑞昌市",
       "center": {
        "longitude": 115.681335,
        "latitude": 29.675834
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武宁县",
       "center": {
        "longitude": 115.092757,
        "latitude": 29.246591
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浔阳区",
       "center": {
        "longitude": 115.990301,
        "latitude": 29.727593
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "修水县",
       "center": {
        "longitude": 114.546836,
        "latitude": 29.025726
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永修县",
       "center": {
        "longitude": 115.831956,
        "latitude": 29.011871
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "景德镇市",
     "center": {
      "longitude": 117.178222,
      "latitude": 29.268945
     },
     "level": "city",
     "districts": [
      {
       "name": "昌江区",
       "center": {
        "longitude": 117.18363,
        "latitude": 29.273565
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浮梁县",
       "center": {
        "longitude": 117.215066,
        "latitude": 29.352253
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乐平市",
       "center": {
        "longitude": 117.151796,
        "latitude": 28.97844
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "珠山区",
       "center": {
        "longitude": 117.202919,
        "latitude": 29.299938
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "南昌市",
     "center": {
      "longitude": 115.858198,
      "latitude": 28.682892
     },
     "level": "city",
     "districts": [
      {
       "name": "安义县",
       "center": {
        "longitude": 115.548658,
        "latitude": 28.846
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东湖区",
       "center": {
        "longitude": 115.903526,
        "latitude": 28.698731
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "进贤县",
       "center": {
        "longitude": 116.241288,
        "latitude": 28.377343
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南昌县",
       "center": {
        "longitude": 115.933742,
        "latitude": 28.558296
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青山湖区",
       "center": {
        "longitude": 115.962144,
        "latitude": 28.682984
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青云谱区",
       "center": {
        "longitude": 115.925749,
        "latitude": 28.621169
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湾里区",
       "center": {
        "longitude": 115.730847,
        "latitude": 28.714796
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西湖区",
       "center": {
        "longitude": 115.877233,
        "latitude": 28.657595
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新建区",
       "center": {
        "longitude": 115.815277,
        "latitude": 28.692864
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "萍乡市",
     "center": {
      "longitude": 113.887083,
      "latitude": 27.658373
     },
     "level": "city",
     "districts": [
      {
       "name": "安源区",
       "center": {
        "longitude": 113.870704,
        "latitude": 27.61511
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莲花县",
       "center": {
        "longitude": 113.961488,
        "latitude": 27.127664
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芦溪县",
       "center": {
        "longitude": 114.029827,
        "latitude": 27.630806
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上栗县",
       "center": {
        "longitude": 113.795311,
        "latitude": 27.880301
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湘东区",
       "center": {
        "longitude": 113.733047,
        "latitude": 27.640075
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "上饶市",
     "center": {
      "longitude": 117.943433,
      "latitude": 28.454863
     },
     "level": "city",
     "districts": [
      {
       "name": "德兴市",
       "center": {
        "longitude": 117.578713,
        "latitude": 28.946464
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广丰区",
       "center": {
        "longitude": 118.19124,
        "latitude": 28.436285
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "横峰县",
       "center": {
        "longitude": 117.596452,
        "latitude": 28.407117
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄱阳县",
       "center": {
        "longitude": 116.70359,
        "latitude": 29.004847
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铅山县",
       "center": {
        "longitude": 117.709659,
        "latitude": 28.315664
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广信区",
       "center": {
        "longitude": 117.907849,
        "latitude": 28.448982
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万年县",
       "center": {
        "longitude": 117.058445,
        "latitude": 28.694582
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "婺源县",
       "center": {
        "longitude": 117.861797,
        "latitude": 29.248085
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "信州区",
       "center": {
        "longitude": 117.966268,
        "latitude": 28.431006
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "弋阳县",
       "center": {
        "longitude": 117.449588,
        "latitude": 28.378044
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "余干县",
       "center": {
        "longitude": 116.695646,
        "latitude": 28.702302
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玉山县",
       "center": {
        "longitude": 118.244769,
        "latitude": 28.682309
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "新余市",
     "center": {
      "longitude": 114.917346,
      "latitude": 27.817808
     },
     "level": "city",
     "districts": [
      {
       "name": "分宜县",
       "center": {
        "longitude": 114.692049,
        "latitude": 27.814757
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "渝水区",
       "center": {
        "longitude": 114.944549,
        "latitude": 27.800148
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "宜春市",
     "center": {
      "longitude": 114.416785,
      "latitude": 27.815743
     },
     "level": "city",
     "districts": [
      {
       "name": "奉新县",
       "center": {
        "longitude": 115.400491,
        "latitude": 28.688423
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰城市",
       "center": {
        "longitude": 115.771093,
        "latitude": 28.159141
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高安市",
       "center": {
        "longitude": 115.360619,
        "latitude": 28.441152
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "靖安县",
       "center": {
        "longitude": 115.362628,
        "latitude": 28.861478
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上高县",
       "center": {
        "longitude": 114.947683,
        "latitude": 28.238061
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铜鼓县",
       "center": {
        "longitude": 114.371172,
        "latitude": 28.520769
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万载县",
       "center": {
        "longitude": 114.444854,
        "latitude": 28.105689
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜丰县",
       "center": {
        "longitude": 114.802852,
        "latitude": 28.394565
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "袁州区",
       "center": {
        "longitude": 114.427858,
        "latitude": 27.797091
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "樟树市",
       "center": {
        "longitude": 115.546152,
        "latitude": 28.055853
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "鹰潭市",
     "center": {
      "longitude": 117.042173,
      "latitude": 28.272537
     },
     "level": "city",
     "districts": [
      {
       "name": "贵溪市",
       "center": {
        "longitude": 117.245497,
        "latitude": 28.292519
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "余江县",
       "center": {
        "longitude": 116.85926,
        "latitude": 28.198652
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "月湖区",
       "center": {
        "longitude": 117.102475,
        "latitude": 28.267018
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "吉林省",
   "center": {
    "longitude": 125.32568,
    "latitude": 43.897016
   },
   "level": "province",
   "districts": [
    {
     "name": "白城市",
     "center": {
      "longitude": 122.838714,
      "latitude": 45.619884
     },
     "level": "city",
     "districts": [
      {
       "name": "大安市",
       "center": {
        "longitude": 124.292626,
        "latitude": 45.506996
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洮北区",
       "center": {
        "longitude": 122.851029,
        "latitude": 45.621716
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洮南市",
       "center": {
        "longitude": 122.798579,
        "latitude": 45.356807
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通榆县",
       "center": {
        "longitude": 123.088238,
        "latitude": 44.81291
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇赉县",
       "center": {
        "longitude": 123.199607,
        "latitude": 45.84835
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "白山市",
     "center": {
      "longitude": 126.41473,
      "latitude": 41.943972
     },
     "level": "city",
     "districts": [
      {
       "name": "抚松县",
       "center": {
        "longitude": 127.449763,
        "latitude": 42.221207
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浑江区",
       "center": {
        "longitude": 126.416093,
        "latitude": 41.945409
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江源区",
       "center": {
        "longitude": 126.591178,
        "latitude": 42.056747
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "靖宇县",
       "center": {
        "longitude": 126.813583,
        "latitude": 42.388896
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临江市",
       "center": {
        "longitude": 126.918087,
        "latitude": 41.811979
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长白朝鲜族自治县",
       "center": {
        "longitude": 128.200789,
        "latitude": 41.420018
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "吉林市",
     "center": {
      "longitude": 126.549572,
      "latitude": 43.837883
     },
     "level": "city",
     "districts": [
      {
       "name": "昌邑区",
       "center": {
        "longitude": 126.574709,
        "latitude": 43.881818
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "船营区",
       "center": {
        "longitude": 126.540966,
        "latitude": 43.833445
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰满区",
       "center": {
        "longitude": 126.562274,
        "latitude": 43.821601
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桦甸市",
       "center": {
        "longitude": 126.746309,
        "latitude": 42.972096
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蛟河市",
       "center": {
        "longitude": 127.344229,
        "latitude": 43.724007
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙潭区",
       "center": {
        "longitude": 126.562197,
        "latitude": 43.910802
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "磐石市",
       "center": {
        "longitude": 126.060427,
        "latitude": 42.946285
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "舒兰市",
       "center": {
        "longitude": 126.965607,
        "latitude": 44.406105
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永吉县",
       "center": {
        "longitude": 126.497741,
        "latitude": 43.672582
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "辽源市",
     "center": {
      "longitude": 125.14366,
      "latitude": 42.887766
     },
     "level": "city",
     "districts": [
      {
       "name": "东丰县",
       "center": {
        "longitude": 125.531021,
        "latitude": 42.677371
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东辽县",
       "center": {
        "longitude": 124.991424,
        "latitude": 42.92625
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙山区",
       "center": {
        "longitude": 125.136627,
        "latitude": 42.90158
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西安区",
       "center": {
        "longitude": 125.149281,
        "latitude": 42.927324
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "松原市",
     "center": {
      "longitude": 124.825042,
      "latitude": 45.141548
     },
     "level": "city",
     "districts": [
      {
       "name": "扶余市",
       "center": {
        "longitude": 126.049803,
        "latitude": 44.9892
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乾安县",
       "center": {
        "longitude": 124.041139,
        "latitude": 45.003773
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁江区",
       "center": {
        "longitude": 124.86562,
        "latitude": 45.209915
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "前郭尔罗斯蒙古族自治县",
       "center": {
        "longitude": 124.823417,
        "latitude": 45.118061
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长岭县",
       "center": {
        "longitude": 123.967483,
        "latitude": 44.275895
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "四平市",
     "center": {
      "longitude": 124.350398,
      "latitude": 43.166419
     },
     "level": "city",
     "districts": [
      {
       "name": "公主岭市",
       "center": {
        "longitude": 124.822929,
        "latitude": 43.504676
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梨树县",
       "center": {
        "longitude": 124.33539,
        "latitude": 43.30706
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双辽市",
       "center": {
        "longitude": 123.502723,
        "latitude": 43.518302
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁东区",
       "center": {
        "longitude": 124.409591,
        "latitude": 43.162105
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁西区",
       "center": {
        "longitude": 124.345722,
        "latitude": 43.146155
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伊通满族自治县",
       "center": {
        "longitude": 125.305393,
        "latitude": 43.345754
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "通化市",
     "center": {
      "longitude": 125.939697,
      "latitude": 41.728401
     },
     "level": "city",
     "districts": [
      {
       "name": "东昌区",
       "center": {
        "longitude": 125.927101,
        "latitude": 41.702859
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "二道江区",
       "center": {
        "longitude": 126.042678,
        "latitude": 41.774044
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "辉南县",
       "center": {
        "longitude": 126.046783,
        "latitude": 42.684921
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "集安市",
       "center": {
        "longitude": 126.19403,
        "latitude": 41.125307
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柳河县",
       "center": {
        "longitude": 125.744735,
        "latitude": 42.284605
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梅河口市",
       "center": {
        "longitude": 125.710859,
        "latitude": 42.539253
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通化县",
       "center": {
        "longitude": 125.759259,
        "latitude": 41.679808
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "延边朝鲜族自治州",
     "center": {
      "longitude": 129.471868,
      "latitude": 42.909408
     },
     "level": "city",
     "districts": [
      {
       "name": "安图县",
       "center": {
        "longitude": 128.899772,
        "latitude": 43.11195
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "敦化市",
       "center": {
        "longitude": 128.232131,
        "latitude": 43.372642
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和龙市",
       "center": {
        "longitude": 129.010106,
        "latitude": 42.546675
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "珲春市",
       "center": {
        "longitude": 130.366036,
        "latitude": 42.862821
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙井市",
       "center": {
        "longitude": 129.427066,
        "latitude": 42.76631
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "图们市",
       "center": {
        "longitude": 129.84371,
        "latitude": 42.968044
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汪清县",
       "center": {
        "longitude": 129.771607,
        "latitude": 43.312522
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "延吉市",
       "center": {
        "longitude": 129.508804,
        "latitude": 42.89125
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "长春市",
     "center": {
      "longitude": 125.323513,
      "latitude": 43.817251
     },
     "level": "city",
     "districts": [
      {
       "name": "朝阳区",
       "center": {
        "longitude": 125.288254,
        "latitude": 43.833762
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "德惠市",
       "center": {
        "longitude": 125.728755,
        "latitude": 44.522056
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "二道区",
       "center": {
        "longitude": 125.374327,
        "latitude": 43.865577
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "九台区",
       "center": {
        "longitude": 125.839573,
        "latitude": 44.151742
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宽城区",
       "center": {
        "longitude": 125.326581,
        "latitude": 43.943612
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绿园区",
       "center": {
        "longitude": 125.256135,
        "latitude": 43.880975
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南关区",
       "center": {
        "longitude": 125.350173,
        "latitude": 43.863989
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "农安县",
       "center": {
        "longitude": 125.184887,
        "latitude": 44.432763
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双阳区",
       "center": {
        "longitude": 125.664662,
        "latitude": 43.525311
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "榆树市",
       "center": {
        "longitude": 126.533187,
        "latitude": 44.840318
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "辽宁省",
   "center": {
    "longitude": 123.431382,
    "latitude": 41.836175
   },
   "level": "province",
   "districts": [
    {
     "name": "鞍山市",
     "center": {
      "longitude": 122.994329,
      "latitude": 41.108647
     },
     "level": "city",
     "districts": [
      {
       "name": "海城市",
       "center": {
        "longitude": 122.685217,
        "latitude": 40.882377
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "立山区",
       "center": {
        "longitude": 123.029091,
        "latitude": 41.150401
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "千山区",
       "center": {
        "longitude": 122.944751,
        "latitude": 41.068901
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "台安县",
       "center": {
        "longitude": 122.436196,
        "latitude": 41.412767
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁东区",
       "center": {
        "longitude": 122.991052,
        "latitude": 41.089933
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁西区",
       "center": {
        "longitude": 122.969629,
        "latitude": 41.119884
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岫岩满族自治县",
       "center": {
        "longitude": 123.280935,
        "latitude": 40.29088
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "本溪市",
     "center": {
      "longitude": 123.685142,
      "latitude": 41.486981
     },
     "level": "city",
     "districts": [
      {
       "name": "本溪满族自治县",
       "center": {
        "longitude": 124.120635,
        "latitude": 41.302009
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桓仁满族自治县",
       "center": {
        "longitude": 125.361007,
        "latitude": 41.267127
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "明山区",
       "center": {
        "longitude": 123.817214,
        "latitude": 41.308719
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南芬区",
       "center": {
        "longitude": 123.744802,
        "latitude": 41.100445
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平山区",
       "center": {
        "longitude": 123.769088,
        "latitude": 41.299587
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "溪湖区",
       "center": {
        "longitude": 123.767646,
        "latitude": 41.329219
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "朝阳市",
     "center": {
      "longitude": 120.450879,
      "latitude": 41.573762
     },
     "level": "city",
     "districts": [
      {
       "name": "北票市",
       "center": {
        "longitude": 120.77073,
        "latitude": 41.800683
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "朝阳县",
       "center": {
        "longitude": 120.389754,
        "latitude": 41.497825
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建平县",
       "center": {
        "longitude": 119.64328,
        "latitude": 41.403128
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "喀喇沁左翼蒙古族自治县",
       "center": {
        "longitude": 119.741223,
        "latitude": 41.12815
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凌源市",
       "center": {
        "longitude": 119.401574,
        "latitude": 41.245445
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙城区",
       "center": {
        "longitude": 120.413376,
        "latitude": 41.576749
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双塔区",
       "center": {
        "longitude": 120.453744,
        "latitude": 41.565627
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "丹东市",
     "center": {
      "longitude": 124.35445,
      "latitude": 40.000787
     },
     "level": "city",
     "districts": [
      {
       "name": "东港市",
       "center": {
        "longitude": 124.152705,
        "latitude": 39.863008
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤城市",
       "center": {
        "longitude": 124.066919,
        "latitude": 40.452297
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宽甸满族自治县",
       "center": {
        "longitude": 124.783659,
        "latitude": 40.731316
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "元宝区",
       "center": {
        "longitude": 124.395661,
        "latitude": 40.136434
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "振安区",
       "center": {
        "longitude": 124.470034,
        "latitude": 40.201553
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "振兴区",
       "center": {
        "longitude": 124.383237,
        "latitude": 40.129944
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "大连市",
     "center": {
      "longitude": 121.614848,
      "latitude": 38.914086
     },
     "level": "city",
     "districts": [
      {
       "name": "甘井子区",
       "center": {
        "longitude": 121.525466,
        "latitude": 38.953343
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金州区",
       "center": {
        "longitude": 121.782655,
        "latitude": 39.050001
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "旅顺口区",
       "center": {
        "longitude": 121.261953,
        "latitude": 38.851705
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "普兰店区",
       "center": {
        "longitude": 121.938269,
        "latitude": 39.392095
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙河口区",
       "center": {
        "longitude": 121.594297,
        "latitude": 38.904788
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "瓦房店市",
       "center": {
        "longitude": 121.979543,
        "latitude": 39.626897
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西岗区",
       "center": {
        "longitude": 121.612324,
        "latitude": 38.914687
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长海县",
       "center": {
        "longitude": 122.588494,
        "latitude": 39.272728
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "庄河市",
       "center": {
        "longitude": 122.967424,
        "latitude": 39.680843
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "中山区",
       "center": {
        "longitude": 121.644926,
        "latitude": 38.918574
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "抚顺市",
     "center": {
      "longitude": 123.957208,
      "latitude": 41.880872
     },
     "level": "city",
     "districts": [
      {
       "name": "东洲区",
       "center": {
        "longitude": 124.038685,
        "latitude": 41.853191
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "抚顺县",
       "center": {
        "longitude": 124.097978,
        "latitude": 41.922644
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清原满族自治县",
       "center": {
        "longitude": 124.924083,
        "latitude": 42.100538
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "顺城区",
       "center": {
        "longitude": 123.945075,
        "latitude": 41.883235
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "望花区",
       "center": {
        "longitude": 123.784225,
        "latitude": 41.853641
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新宾满族自治县",
       "center": {
        "longitude": 125.039978,
        "latitude": 41.734256
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新抚区",
       "center": {
        "longitude": 123.912872,
        "latitude": 41.862026
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "阜新市",
     "center": {
      "longitude": 121.670273,
      "latitude": 42.021602
     },
     "level": "city",
     "districts": [
      {
       "name": "阜新蒙古族自治县",
       "center": {
        "longitude": 121.757901,
        "latitude": 42.065175
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海州区",
       "center": {
        "longitude": 121.657638,
        "latitude": 42.011162
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清河门区",
       "center": {
        "longitude": 121.416105,
        "latitude": 41.7831
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太平区",
       "center": {
        "longitude": 121.678604,
        "latitude": 42.010669
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "细河区",
       "center": {
        "longitude": 121.68054,
        "latitude": 42.025494
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新邱区",
       "center": {
        "longitude": 121.792535,
        "latitude": 42.087632
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "彰武县",
       "center": {
        "longitude": 122.538793,
        "latitude": 42.386543
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "葫芦岛市",
     "center": {
      "longitude": 120.836939,
      "latitude": 40.71104
     },
     "level": "city",
     "districts": [
      {
       "name": "建昌县",
       "center": {
        "longitude": 119.837124,
        "latitude": 40.824367
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "连山区",
       "center": {
        "longitude": 120.869231,
        "latitude": 40.774461
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙港区",
       "center": {
        "longitude": 120.893786,
        "latitude": 40.735519
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南票区",
       "center": {
        "longitude": 120.749727,
        "latitude": 41.107107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绥中县",
       "center": {
        "longitude": 120.344311,
        "latitude": 40.32558
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴城市",
       "center": {
        "longitude": 120.756479,
        "latitude": 40.609731
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "锦州市",
     "center": {
      "longitude": 121.126846,
      "latitude": 41.095685
     },
     "level": "city",
     "districts": [
      {
       "name": "北镇市",
       "center": {
        "longitude": 121.777395,
        "latitude": 41.58844
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "古塔区",
       "center": {
        "longitude": 121.128279,
        "latitude": 41.117245
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黑山县",
       "center": {
        "longitude": 122.126292,
        "latitude": 41.653593
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凌河区",
       "center": {
        "longitude": 121.150877,
        "latitude": 41.114989
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凌海市",
       "center": {
        "longitude": 121.35549,
        "latitude": 41.160567
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太和区",
       "center": {
        "longitude": 121.103892,
        "latitude": 41.109147
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "义县",
       "center": {
        "longitude": 121.23908,
        "latitude": 41.533086
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "辽阳市",
     "center": {
      "longitude": 123.236974,
      "latitude": 41.267794
     },
     "level": "city",
     "districts": [
      {
       "name": "白塔区",
       "center": {
        "longitude": 123.174325,
        "latitude": 41.270347
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灯塔市",
       "center": {
        "longitude": 123.339312,
        "latitude": 41.426372
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "弓长岭区",
       "center": {
        "longitude": 123.419803,
        "latitude": 41.151847
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宏伟区",
       "center": {
        "longitude": 123.196672,
        "latitude": 41.217649
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "辽阳县",
       "center": {
        "longitude": 123.105694,
        "latitude": 41.205329
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太子河区",
       "center": {
        "longitude": 123.18144,
        "latitude": 41.295023
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "文圣区",
       "center": {
        "longitude": 123.231408,
        "latitude": 41.283754
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "盘锦市",
     "center": {
      "longitude": 122.170584,
      "latitude": 40.719847
     },
     "level": "city",
     "districts": [
      {
       "name": "大洼区",
       "center": {
        "longitude": 122.082574,
        "latitude": 41.002279
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盘山县",
       "center": {
        "longitude": 121.996411,
        "latitude": 41.242639
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双台子区",
       "center": {
        "longitude": 122.039787,
        "latitude": 41.19965
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴隆台区",
       "center": {
        "longitude": 122.070769,
        "latitude": 41.119898
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "沈阳市",
     "center": {
      "longitude": 123.465035,
      "latitude": 41.677284
     },
     "level": "city",
     "districts": [
      {
       "name": "沈河区",
       "center": {
        "longitude": 123.458691,
        "latitude": 41.796177
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沈北新区",
       "center": {
        "longitude": 123.583196,
        "latitude": 41.912487
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大东区",
       "center": {
        "longitude": 123.469948,
        "latitude": 41.805137
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "法库县",
       "center": {
        "longitude": 123.440294,
        "latitude": 42.50108
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和平区",
       "center": {
        "longitude": 123.420368,
        "latitude": 41.789833
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "皇姑区",
       "center": {
        "longitude": 123.442378,
        "latitude": 41.824516
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浑南区",
       "center": {
        "longitude": 123.449714,
        "latitude": 41.714914
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "康平县",
       "center": {
        "longitude": 123.343699,
        "latitude": 42.72793
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "辽中区",
       "center": {
        "longitude": 122.765409,
        "latitude": 41.516826
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "苏家屯区",
       "center": {
        "longitude": 123.344062,
        "latitude": 41.664757
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁西区",
       "center": {
        "longitude": 123.333968,
        "latitude": 41.820807
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新民市",
       "center": {
        "longitude": 122.836723,
        "latitude": 41.985186
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "于洪区",
       "center": {
        "longitude": 123.308119,
        "latitude": 41.793721
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "铁岭市",
     "center": {
      "longitude": 123.726035,
      "latitude": 42.223828
     },
     "level": "city",
     "districts": [
      {
       "name": "昌图县",
       "center": {
        "longitude": 124.111099,
        "latitude": 42.785791
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "调兵山市",
       "center": {
        "longitude": 123.567117,
        "latitude": 42.467521
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开原市",
       "center": {
        "longitude": 124.038268,
        "latitude": 42.546307
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清河区",
       "center": {
        "longitude": 124.159191,
        "latitude": 42.546565
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "铁岭县",
       "center": {
        "longitude": 123.728933,
        "latitude": 42.223395
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西丰县",
       "center": {
        "longitude": 124.727392,
        "latitude": 42.73803
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "银州区",
       "center": {
        "longitude": 123.842305,
        "latitude": 42.286129
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "营口市",
     "center": {
      "longitude": 122.219458,
      "latitude": 40.625364
     },
     "level": "city",
     "districts": [
      {
       "name": "鲅鱼圈区",
       "center": {
        "longitude": 122.121521,
        "latitude": 40.226661
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大石桥市",
       "center": {
        "longitude": 122.509006,
        "latitude": 40.644482
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盖州市",
       "center": {
        "longitude": 122.349012,
        "latitude": 40.40074
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "老边区",
       "center": {
        "longitude": 122.380087,
        "latitude": 40.680191
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西市区",
       "center": {
        "longitude": 122.206419,
        "latitude": 40.666213
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "站前区",
       "center": {
        "longitude": 122.259033,
        "latitude": 40.672563
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "宁夏回族自治区",
   "center": {
    "longitude": 106.259126,
    "latitude": 38.472641
   },
   "level": "province",
   "districts": [
    {
     "name": "固原市",
     "center": {
      "longitude": 106.24261,
      "latitude": 36.015855
     },
     "level": "city",
     "districts": [
      {
       "name": "泾源县",
       "center": {
        "longitude": 106.330646,
        "latitude": 35.498159
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隆德县",
       "center": {
        "longitude": 106.111595,
        "latitude": 35.625914
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "彭阳县",
       "center": {
        "longitude": 106.631809,
        "latitude": 35.858815
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西吉县",
       "center": {
        "longitude": 105.729085,
        "latitude": 35.963912
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "原州区",
       "center": {
        "longitude": 106.287781,
        "latitude": 36.003739
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "石嘴山市",
     "center": {
      "longitude": 106.383303,
      "latitude": 38.983236
     },
     "level": "city",
     "districts": [
      {
       "name": "大武口区",
       "center": {
        "longitude": 106.367958,
        "latitude": 39.01918
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "惠农区",
       "center": {
        "longitude": 106.781176,
        "latitude": 39.239302
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平罗县",
       "center": {
        "longitude": 106.523474,
        "latitude": 38.913544
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "吴忠市",
     "center": {
      "longitude": 106.198913,
      "latitude": 37.997428
     },
     "level": "city",
     "districts": [
      {
       "name": "红寺堡区",
       "center": {
        "longitude": 106.062113,
        "latitude": 37.425702
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "利通区",
       "center": {
        "longitude": 106.212613,
        "latitude": 37.98349
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青铜峡市",
       "center": {
        "longitude": 106.078817,
        "latitude": 38.021302
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "同心县",
       "center": {
        "longitude": 105.895309,
        "latitude": 36.95449
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盐池县",
       "center": {
        "longitude": 107.407358,
        "latitude": 37.783205
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "银川市",
     "center": {
      "longitude": 106.230909,
      "latitude": 38.487193
     },
     "level": "city",
     "districts": [
      {
       "name": "贺兰县",
       "center": {
        "longitude": 106.349861,
        "latitude": 38.554599
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金凤区",
       "center": {
        "longitude": 106.239679,
        "latitude": 38.47436
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "灵武市",
       "center": {
        "longitude": 106.340053,
        "latitude": 38.102655
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西夏区",
       "center": {
        "longitude": 106.161106,
        "latitude": 38.502605
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴庆区",
       "center": {
        "longitude": 106.28865,
        "latitude": 38.473609
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永宁县",
       "center": {
        "longitude": 106.253145,
        "latitude": 38.277372
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "中卫市",
     "center": {
      "longitude": 105.196902,
      "latitude": 37.499972
     },
     "level": "city",
     "districts": [
      {
       "name": "海原县",
       "center": {
        "longitude": 105.643487,
        "latitude": 36.565033
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙坡头区",
       "center": {
        "longitude": 105.173721,
        "latitude": 37.516883
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "中宁县",
       "center": {
        "longitude": 105.685218,
        "latitude": 37.491546
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "内蒙古自治区",
   "center": {
    "longitude": 111.76629,
    "latitude": 40.81739
   },
   "level": "province",
   "districts": [
    {
     "name": "阿拉善盟",
     "center": {
      "longitude": 105.728957,
      "latitude": 38.851921
     },
     "level": "city",
     "districts": [
      {
       "name": "阿拉善右旗",
       "center": {
        "longitude": 101.666917,
        "latitude": 39.216185
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阿拉善左旗",
       "center": {
        "longitude": 105.666275,
        "latitude": 38.833389
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "额济纳旗",
       "center": {
        "longitude": 101.055731,
        "latitude": 41.95455
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "巴彦淖尔市",
     "center": {
      "longitude": 107.387657,
      "latitude": 40.743213
     },
     "level": "city",
     "districts": [
      {
       "name": "磴口县",
       "center": {
        "longitude": 107.008248,
        "latitude": 40.330523
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "杭锦后旗",
       "center": {
        "longitude": 107.151245,
        "latitude": 40.88602
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临河区",
       "center": {
        "longitude": 107.363918,
        "latitude": 40.751187
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌拉特中旗",
       "center": {
        "longitude": 108.513645,
        "latitude": 41.587732
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌拉特前旗",
       "center": {
        "longitude": 108.652114,
        "latitude": 40.737018
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌拉特后旗",
       "center": {
        "longitude": 107.074621,
        "latitude": 41.084282
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五原县",
       "center": {
        "longitude": 108.267561,
        "latitude": 41.088421
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "包头市",
     "center": {
      "longitude": 109.953504,
      "latitude": 40.621157
     },
     "level": "city",
     "districts": [
      {
       "name": "白云鄂博矿区",
       "center": {
        "longitude": 109.973803,
        "latitude": 41.769511
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "达尔罕茂明安联合旗",
       "center": {
        "longitude": 110.432626,
        "latitude": 41.698992
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东河区",
       "center": {
        "longitude": 110.044106,
        "latitude": 40.576319
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "固阳县",
       "center": {
        "longitude": 110.060514,
        "latitude": 41.034105
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "九原区",
       "center": {
        "longitude": 109.967449,
        "latitude": 40.610561
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昆都仑区",
       "center": {
        "longitude": 109.837707,
        "latitude": 40.642578
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青山区",
       "center": {
        "longitude": 109.901572,
        "latitude": 40.643246
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石拐区",
       "center": {
        "longitude": 110.060254,
        "latitude": 40.681748
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "土默特右旗",
       "center": {
        "longitude": 110.524262,
        "latitude": 40.569426
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "赤峰市",
     "center": {
      "longitude": 118.88694,
      "latitude": 42.257843
     },
     "level": "city",
     "districts": [
      {
       "name": "阿鲁科尔沁旗",
       "center": {
        "longitude": 120.0657,
        "latitude": 43.872298
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巴林右旗",
       "center": {
        "longitude": 118.66518,
        "latitude": 43.534414
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "敖汉旗",
       "center": {
        "longitude": 119.921603,
        "latitude": 42.290781
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巴林左旗",
       "center": {
        "longitude": 119.362931,
        "latitude": 43.960889
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红山区",
       "center": {
        "longitude": 118.953854,
        "latitude": 42.296588
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "喀喇沁旗",
       "center": {
        "longitude": 118.701937,
        "latitude": 41.927363
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "克什克腾旗",
       "center": {
        "longitude": 117.545797,
        "latitude": 43.264988
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "林西县",
       "center": {
        "longitude": 118.05545,
        "latitude": 43.61812
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁城县",
       "center": {
        "longitude": 119.318876,
        "latitude": 41.601375
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "松山区",
       "center": {
        "longitude": 118.916208,
        "latitude": 42.299798
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "翁牛特旗",
       "center": {
        "longitude": 119.00658,
        "latitude": 42.936188
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "元宝山区",
       "center": {
        "longitude": 119.288611,
        "latitude": 42.038902
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "鄂尔多斯市",
     "center": {
      "longitude": 109.781327,
      "latitude": 39.608266
     },
     "level": "city",
     "districts": [
      {
       "name": "达拉特旗",
       "center": {
        "longitude": 110.033833,
        "latitude": 40.412438
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东胜区",
       "center": {
        "longitude": 109.963333,
        "latitude": 39.822593
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄂托克旗",
       "center": {
        "longitude": 107.97616,
        "latitude": 39.08965
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄂托克前旗",
       "center": {
        "longitude": 107.477514,
        "latitude": 38.182362
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "杭锦旗",
       "center": {
        "longitude": 108.736208,
        "latitude": 39.833309
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "康巴什区",
       "center": {
        "longitude": 109.790076,
        "latitude": 39.607472
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌审旗",
       "center": {
        "longitude": 108.817607,
        "latitude": 38.604136
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伊金霍洛旗",
       "center": {
        "longitude": 109.74774,
        "latitude": 39.564659
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "准格尔旗",
       "center": {
        "longitude": 111.240171,
        "latitude": 39.864361
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "呼和浩特市",
     "center": {
      "longitude": 111.749995,
      "latitude": 40.842356
     },
     "level": "city",
     "districts": [
      {
       "name": "和林格尔县",
       "center": {
        "longitude": 111.821843,
        "latitude": 40.378787
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "回民区",
       "center": {
        "longitude": 111.623692,
        "latitude": 40.808608
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清水河县",
       "center": {
        "longitude": 111.647609,
        "latitude": 39.921095
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "赛罕区",
       "center": {
        "longitude": 111.701355,
        "latitude": 40.792667
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "土默特左旗",
       "center": {
        "longitude": 111.163902,
        "latitude": 40.729572
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "托克托县",
       "center": {
        "longitude": 111.194312,
        "latitude": 40.277431
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武川县",
       "center": {
        "longitude": 111.451303,
        "latitude": 41.096471
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新城区",
       "center": {
        "longitude": 111.665544,
        "latitude": 40.858289
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玉泉区",
       "center": {
        "longitude": 111.673881,
        "latitude": 40.753655
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "呼伦贝尔市",
     "center": {
      "longitude": 119.765558,
      "latitude": 49.211576
     },
     "level": "city",
     "districts": [
      {
       "name": "阿荣旗",
       "center": {
        "longitude": 123.459049,
        "latitude": 48.126584
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陈巴尔虎旗",
       "center": {
        "longitude": 119.424026,
        "latitude": 49.328916
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "额尔古纳市",
       "center": {
        "longitude": 120.180506,
        "latitude": 50.243102
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄂伦春自治旗",
       "center": {
        "longitude": 123.726201,
        "latitude": 50.591842
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄂温克族自治旗",
       "center": {
        "longitude": 119.755239,
        "latitude": 49.146592
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "根河市",
       "center": {
        "longitude": 121.520388,
        "latitude": 50.780344
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海拉尔区",
       "center": {
        "longitude": 119.736176,
        "latitude": 49.212188
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "满洲里市",
       "center": {
        "longitude": 117.378529,
        "latitude": 49.597841
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莫力达瓦达斡尔族自治旗",
       "center": {
        "longitude": 124.519023,
        "latitude": 48.477728
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新巴尔虎右旗",
       "center": {
        "longitude": 116.82369,
        "latitude": 48.672101
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新巴尔虎左旗",
       "center": {
        "longitude": 118.269819,
        "latitude": 48.218241
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "牙克石市",
       "center": {
        "longitude": 120.711775,
        "latitude": 49.285629
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "扎兰屯市",
       "center": {
        "longitude": 122.737467,
        "latitude": 48.013733
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "扎赉诺尔区",
       "center": {
        "longitude": 117.670248,
        "latitude": 49.510375
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "乌海市",
     "center": {
      "longitude": 106.794216,
      "latitude": 39.655248
     },
     "level": "city",
     "districts": [
      {
       "name": "海勃湾区",
       "center": {
        "longitude": 106.822778,
        "latitude": 39.691156
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海南区",
       "center": {
        "longitude": 106.891424,
        "latitude": 39.441364
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌达区",
       "center": {
        "longitude": 106.726099,
        "latitude": 39.505925
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "乌兰察布市",
     "center": {
      "longitude": 113.132584,
      "latitude": 40.994785
     },
     "level": "city",
     "districts": [
      {
       "name": "察哈尔右翼中旗",
       "center": {
        "longitude": 112.635577,
        "latitude": 41.277462
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "察哈尔右翼前旗",
       "center": {
        "longitude": 113.214733,
        "latitude": 40.785631
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "察哈尔右翼后旗",
       "center": {
        "longitude": 113.191035,
        "latitude": 41.436069
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丰镇市",
       "center": {
        "longitude": 113.109892,
        "latitude": 40.436983
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "化德县",
       "center": {
        "longitude": 114.010437,
        "latitude": 41.90456
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "集宁区",
       "center": {
        "longitude": 113.116453,
        "latitude": 41.034134
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凉城县",
       "center": {
        "longitude": 112.503971,
        "latitude": 40.531555
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "商都县",
       "center": {
        "longitude": 113.577816,
        "latitude": 41.562113
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "四子王旗",
       "center": {
        "longitude": 111.706617,
        "latitude": 41.533462
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴和县",
       "center": {
        "longitude": 113.834173,
        "latitude": 40.872301
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "卓资县",
       "center": {
        "longitude": 112.577528,
        "latitude": 40.894691
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "通辽市",
     "center": {
      "longitude": 122.243444,
      "latitude": 43.652889
     },
     "level": "city",
     "districts": [
      {
       "name": "霍林郭勒市",
       "center": {
        "longitude": 119.68187,
        "latitude": 45.533962
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "科尔沁左翼中旗",
       "center": {
        "longitude": 123.312264,
        "latitude": 44.126625
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开鲁县",
       "center": {
        "longitude": 121.319308,
        "latitude": 43.601244
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "科尔沁区",
       "center": {
        "longitude": 122.255671,
        "latitude": 43.623078
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "科尔沁左翼后旗",
       "center": {
        "longitude": 122.35677,
        "latitude": 42.935105
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "库伦旗",
       "center": {
        "longitude": 121.8107,
        "latitude": 42.735656
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "奈曼旗",
       "center": {
        "longitude": 120.658282,
        "latitude": 42.867226
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "扎鲁特旗",
       "center": {
        "longitude": 120.911676,
        "latitude": 44.556389
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "锡林郭勒盟",
     "center": {
      "longitude": 116.048222,
      "latitude": 43.933454
     },
     "level": "city",
     "districts": [
      {
       "name": "阿巴嘎旗",
       "center": {
        "longitude": 114.950248,
        "latitude": 44.022995
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东乌珠穆沁旗",
       "center": {
        "longitude": 116.974494,
        "latitude": 45.498221
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "二连浩特市",
       "center": {
        "longitude": 111.951002,
        "latitude": 43.6437
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "多伦县",
       "center": {
        "longitude": 116.485555,
        "latitude": 42.203591
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "苏尼特右旗",
       "center": {
        "longitude": 112.641783,
        "latitude": 42.742892
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "苏尼特左旗",
       "center": {
        "longitude": 113.667248,
        "latitude": 43.85988
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太仆寺旗",
       "center": {
        "longitude": 115.282986,
        "latitude": 41.877135
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "锡林浩特市",
       "center": {
        "longitude": 116.086029,
        "latitude": 43.933403
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镶黄旗",
       "center": {
        "longitude": 113.847287,
        "latitude": 42.232371
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西乌珠穆沁旗",
       "center": {
        "longitude": 117.608911,
        "latitude": 44.587882
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "正镶白旗",
       "center": {
        "longitude": 115.029848,
        "latitude": 42.28747
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "正蓝旗",
       "center": {
        "longitude": 115.99247,
        "latitude": 42.241638
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "兴安盟",
     "center": {
      "longitude": 122.037657,
      "latitude": 46.082462
     },
     "level": "city",
     "districts": [
      {
       "name": "阿尔山市",
       "center": {
        "longitude": 119.943575,
        "latitude": 47.17744
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "科尔沁右翼中旗",
       "center": {
        "longitude": 121.47653,
        "latitude": 45.060837
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "科尔沁右翼前旗",
       "center": {
        "longitude": 121.952621,
        "latitude": 46.079833
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "突泉县",
       "center": {
        "longitude": 121.593799,
        "latitude": 45.38193
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌兰浩特市",
       "center": {
        "longitude": 122.093123,
        "latitude": 46.072731
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "扎赉特旗",
       "center": {
        "longitude": 122.899656,
        "latitude": 46.723237
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "山东省",
   "center": {
    "longitude": 117.019915,
    "latitude": 36.671156
   },
   "level": "province",
   "districts": [
    {
     "name": "滨州市",
     "center": {
      "longitude": 117.970699,
      "latitude": 37.38198
     },
     "level": "city",
     "districts": [
      {
       "name": "博兴县",
       "center": {
        "longitude": 118.110709,
        "latitude": 37.15457
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "滨城区",
       "center": {
        "longitude": 118.019326,
        "latitude": 37.430724
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "惠民县",
       "center": {
        "longitude": 117.509921,
        "latitude": 37.489877
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "无棣县",
       "center": {
        "longitude": 117.625696,
        "latitude": 37.77026
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳信县",
       "center": {
        "longitude": 117.603339,
        "latitude": 37.632433
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沾化区",
       "center": {
        "longitude": 118.098902,
        "latitude": 37.69926
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邹平县",
       "center": {
        "longitude": 117.743109,
        "latitude": 36.862989
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "德州市",
     "center": {
      "longitude": 116.359381,
      "latitude": 37.436657
     },
     "level": "city",
     "districts": [
      {
       "name": "德城区",
       "center": {
        "longitude": 116.29947,
        "latitude": 37.450804
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乐陵市",
       "center": {
        "longitude": 117.231934,
        "latitude": 37.729907
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临邑县",
       "center": {
        "longitude": 116.866799,
        "latitude": 37.189797
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陵城区",
       "center": {
        "longitude": 116.576092,
        "latitude": 37.335794
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁津县",
       "center": {
        "longitude": 116.800306,
        "latitude": 37.652189
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平原县",
       "center": {
        "longitude": 116.434032,
        "latitude": 37.165323
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "齐河县",
       "center": {
        "longitude": 116.762893,
        "latitude": 36.784158
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "庆云县",
       "center": {
        "longitude": 117.385256,
        "latitude": 37.775349
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武城县",
       "center": {
        "longitude": 116.069302,
        "latitude": 37.213311
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "夏津县",
       "center": {
        "longitude": 116.001726,
        "latitude": 36.948371
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "禹城市",
       "center": {
        "longitude": 116.638327,
        "latitude": 36.933812
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "东营市",
     "center": {
      "longitude": 118.674614,
      "latitude": 37.433963
     },
     "level": "city",
     "districts": [
      {
       "name": "东营区",
       "center": {
        "longitude": 118.582184,
        "latitude": 37.448964
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广饶县",
       "center": {
        "longitude": 118.407107,
        "latitude": 37.053555
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "河口区",
       "center": {
        "longitude": 118.525543,
        "latitude": 37.886162
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "垦利区",
       "center": {
        "longitude": 118.575228,
        "latitude": 37.573054
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "利津县",
       "center": {
        "longitude": 118.255287,
        "latitude": 37.490328
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "菏泽市",
     "center": {
      "longitude": 115.480656,
      "latitude": 35.23375
     },
     "level": "city",
     "districts": [
      {
       "name": "曹县",
       "center": {
        "longitude": 115.542328,
        "latitude": 34.825508
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "成武县",
       "center": {
        "longitude": 115.889764,
        "latitude": 34.952459
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "单县",
       "center": {
        "longitude": 116.107428,
        "latitude": 34.778808
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "定陶区",
       "center": {
        "longitude": 115.57302,
        "latitude": 35.070995
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东明县",
       "center": {
        "longitude": 115.107404,
        "latitude": 35.276162
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄄城县",
       "center": {
        "longitude": 115.510192,
        "latitude": 35.563408
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巨野县",
       "center": {
        "longitude": 116.062394,
        "latitude": 35.388925
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "牡丹区",
       "center": {
        "longitude": 115.417826,
        "latitude": 35.252512
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郓城县",
       "center": {
        "longitude": 115.9389,
        "latitude": 35.575135
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "济南市",
     "center": {
      "longitude": 117.120098,
      "latitude": 36.6512
     },
     "level": "city",
     "districts": [
      {
       "name": "槐荫区",
       "center": {
        "longitude": 116.901224,
        "latitude": 36.651441
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "济阳县",
       "center": {
        "longitude": 117.173524,
        "latitude": 36.978537
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "历下区",
       "center": {
        "longitude": 117.076441,
        "latitude": 36.666465
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "历城区",
       "center": {
        "longitude": 117.06523,
        "latitude": 36.680259
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平阴县",
       "center": {
        "longitude": 116.456006,
        "latitude": 36.289251
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "商河县",
       "center": {
        "longitude": 117.157232,
        "latitude": 37.309041
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "市中区",
       "center": {
        "longitude": 116.997845,
        "latitude": 36.651335
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天桥区",
       "center": {
        "longitude": 116.987153,
        "latitude": 36.678589
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "章丘区",
       "center": {
        "longitude": 117.526228,
        "latitude": 36.681258
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长清区",
       "center": {
        "longitude": 116.751843,
        "latitude": 36.55371
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "济宁市",
     "center": {
      "longitude": 116.587282,
      "latitude": 35.414982
     },
     "level": "city",
     "districts": [
      {
       "name": "嘉祥县",
       "center": {
        "longitude": 116.342449,
        "latitude": 35.408824
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金乡县",
       "center": {
        "longitude": 116.311532,
        "latitude": 35.066619
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梁山县",
       "center": {
        "longitude": 116.096044,
        "latitude": 35.802306
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "曲阜市",
       "center": {
        "longitude": 116.986526,
        "latitude": 35.581108
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "任城区",
       "center": {
        "longitude": 116.606103,
        "latitude": 35.444028
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泗水县",
       "center": {
        "longitude": 117.251195,
        "latitude": 35.664323
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "微山县",
       "center": {
        "longitude": 117.128827,
        "latitude": 34.806554
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汶上县",
       "center": {
        "longitude": 116.49708,
        "latitude": 35.712298
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兖州区",
       "center": {
        "longitude": 116.783833,
        "latitude": 35.553144
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鱼台县",
       "center": {
        "longitude": 116.650608,
        "latitude": 35.012749
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邹城市",
       "center": {
        "longitude": 117.007453,
        "latitude": 35.40268
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "莱芜市",
     "center": {
      "longitude": 117.676723,
      "latitude": 36.213813
     },
     "level": "city",
     "districts": [
      {
       "name": "钢城区",
       "center": {
        "longitude": 117.811354,
        "latitude": 36.058572
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莱城区",
       "center": {
        "longitude": 117.659884,
        "latitude": 36.203179
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "聊城市",
     "center": {
      "longitude": 115.985389,
      "latitude": 36.456684
     },
     "level": "city",
     "districts": [
      {
       "name": "茌平县",
       "center": {
        "longitude": 116.25527,
        "latitude": 36.580688
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东昌府区",
       "center": {
        "longitude": 115.988349,
        "latitude": 36.434669
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东阿县",
       "center": {
        "longitude": 116.247579,
        "latitude": 36.334917
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高唐县",
       "center": {
        "longitude": 116.23016,
        "latitude": 36.846762
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "冠县",
       "center": {
        "longitude": 115.442739,
        "latitude": 36.484009
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临清市",
       "center": {
        "longitude": 115.704881,
        "latitude": 36.838277
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莘县",
       "center": {
        "longitude": 115.671191,
        "latitude": 36.233598
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阳谷县",
       "center": {
        "longitude": 115.79182,
        "latitude": 36.114392
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "临沂市",
     "center": {
      "longitude": 118.356414,
      "latitude": 35.104673
     },
     "level": "city",
     "districts": [
      {
       "name": "费县",
       "center": {
        "longitude": 117.977325,
        "latitude": 35.26596
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "河东区",
       "center": {
        "longitude": 118.402893,
        "latitude": 35.089916
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莒南县",
       "center": {
        "longitude": 118.835163,
        "latitude": 35.174846
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兰陵县",
       "center": {
        "longitude": 118.07065,
        "latitude": 34.857149
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兰山区",
       "center": {
        "longitude": 118.347842,
        "latitude": 35.051804
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临沭县",
       "center": {
        "longitude": 118.650781,
        "latitude": 34.919851
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "罗庄区",
       "center": {
        "longitude": 118.284786,
        "latitude": 34.996741
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蒙阴县",
       "center": {
        "longitude": 117.953621,
        "latitude": 35.719396
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平邑县",
       "center": {
        "longitude": 117.640352,
        "latitude": 35.505943
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郯城县",
       "center": {
        "longitude": 118.367215,
        "latitude": 34.613586
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沂南县",
       "center": {
        "longitude": 118.465221,
        "latitude": 35.550217
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沂水县",
       "center": {
        "longitude": 118.627917,
        "latitude": 35.79045
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "青岛市",
     "center": {
      "longitude": 120.382621,
      "latitude": 36.067131
     },
     "level": "city",
     "districts": [
      {
       "name": "城阳区",
       "center": {
        "longitude": 120.396256,
        "latitude": 36.307559
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄岛区",
       "center": {
        "longitude": 120.198055,
        "latitude": 35.960933
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "即墨区",
       "center": {
        "longitude": 120.447158,
        "latitude": 36.389408
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "胶州市",
       "center": {
        "longitude": 120.033382,
        "latitude": 36.26468
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莱西市",
       "center": {
        "longitude": 120.51769,
        "latitude": 36.889084
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "李沧区",
       "center": {
        "longitude": 120.432922,
        "latitude": 36.145519
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "崂山区",
       "center": {
        "longitude": 120.468956,
        "latitude": 36.107538
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平度市",
       "center": {
        "longitude": 119.98842,
        "latitude": 36.776357
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "市南区",
       "center": {
        "longitude": 120.412392,
        "latitude": 36.075651
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "市北区",
       "center": {
        "longitude": 120.374701,
        "latitude": 36.0876
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "日照市",
     "center": {
      "longitude": 119.526925,
      "latitude": 35.416734
     },
     "level": "city",
     "districts": [
      {
       "name": "东港区",
       "center": {
        "longitude": 119.462267,
        "latitude": 35.42548
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莒县",
       "center": {
        "longitude": 118.837063,
        "latitude": 35.579868
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岚山区",
       "center": {
        "longitude": 119.318928,
        "latitude": 35.121884
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五莲县",
       "center": {
        "longitude": 119.213619,
        "latitude": 35.760228
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "泰安市",
     "center": {
      "longitude": 117.087614,
      "latitude": 36.200252
     },
     "level": "city",
     "districts": [
      {
       "name": "岱岳区",
       "center": {
        "longitude": 117.041581,
        "latitude": 36.187989
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东平县",
       "center": {
        "longitude": 116.470304,
        "latitude": 35.937102
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "肥城市",
       "center": {
        "longitude": 116.768358,
        "latitude": 36.182571
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁阳县",
       "center": {
        "longitude": 116.805796,
        "latitude": 35.758786
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泰山区",
       "center": {
        "longitude": 117.135354,
        "latitude": 36.192083
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新泰市",
       "center": {
        "longitude": 117.767952,
        "latitude": 35.909032
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "威海市",
     "center": {
      "longitude": 122.120282,
      "latitude": 37.513412
     },
     "level": "city",
     "districts": [
      {
       "name": "环翠区",
       "center": {
        "longitude": 122.123443,
        "latitude": 37.50199
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乳山市",
       "center": {
        "longitude": 121.539764,
        "latitude": 36.919816
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荣成市",
       "center": {
        "longitude": 122.486657,
        "latitude": 37.16516
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "文登区",
       "center": {
        "longitude": 122.05767,
        "latitude": 37.193735
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "潍坊市",
     "center": {
      "longitude": 119.161748,
      "latitude": 36.706962
     },
     "level": "city",
     "districts": [
      {
       "name": "安丘市",
       "center": {
        "longitude": 119.218978,
        "latitude": 36.478493
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昌乐县",
       "center": {
        "longitude": 118.829992,
        "latitude": 36.706964
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昌邑市",
       "center": {
        "longitude": 119.403069,
        "latitude": 36.843319
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "坊子区",
       "center": {
        "longitude": 119.166485,
        "latitude": 36.654448
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高密市",
       "center": {
        "longitude": 119.755597,
        "latitude": 36.382594
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "寒亭区",
       "center": {
        "longitude": 119.211157,
        "latitude": 36.755623
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "奎文区",
       "center": {
        "longitude": 119.132482,
        "latitude": 36.70759
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临朐县",
       "center": {
        "longitude": 118.542982,
        "latitude": 36.512506
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青州市",
       "center": {
        "longitude": 118.479654,
        "latitude": 36.684789
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "寿光市",
       "center": {
        "longitude": 118.790739,
        "latitude": 36.85576
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "潍城区",
       "center": {
        "longitude": 119.024835,
        "latitude": 36.7281
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "诸城市",
       "center": {
        "longitude": 119.410103,
        "latitude": 35.995654
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "烟台市",
     "center": {
      "longitude": 121.447852,
      "latitude": 37.464539
     },
     "level": "city",
     "districts": [
      {
       "name": "福山区",
       "center": {
        "longitude": 121.267741,
        "latitude": 37.498246
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海阳市",
       "center": {
        "longitude": 121.173793,
        "latitude": 36.688
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莱山区",
       "center": {
        "longitude": 121.445301,
        "latitude": 37.511291
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莱阳市",
       "center": {
        "longitude": 120.711672,
        "latitude": 36.978941
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莱州市",
       "center": {
        "longitude": 119.942274,
        "latitude": 37.177129
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙口市",
       "center": {
        "longitude": 120.477813,
        "latitude": 37.646107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "牟平区",
       "center": {
        "longitude": 121.600455,
        "latitude": 37.387061
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蓬莱市",
       "center": {
        "longitude": 120.758848,
        "latitude": 37.810661
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "栖霞市",
       "center": {
        "longitude": 120.849675,
        "latitude": 37.335123
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "招远市",
       "center": {
        "longitude": 120.434071,
        "latitude": 37.355469
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芝罘区",
       "center": {
        "longitude": 121.400445,
        "latitude": 37.541475
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长岛县",
       "center": {
        "longitude": 120.73658,
        "latitude": 37.921368
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "枣庄市",
     "center": {
      "longitude": 117.323725,
      "latitude": 34.810488
     },
     "level": "city",
     "districts": [
      {
       "name": "山亭区",
       "center": {
        "longitude": 117.461517,
        "latitude": 35.099528
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "市中区",
       "center": {
        "longitude": 117.556139,
        "latitude": 34.863554
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "台儿庄区",
       "center": {
        "longitude": 117.734414,
        "latitude": 34.56244
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "滕州市",
       "center": {
        "longitude": 117.165824,
        "latitude": 35.114155
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "薛城区",
       "center": {
        "longitude": 117.263164,
        "latitude": 34.795062
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "峄城区",
       "center": {
        "longitude": 117.590816,
        "latitude": 34.773263
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "淄博市",
     "center": {
      "longitude": 118.055019,
      "latitude": 36.813546
     },
     "level": "city",
     "districts": [
      {
       "name": "博山区",
       "center": {
        "longitude": 117.861851,
        "latitude": 36.494701
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高青县",
       "center": {
        "longitude": 117.826924,
        "latitude": 37.170979
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桓台县",
       "center": {
        "longitude": 118.097922,
        "latitude": 36.959804
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临淄区",
       "center": {
        "longitude": 118.309118,
        "latitude": 36.826981
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沂源县",
       "center": {
        "longitude": 118.170855,
        "latitude": 36.185038
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "张店区",
       "center": {
        "longitude": 118.017938,
        "latitude": 36.806669
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "周村区",
       "center": {
        "longitude": 117.869886,
        "latitude": 36.803072
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淄川区",
       "center": {
        "longitude": 117.966723,
        "latitude": 36.643452
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "青海省",
   "center": {
    "longitude": 101.780268,
    "latitude": 36.620939
   },
   "level": "province",
   "districts": [
    {
     "name": "果洛藏族自治州",
     "center": {
      "longitude": 100.244808,
      "latitude": 34.471431
     },
     "level": "city",
     "districts": [
      {
       "name": "班玛县",
       "center": {
        "longitude": 100.737138,
        "latitude": 32.932723
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "达日县",
       "center": {
        "longitude": 99.651392,
        "latitude": 33.74892
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "甘德县",
       "center": {
        "longitude": 99.900923,
        "latitude": 33.969216
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "久治县",
       "center": {
        "longitude": 101.482831,
        "latitude": 33.429471
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玛沁县",
       "center": {
        "longitude": 100.238888,
        "latitude": 34.477433
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玛多县",
       "center": {
        "longitude": 98.209206,
        "latitude": 34.915946
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "海东市",
     "center": {
      "longitude": 102.104287,
      "latitude": 36.502039
     },
     "level": "city",
     "districts": [
      {
       "name": "互助土族自治县",
       "center": {
        "longitude": 101.959271,
        "latitude": 36.844248
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "化隆回族自治县",
       "center": {
        "longitude": 102.264143,
        "latitude": 36.094908
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乐都区",
       "center": {
        "longitude": 102.401724,
        "latitude": 36.482058
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "民和回族土族自治县",
       "center": {
        "longitude": 102.830892,
        "latitude": 36.320321
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平安区",
       "center": {
        "longitude": 102.108834,
        "latitude": 36.500563
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "循化撒拉族自治县",
       "center": {
        "longitude": 102.489135,
        "latitude": 35.851152
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "海北藏族自治州",
     "center": {
      "longitude": 100.900997,
      "latitude": 36.954413
     },
     "level": "city",
     "districts": [
      {
       "name": "刚察县",
       "center": {
        "longitude": 100.145833,
        "latitude": 37.32547
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海晏县",
       "center": {
        "longitude": 100.99426,
        "latitude": 36.896359
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "门源回族自治县",
       "center": {
        "longitude": 101.611539,
        "latitude": 37.388746
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "祁连县",
       "center": {
        "longitude": 100.253211,
        "latitude": 38.177112
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "海西蒙古族藏族自治州",
     "center": {
      "longitude": 97.369751,
      "latitude": 37.377139
     },
     "level": "city",
     "districts": [
      {
       "name": "德令哈市",
       "center": {
        "longitude": 97.360984,
        "latitude": 37.369436
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "都兰县",
       "center": {
        "longitude": 98.095844,
        "latitude": 36.302496
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "格尔木市",
       "center": {
        "longitude": 94.928453,
        "latitude": 36.406367
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海西蒙古族藏族自治州直辖",
       "center": {
        "longitude": 95.356546,
        "latitude": 37.853328
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天峻县",
       "center": {
        "longitude": 99.022984,
        "latitude": 37.300851
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌兰县",
       "center": {
        "longitude": 98.480195,
        "latitude": 36.929749
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "海南藏族自治州",
     "center": {
      "longitude": 100.622692,
      "latitude": 36.296529
     },
     "level": "city",
     "districts": [
      {
       "name": "共和县",
       "center": {
        "longitude": 100.620031,
        "latitude": 36.284107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贵南县",
       "center": {
        "longitude": 100.747503,
        "latitude": 35.586714
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贵德县",
       "center": {
        "longitude": 101.433391,
        "latitude": 36.040166
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "同德县",
       "center": {
        "longitude": 100.578051,
        "latitude": 35.25479
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴海县",
       "center": {
        "longitude": 99.987965,
        "latitude": 35.588612
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "黄南藏族自治州",
     "center": {
      "longitude": 102.015248,
      "latitude": 35.519548
     },
     "level": "city",
     "districts": [
      {
       "name": "河南蒙古族自治县",
       "center": {
        "longitude": 101.617503,
        "latitude": 34.734568
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尖扎县",
       "center": {
        "longitude": 102.04014,
        "latitude": 35.943156
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "同仁县",
       "center": {
        "longitude": 102.018323,
        "latitude": 35.516063
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泽库县",
       "center": {
        "longitude": 101.466689,
        "latitude": 35.035313
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "西宁市",
     "center": {
      "longitude": 101.778223,
      "latitude": 36.617134
     },
     "level": "city",
     "districts": [
      {
       "name": "城北区",
       "center": {
        "longitude": 101.766228,
        "latitude": 36.650038
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "城东区",
       "center": {
        "longitude": 101.803717,
        "latitude": 36.599744
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "城中区",
       "center": {
        "longitude": 101.705298,
        "latitude": 36.545652
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "城西区",
       "center": {
        "longitude": 101.765843,
        "latitude": 36.628304
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大通回族土族自治县",
       "center": {
        "longitude": 101.685643,
        "latitude": 36.926954
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湟中县",
       "center": {
        "longitude": 101.571667,
        "latitude": 36.500879
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "湟源县",
       "center": {
        "longitude": 101.256464,
        "latitude": 36.682426
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "玉树藏族自治州",
     "center": {
      "longitude": 97.091934,
      "latitude": 33.011674
     },
     "level": "city",
     "districts": [
      {
       "name": "称多县",
       "center": {
        "longitude": 97.110831,
        "latitude": 33.369218
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "囊谦县",
       "center": {
        "longitude": 96.48943,
        "latitude": 32.203432
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "曲麻莱县",
       "center": {
        "longitude": 95.797367,
        "latitude": 34.126428
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玉树市",
       "center": {
        "longitude": 97.008784,
        "latitude": 32.993106
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "杂多县",
       "center": {
        "longitude": 95.300723,
        "latitude": 32.893185
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "治多县",
       "center": {
        "longitude": 95.61896,
        "latitude": 33.844956
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "陕西省",
   "center": {
    "longitude": 108.954347,
    "latitude": 34.265502
   },
   "level": "province",
   "districts": [
    {
     "name": "安康市",
     "center": {
      "longitude": 109.029113,
      "latitude": 32.68481
     },
     "level": "city",
     "districts": [
      {
       "name": "白河县",
       "center": {
        "longitude": 110.112629,
        "latitude": 32.809026
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汉阴县",
       "center": {
        "longitude": 108.508745,
        "latitude": 32.893026
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汉滨区",
       "center": {
        "longitude": 109.026836,
        "latitude": 32.695172
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岚皋县",
       "center": {
        "longitude": 108.902049,
        "latitude": 32.307001
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁陕县",
       "center": {
        "longitude": 108.314283,
        "latitude": 33.310527
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平利县",
       "center": {
        "longitude": 109.361864,
        "latitude": 32.388854
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石泉县",
       "center": {
        "longitude": 108.247886,
        "latitude": 33.038408
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "旬阳县",
       "center": {
        "longitude": 109.361024,
        "latitude": 32.832012
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇坪县",
       "center": {
        "longitude": 109.526873,
        "latitude": 31.883672
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "紫阳县",
       "center": {
        "longitude": 108.534228,
        "latitude": 32.520246
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "宝鸡市",
     "center": {
      "longitude": 107.237743,
      "latitude": 34.363184
     },
     "level": "city",
     "districts": [
      {
       "name": "陈仓区",
       "center": {
        "longitude": 107.369987,
        "latitude": 34.35147
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤县",
       "center": {
        "longitude": 106.515803,
        "latitude": 33.91091
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤翔县",
       "center": {
        "longitude": 107.400737,
        "latitude": 34.521217
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "扶风县",
       "center": {
        "longitude": 107.900219,
        "latitude": 34.37541
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金台区",
       "center": {
        "longitude": 107.146806,
        "latitude": 34.376069
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麟游县",
       "center": {
        "longitude": 107.793524,
        "latitude": 34.677902
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陇县",
       "center": {
        "longitude": 106.864397,
        "latitude": 34.89305
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "眉县",
       "center": {
        "longitude": 107.749766,
        "latitude": 34.274246
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岐山县",
       "center": {
        "longitude": 107.621053,
        "latitude": 34.443459
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "千阳县",
       "center": {
        "longitude": 107.132441,
        "latitude": 34.642381
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "太白县",
       "center": {
        "longitude": 107.319116,
        "latitude": 34.058401
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "渭滨区",
       "center": {
        "longitude": 107.155344,
        "latitude": 34.355068
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "汉中市",
     "center": {
      "longitude": 107.02305,
      "latitude": 33.067225
     },
     "level": "city",
     "districts": [
      {
       "name": "城固县",
       "center": {
        "longitude": 107.33393,
        "latitude": 33.157131
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "略阳县",
       "center": {
        "longitude": 106.156718,
        "latitude": 33.327281
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "佛坪县",
       "center": {
        "longitude": 107.990538,
        "latitude": 33.524359
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汉台区",
       "center": {
        "longitude": 107.031856,
        "latitude": 33.067771
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "留坝县",
       "center": {
        "longitude": 106.920808,
        "latitude": 33.617571
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "勉县",
       "center": {
        "longitude": 106.673221,
        "latitude": 33.153553
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南郑区",
       "center": {
        "longitude": 106.93623,
        "latitude": 32.999333
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁强县",
       "center": {
        "longitude": 106.257171,
        "latitude": 32.829694
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西乡县",
       "center": {
        "longitude": 107.766613,
        "latitude": 32.983101
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洋县",
       "center": {
        "longitude": 107.545836,
        "latitude": 33.222738
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇巴县",
       "center": {
        "longitude": 107.895035,
        "latitude": 32.536704
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "商洛市",
     "center": {
      "longitude": 109.91857,
      "latitude": 33.872726
     },
     "level": "city",
     "districts": [
      {
       "name": "丹凤县",
       "center": {
        "longitude": 110.32733,
        "latitude": 33.695783
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洛南县",
       "center": {
        "longitude": 110.148508,
        "latitude": 34.090837
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "山阳县",
       "center": {
        "longitude": 109.882289,
        "latitude": 33.532172
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "商南县",
       "center": {
        "longitude": 110.881807,
        "latitude": 33.530995
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "商州区",
       "center": {
        "longitude": 109.941839,
        "latitude": 33.862599
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柞水县",
       "center": {
        "longitude": 109.114206,
        "latitude": 33.68611
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇安县",
       "center": {
        "longitude": 109.152892,
        "latitude": 33.423357
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "铜川市",
     "center": {
      "longitude": 108.945019,
      "latitude": 34.897887
     },
     "level": "city",
     "districts": [
      {
       "name": "王益区",
       "center": {
        "longitude": 109.075578,
        "latitude": 35.068964
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜君县",
       "center": {
        "longitude": 109.116932,
        "latitude": 35.398577
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "耀州区",
       "center": {
        "longitude": 108.980102,
        "latitude": 34.909793
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "印台区",
       "center": {
        "longitude": 109.099974,
        "latitude": 35.114492
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "渭南市",
     "center": {
      "longitude": 109.471094,
      "latitude": 34.52044
     },
     "level": "city",
     "districts": [
      {
       "name": "白水县",
       "center": {
        "longitude": 109.590671,
        "latitude": 35.177451
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "澄城县",
       "center": {
        "longitude": 109.93235,
        "latitude": 35.190245
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大荔县",
       "center": {
        "longitude": 109.941734,
        "latitude": 34.797259
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富平县",
       "center": {
        "longitude": 109.18032,
        "latitude": 34.751077
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "韩城市",
       "center": {
        "longitude": 110.442846,
        "latitude": 35.476788
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "合阳县",
       "center": {
        "longitude": 110.149453,
        "latitude": 35.237988
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华阴市",
       "center": {
        "longitude": 110.092078,
        "latitude": 34.566079
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华州区",
       "center": {
        "longitude": 109.775247,
        "latitude": 34.495915
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临渭区",
       "center": {
        "longitude": 109.510175,
        "latitude": 34.499314
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蒲城县",
       "center": {
        "longitude": 109.586403,
        "latitude": 34.955562
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "潼关县",
       "center": {
        "longitude": 110.246349,
        "latitude": 34.544296
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "西安市",
     "center": {
      "longitude": 108.93977,
      "latitude": 34.341574
     },
     "level": "city",
     "districts": [
      {
       "name": "灞桥区",
       "center": {
        "longitude": 109.064646,
        "latitude": 34.272793
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "碑林区",
       "center": {
        "longitude": 108.94059,
        "latitude": 34.256783
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高陵区",
       "center": {
        "longitude": 109.088297,
        "latitude": 34.534829
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄠邑区",
       "center": {
        "longitude": 108.604894,
        "latitude": 34.109244
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蓝田县",
       "center": {
        "longitude": 109.32345,
        "latitude": 34.151298
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莲湖区",
       "center": {
        "longitude": 108.943895,
        "latitude": 34.265239
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临潼区",
       "center": {
        "longitude": 109.214237,
        "latitude": 34.367069
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "未央区",
       "center": {
        "longitude": 108.946825,
        "latitude": 34.29292
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新城区",
       "center": {
        "longitude": 108.960716,
        "latitude": 34.266447
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阎良区",
       "center": {
        "longitude": 109.226124,
        "latitude": 34.662232
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雁塔区",
       "center": {
        "longitude": 108.944644,
        "latitude": 34.214113
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长安区",
       "center": {
        "longitude": 108.907173,
        "latitude": 34.158926
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "周至县",
       "center": {
        "longitude": 108.222162,
        "latitude": 34.163669
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "咸阳市",
     "center": {
      "longitude": 108.709136,
      "latitude": 34.32987
     },
     "level": "city",
     "districts": [
      {
       "name": "彬县",
       "center": {
        "longitude": 108.077658,
        "latitude": 35.043911
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淳化县",
       "center": {
        "longitude": 108.580681,
        "latitude": 34.79925
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乾县",
       "center": {
        "longitude": 108.239473,
        "latitude": 34.527551
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泾阳县",
       "center": {
        "longitude": 108.842622,
        "latitude": 34.527114
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "礼泉县",
       "center": {
        "longitude": 108.425018,
        "latitude": 34.481764
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秦都区",
       "center": {
        "longitude": 108.706272,
        "latitude": 34.329567
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三原县",
       "center": {
        "longitude": 108.940509,
        "latitude": 34.617381
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "渭城区",
       "center": {
        "longitude": 108.737204,
        "latitude": 34.36195
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武功县",
       "center": {
        "longitude": 108.200398,
        "latitude": 34.260203
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴平市",
       "center": {
        "longitude": 108.490475,
        "latitude": 34.29922
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "旬邑县",
       "center": {
        "longitude": 108.333986,
        "latitude": 35.111978
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "杨陵区",
       "center": {
        "longitude": 108.084731,
        "latitude": 34.272117
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永寿县",
       "center": {
        "longitude": 108.142311,
        "latitude": 34.691979
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长武县",
       "center": {
        "longitude": 107.798757,
        "latitude": 35.205886
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "延安市",
     "center": {
      "longitude": 109.494112,
      "latitude": 36.651381
     },
     "level": "city",
     "districts": [
      {
       "name": "安塞区",
       "center": {
        "longitude": 109.328842,
        "latitude": 36.863853
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宝塔区",
       "center": {
        "longitude": 109.48976,
        "latitude": 36.585472
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富县",
       "center": {
        "longitude": 109.379776,
        "latitude": 35.987953
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "甘泉县",
       "center": {
        "longitude": 109.351019,
        "latitude": 36.276526
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄龙县",
       "center": {
        "longitude": 109.840314,
        "latitude": 35.584743
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黄陵县",
       "center": {
        "longitude": 109.262961,
        "latitude": 35.579427
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洛川县",
       "center": {
        "longitude": 109.432369,
        "latitude": 35.761974
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吴起县",
       "center": {
        "longitude": 108.175933,
        "latitude": 36.927215
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "延川县",
       "center": {
        "longitude": 110.193514,
        "latitude": 36.878117
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "延长县",
       "center": {
        "longitude": 110.012334,
        "latitude": 36.579313
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜川县",
       "center": {
        "longitude": 110.168963,
        "latitude": 36.050178
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "志丹县",
       "center": {
        "longitude": 108.768432,
        "latitude": 36.822194
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "子长县",
       "center": {
        "longitude": 109.675264,
        "latitude": 37.142535
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "榆林市",
     "center": {
      "longitude": 109.734474,
      "latitude": 38.285369
     },
     "level": "city",
     "districts": [
      {
       "name": "定边县",
       "center": {
        "longitude": 107.601267,
        "latitude": 37.594612
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "府谷县",
       "center": {
        "longitude": 111.067276,
        "latitude": 39.028116
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "横山区",
       "center": {
        "longitude": 109.294346,
        "latitude": 37.962208
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "佳县",
       "center": {
        "longitude": 110.491345,
        "latitude": 38.01951
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "靖边县",
       "center": {
        "longitude": 108.793988,
        "latitude": 37.599438
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "米脂县",
       "center": {
        "longitude": 110.183754,
        "latitude": 37.755416
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "清涧县",
       "center": {
        "longitude": 110.121209,
        "latitude": 37.088878
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "神木市",
       "center": {
        "longitude": 110.498939,
        "latitude": 38.842578
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绥德县",
       "center": {
        "longitude": 110.263362,
        "latitude": 37.50294
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吴堡县",
       "center": {
        "longitude": 110.739673,
        "latitude": 37.452067
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "榆阳区",
       "center": {
        "longitude": 109.721069,
        "latitude": 38.277046
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "子洲县",
       "center": {
        "longitude": 110.03525,
        "latitude": 37.610683
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "天津市",
   "center": {
    "longitude": 117.200983,
    "latitude": 39.084158
   },
   "level": "province",
   "districts": [
    {
     "name": "天津城区",
     "center": {
      "longitude": 117.200983,
      "latitude": 39.084158
     },
     "level": "city",
     "districts": [
      {
       "name": "宝坻区",
       "center": {
        "longitude": 117.309874,
        "latitude": 39.717564
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "北辰区",
       "center": {
        "longitude": 117.135488,
        "latitude": 39.224791
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "滨海新区",
       "center": {
        "longitude": 117.698407,
        "latitude": 39.01727
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东丽区",
       "center": {
        "longitude": 117.31362,
        "latitude": 39.086802
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和平区",
       "center": {
        "longitude": 117.214699,
        "latitude": 39.117196
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "河北区",
       "center": {
        "longitude": 117.196648,
        "latitude": 39.147869
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "河东区",
       "center": {
        "longitude": 117.251584,
        "latitude": 39.128294
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "河西区",
       "center": {
        "longitude": 117.223371,
        "latitude": 39.109563
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红桥区",
       "center": {
        "longitude": 117.151533,
        "latitude": 39.167345
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蓟州区",
       "center": {
        "longitude": 117.408296,
        "latitude": 40.045851
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "津南区",
       "center": {
        "longitude": 117.35726,
        "latitude": 38.937928
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "静海区",
       "center": {
        "longitude": 116.974232,
        "latitude": 38.94745
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南开区",
       "center": {
        "longitude": 117.150738,
        "latitude": 39.138205
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁河区",
       "center": {
        "longitude": 117.826724,
        "latitude": 39.330087
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武清区",
       "center": {
        "longitude": 117.044387,
        "latitude": 39.384119
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西青区",
       "center": {
        "longitude": 117.008826,
        "latitude": 39.141152
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "香港特别行政区",
   "center": {
    "longitude": 114.171203,
    "latitude": 22.277468
   },
   "level": "province",
   "districts": [
    {
     "name": "油尖旺区",
     "center": {
      "longitude": 114.173332,
      "latitude": 22.311704
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "湾仔区",
     "center": {
      "longitude": 114.182915,
      "latitude": 22.276389
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "北区",
     "center": {
      "longitude": 114.147364,
      "latitude": 22.496104
     },
     "level": "district",
     "districts": [
      {
       "name": "龙跃头乡",
       "center": {
        "longitude": 114.154061,
        "latitude": 22.500422
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "大埔区",
     "center": {
      "longitude": 114.171743,
      "latitude": 22.445653
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "东区",
     "center": {
      "longitude": 114.226003,
      "latitude": 22.279693
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "观塘区",
     "center": {
      "longitude": 114.214054,
      "latitude": 22.320838
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "黄大仙区",
     "center": {
      "longitude": 114.203886,
      "latitude": 22.336321
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "九龙城区",
     "center": {
      "longitude": 114.192847,
      "latitude": 22.31251
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "葵青区",
     "center": {
      "longitude": 114.139319,
      "latitude": 22.363877
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "离岛区",
     "center": {
      "longitude": 113.94612,
      "latitude": 22.286408
     },
     "level": "district",
     "districts": [
      {
       "name": "梅窝乡",
       "center": {
        "longitude": 114.000813,
        "latitude": 22.264829
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "南区",
     "center": {
      "longitude": 114.160012,
      "latitude": 22.245897
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "荃湾区",
     "center": {
      "longitude": 114.121079,
      "latitude": 22.368306
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "沙田区",
     "center": {
      "longitude": 114.195365,
      "latitude": 22.379532
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "深水埗区",
     "center": {
      "longitude": 114.163242,
      "latitude": 22.333854
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "屯门区",
     "center": {
      "longitude": 113.976574,
      "latitude": 22.393844
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "西贡区",
     "center": {
      "longitude": 114.264645,
      "latitude": 22.314213
     },
     "level": "district",
     "districts": []
    },
    {
     "name": "元朗区",
     "center": {
      "longitude": 114.032438,
      "latitude": 22.441428
     },
     "level": "district",
     "districts": [
      {
       "name": "逢吉乡",
       "center": {
        "longitude": 114.063044,
        "latitude": 22.45481
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "中西区",
     "center": {
      "longitude": 114.154373,
      "latitude": 22.281981
     },
     "level": "district",
     "districts": []
    }
   ]
  },
  {
   "name": "四川省",
   "center": {
    "longitude": 104.075809,
    "latitude": 30.651239
   },
   "level": "province",
   "districts": [
    {
     "name": "阿坝藏族羌族自治州",
     "center": {
      "longitude": 102.224653,
      "latitude": 31.899413
     },
     "level": "city",
     "districts": [
      {
       "name": "阿坝县",
       "center": {
        "longitude": 101.706655,
        "latitude": 32.902459
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红原县",
       "center": {
        "longitude": 102.544405,
        "latitude": 32.790891
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "黑水县",
       "center": {
        "longitude": 102.990108,
        "latitude": 32.061895
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金川县",
       "center": {
        "longitude": 102.063829,
        "latitude": 31.476277
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "九寨沟县",
       "center": {
        "longitude": 104.243841,
        "latitude": 33.252056
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "理县",
       "center": {
        "longitude": 103.164661,
        "latitude": 31.435174
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "马尔康市",
       "center": {
        "longitude": 102.20652,
        "latitude": 31.905693
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "茂县",
       "center": {
        "longitude": 103.853363,
        "latitude": 31.681547
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "壤塘县",
       "center": {
        "longitude": 100.978526,
        "latitude": 32.265796
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "若尔盖县",
       "center": {
        "longitude": 102.967826,
        "latitude": 33.578159
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "松潘县",
       "center": {
        "longitude": 103.604698,
        "latitude": 32.655325
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汶川县",
       "center": {
        "longitude": 103.590179,
        "latitude": 31.476854
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "小金县",
       "center": {
        "longitude": 102.362984,
        "latitude": 30.995823
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "巴中市",
     "center": {
      "longitude": 106.747477,
      "latitude": 31.867903
     },
     "level": "city",
     "districts": [
      {
       "name": "巴州区",
       "center": {
        "longitude": 106.768878,
        "latitude": 31.851478
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "恩阳区",
       "center": {
        "longitude": 106.654386,
        "latitude": 31.787186
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南江县",
       "center": {
        "longitude": 106.828697,
        "latitude": 32.346589
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平昌县",
       "center": {
        "longitude": 107.104008,
        "latitude": 31.560874
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通江县",
       "center": {
        "longitude": 107.245033,
        "latitude": 31.911705
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "成都市",
     "center": {
      "longitude": 104.066794,
      "latitude": 30.572893
     },
     "level": "city",
     "districts": [
      {
       "name": "成华区",
       "center": {
        "longitude": 104.101515,
        "latitude": 30.659966
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "崇州市",
       "center": {
        "longitude": 103.673001,
        "latitude": 30.630122
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大邑县",
       "center": {
        "longitude": 103.511865,
        "latitude": 30.572268
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "都江堰市",
       "center": {
        "longitude": 103.647153,
        "latitude": 30.988767
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "简阳市",
       "center": {
        "longitude": 104.54722,
        "latitude": 30.411264
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金堂县",
       "center": {
        "longitude": 104.411976,
        "latitude": 30.861979
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金牛区",
       "center": {
        "longitude": 104.052236,
        "latitude": 30.691359
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "锦江区",
       "center": {
        "longitude": 104.117022,
        "latitude": 30.598158
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙泉驿区",
       "center": {
        "longitude": 104.274632,
        "latitude": 30.556506
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "彭州市",
       "center": {
        "longitude": 103.957983,
        "latitude": 30.990212
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "郫都区",
       "center": {
        "longitude": 103.901091,
        "latitude": 30.795854
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蒲江县",
       "center": {
        "longitude": 103.506498,
        "latitude": 30.196788
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青白江区",
       "center": {
        "longitude": 104.250945,
        "latitude": 30.878629
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青羊区",
       "center": {
        "longitude": 104.061442,
        "latitude": 30.673914
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邛崃市",
       "center": {
        "longitude": 103.464207,
        "latitude": 30.410324
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双流区",
       "center": {
        "longitude": 103.923566,
        "latitude": 30.574449
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "温江区",
       "center": {
        "longitude": 103.856646,
        "latitude": 30.682203
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武侯区",
       "center": {
        "longitude": 104.043235,
        "latitude": 30.641907
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新都区",
       "center": {
        "longitude": 104.158705,
        "latitude": 30.823498
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新津县",
       "center": {
        "longitude": 103.811286,
        "latitude": 30.410346
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "德阳市",
     "center": {
      "longitude": 104.397894,
      "latitude": 31.126855
     },
     "level": "city",
     "districts": [
      {
       "name": "广汉市",
       "center": {
        "longitude": 104.282429,
        "latitude": 30.977119
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "旌阳区",
       "center": {
        "longitude": 104.416966,
        "latitude": 31.142633
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "罗江区",
       "center": {
        "longitude": 104.510249,
        "latitude": 31.317045
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绵竹市",
       "center": {
        "longitude": 104.22075,
        "latitude": 31.338077
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "什邡市",
       "center": {
        "longitude": 104.167501,
        "latitude": 31.12678
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "中江县",
       "center": {
        "longitude": 104.678751,
        "latitude": 31.03307
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "达州市",
     "center": {
      "longitude": 107.467758,
      "latitude": 31.209121
     },
     "level": "city",
     "districts": [
      {
       "name": "达川区",
       "center": {
        "longitude": 107.511749,
        "latitude": 31.196157
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大竹县",
       "center": {
        "longitude": 107.204795,
        "latitude": 30.73641
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开江县",
       "center": {
        "longitude": 107.868736,
        "latitude": 31.082986
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "渠县",
       "center": {
        "longitude": 106.97303,
        "latitude": 30.836618
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通川区",
       "center": {
        "longitude": 107.504928,
        "latitude": 31.214715
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "万源市",
       "center": {
        "longitude": 108.034657,
        "latitude": 32.081631
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宣汉县",
       "center": {
        "longitude": 107.72719,
        "latitude": 31.353835
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "广元市",
     "center": {
      "longitude": 105.843357,
      "latitude": 32.435435
     },
     "level": "city",
     "districts": [
      {
       "name": "苍溪县",
       "center": {
        "longitude": 105.934756,
        "latitude": 31.731709
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "朝天区",
       "center": {
        "longitude": 105.882642,
        "latitude": 32.651336
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "剑阁县",
       "center": {
        "longitude": 105.524766,
        "latitude": 32.287722
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "利州区",
       "center": {
        "longitude": 105.845307,
        "latitude": 32.433756
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青川县",
       "center": {
        "longitude": 105.238842,
        "latitude": 32.575484
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "旺苍县",
       "center": {
        "longitude": 106.289983,
        "latitude": 32.229058
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昭化区",
       "center": {
        "longitude": 105.962819,
        "latitude": 32.323256
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "广安市",
     "center": {
      "longitude": 106.633088,
      "latitude": 30.456224
     },
     "level": "city",
     "districts": [
      {
       "name": "广安区",
       "center": {
        "longitude": 106.641662,
        "latitude": 30.473913
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华蓥市",
       "center": {
        "longitude": 106.7831,
        "latitude": 30.390188
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "邻水县",
       "center": {
        "longitude": 106.93038,
        "latitude": 30.334768
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "前锋区",
       "center": {
        "longitude": 106.886143,
        "latitude": 30.495804
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武胜县",
       "center": {
        "longitude": 106.295764,
        "latitude": 30.348772
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岳池县",
       "center": {
        "longitude": 106.440114,
        "latitude": 30.537863
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "甘孜藏族自治州",
     "center": {
      "longitude": 101.96231,
      "latitude": 30.04952
     },
     "level": "city",
     "districts": [
      {
       "name": "巴塘县",
       "center": {
        "longitude": 99.110712,
        "latitude": 30.004677
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "白玉县",
       "center": {
        "longitude": 98.824182,
        "latitude": 31.209913
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丹巴县",
       "center": {
        "longitude": 101.890358,
        "latitude": 30.878577
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "道孚县",
       "center": {
        "longitude": 101.125237,
        "latitude": 30.979545
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "稻城县",
       "center": {
        "longitude": 100.298403,
        "latitude": 29.037007
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "得荣县",
       "center": {
        "longitude": 99.286335,
        "latitude": 28.713036
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "德格县",
       "center": {
        "longitude": 98.580914,
        "latitude": 31.806118
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "甘孜县",
       "center": {
        "longitude": 99.99267,
        "latitude": 31.622933
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "九龙县",
       "center": {
        "longitude": 101.507294,
        "latitude": 29.000347
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "康定市",
       "center": {
        "longitude": 101.957146,
        "latitude": 29.998435
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "理塘县",
       "center": {
        "longitude": 100.269817,
        "latitude": 29.996049
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泸定县",
       "center": {
        "longitude": 102.234617,
        "latitude": 29.91416
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "炉霍县",
       "center": {
        "longitude": 100.676372,
        "latitude": 31.39179
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "色达县",
       "center": {
        "longitude": 100.332743,
        "latitude": 32.268129
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石渠县",
       "center": {
        "longitude": 98.102914,
        "latitude": 32.97896
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乡城县",
       "center": {
        "longitude": 99.798435,
        "latitude": 28.931172
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新龙县",
       "center": {
        "longitude": 100.311368,
        "latitude": 30.939169
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雅江县",
       "center": {
        "longitude": 101.014425,
        "latitude": 30.031533
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "凉山彝族自治州",
     "center": {
      "longitude": 102.267712,
      "latitude": 27.88157
     },
     "level": "city",
     "districts": [
      {
       "name": "布拖县",
       "center": {
        "longitude": 102.812061,
        "latitude": 27.706061
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "德昌县",
       "center": {
        "longitude": 102.17567,
        "latitude": 27.402839
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "甘洛县",
       "center": {
        "longitude": 102.771504,
        "latitude": 28.959157
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "会东县",
       "center": {
        "longitude": 102.57796,
        "latitude": 26.634669
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "会理县",
       "center": {
        "longitude": 102.244683,
        "latitude": 26.655026
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金阳县",
       "center": {
        "longitude": 103.248772,
        "latitude": 27.69686
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雷波县",
       "center": {
        "longitude": 103.571696,
        "latitude": 28.262682
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "美姑县",
       "center": {
        "longitude": 103.132179,
        "latitude": 28.32864
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "冕宁县",
       "center": {
        "longitude": 102.17701,
        "latitude": 28.549656
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "木里藏族自治县",
       "center": {
        "longitude": 101.280205,
        "latitude": 27.928835
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁南县",
       "center": {
        "longitude": 102.751745,
        "latitude": 27.061189
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "普格县",
       "center": {
        "longitude": 102.540901,
        "latitude": 27.376413
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西昌市",
       "center": {
        "longitude": 102.264449,
        "latitude": 27.894504
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "喜德县",
       "center": {
        "longitude": 102.412518,
        "latitude": 28.306726
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盐源县",
       "center": {
        "longitude": 101.509188,
        "latitude": 27.422645
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "越西县",
       "center": {
        "longitude": 102.50768,
        "latitude": 28.639801
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昭觉县",
       "center": {
        "longitude": 102.840264,
        "latitude": 28.015333
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "乐山市",
     "center": {
      "longitude": 103.765678,
      "latitude": 29.552115
     },
     "level": "city",
     "districts": [
      {
       "name": "峨眉山市",
       "center": {
        "longitude": 103.484503,
        "latitude": 29.601198
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "峨边彝族自治县",
       "center": {
        "longitude": 103.262048,
        "latitude": 29.230425
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "夹江县",
       "center": {
        "longitude": 103.571656,
        "latitude": 29.73763
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "犍为县",
       "center": {
        "longitude": 103.949326,
        "latitude": 29.20817
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "井研县",
       "center": {
        "longitude": 104.069726,
        "latitude": 29.651287
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金口河区",
       "center": {
        "longitude": 103.07862,
        "latitude": 29.244345
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "马边彝族自治县",
       "center": {
        "longitude": 103.546347,
        "latitude": 28.83552
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沐川县",
       "center": {
        "longitude": 103.902334,
        "latitude": 28.956647
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙湾区",
       "center": {
        "longitude": 103.549991,
        "latitude": 29.413091
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "市中区",
       "center": {
        "longitude": 103.761329,
        "latitude": 29.555374
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五通桥区",
       "center": {
        "longitude": 103.818014,
        "latitude": 29.406945
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "绵阳市",
     "center": {
      "longitude": 104.679004,
      "latitude": 31.467459
     },
     "level": "city",
     "districts": [
      {
       "name": "安州区",
       "center": {
        "longitude": 104.567187,
        "latitude": 31.534886
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "北川羌族自治县",
       "center": {
        "longitude": 104.46797,
        "latitude": 31.617203
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "涪城区",
       "center": {
        "longitude": 104.756944,
        "latitude": 31.455101
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江油市",
       "center": {
        "longitude": 104.745915,
        "latitude": 31.778026
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平武县",
       "center": {
        "longitude": 104.555583,
        "latitude": 32.409675
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三台县",
       "center": {
        "longitude": 105.094586,
        "latitude": 31.095979
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盐亭县",
       "center": {
        "longitude": 105.389453,
        "latitude": 31.208362
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "游仙区",
       "center": {
        "longitude": 104.766392,
        "latitude": 31.473779
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "梓潼县",
       "center": {
        "longitude": 105.170845,
        "latitude": 31.642718
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "眉山市",
     "center": {
      "longitude": 103.848403,
      "latitude": 30.076994
     },
     "level": "city",
     "districts": [
      {
       "name": "丹棱县",
       "center": {
        "longitude": 103.512783,
        "latitude": 30.01521
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东坡区",
       "center": {
        "longitude": 103.831863,
        "latitude": 30.042308
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洪雅县",
       "center": {
        "longitude": 103.372863,
        "latitude": 29.90489
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "彭山区",
       "center": {
        "longitude": 103.872949,
        "latitude": 30.193056
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青神县",
       "center": {
        "longitude": 103.846688,
        "latitude": 29.831357
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仁寿县",
       "center": {
        "longitude": 104.133995,
        "latitude": 29.995635
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "泸州市",
     "center": {
      "longitude": 105.442285,
      "latitude": 28.871805
     },
     "level": "city",
     "districts": [
      {
       "name": "古蔺县",
       "center": {
        "longitude": 105.812601,
        "latitude": 28.038801
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "合江县",
       "center": {
        "longitude": 105.830986,
        "latitude": 28.811164
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江阳区",
       "center": {
        "longitude": 105.434982,
        "latitude": 28.87881
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙马潭区",
       "center": {
        "longitude": 105.437751,
        "latitude": 28.913257
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泸县",
       "center": {
        "longitude": 105.381893,
        "latitude": 29.151534
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "纳溪区",
       "center": {
        "longitude": 105.371505,
        "latitude": 28.773134
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "叙永县",
       "center": {
        "longitude": 105.444765,
        "latitude": 28.155801
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "南充市",
     "center": {
      "longitude": 106.110698,
      "latitude": 30.837793
     },
     "level": "city",
     "districts": [
      {
       "name": "高坪区",
       "center": {
        "longitude": 106.118808,
        "latitude": 30.781623
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嘉陵区",
       "center": {
        "longitude": 106.071876,
        "latitude": 30.758823
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阆中市",
       "center": {
        "longitude": 106.005046,
        "latitude": 31.558356
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南部县",
       "center": {
        "longitude": 106.036584,
        "latitude": 31.347467
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蓬安县",
       "center": {
        "longitude": 106.412136,
        "latitude": 31.029091
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "顺庆区",
       "center": {
        "longitude": 106.09245,
        "latitude": 30.796803
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西充县",
       "center": {
        "longitude": 105.90087,
        "latitude": 30.995683
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仪陇县",
       "center": {
        "longitude": 106.303042,
        "latitude": 31.271561
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "营山县",
       "center": {
        "longitude": 106.565519,
        "latitude": 31.076579
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "攀枝花市",
     "center": {
      "longitude": 101.718637,
      "latitude": 26.582347
     },
     "level": "city",
     "districts": [
      {
       "name": "东区",
       "center": {
        "longitude": 101.704109,
        "latitude": 26.546491
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "米易县",
       "center": {
        "longitude": 102.112895,
        "latitude": 26.897694
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仁和区",
       "center": {
        "longitude": 101.738528,
        "latitude": 26.497765
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西区",
       "center": {
        "longitude": 101.630619,
        "latitude": 26.597781
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盐边县",
       "center": {
        "longitude": 101.855071,
        "latitude": 26.683213
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "内江市",
     "center": {
      "longitude": 105.058432,
      "latitude": 29.580228
     },
     "level": "city",
     "districts": [
      {
       "name": "东兴区",
       "center": {
        "longitude": 105.075489,
        "latitude": 29.592756
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隆昌市",
       "center": {
        "longitude": 105.287612,
        "latitude": 29.339476
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "市中区",
       "center": {
        "longitude": 105.067597,
        "latitude": 29.587053
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "威远县",
       "center": {
        "longitude": 104.668879,
        "latitude": 29.52744
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "资中县",
       "center": {
        "longitude": 104.851944,
        "latitude": 29.764059
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "遂宁市",
     "center": {
      "longitude": 105.592803,
      "latitude": 30.53292
     },
     "level": "city",
     "districts": [
      {
       "name": "安居区",
       "center": {
        "longitude": 105.456342,
        "latitude": 30.355379
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "船山区",
       "center": {
        "longitude": 105.568297,
        "latitude": 30.525475
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大英县",
       "center": {
        "longitude": 105.236923,
        "latitude": 30.594409
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蓬溪县",
       "center": {
        "longitude": 105.70757,
        "latitude": 30.757575
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "射洪县",
       "center": {
        "longitude": 105.388412,
        "latitude": 30.871131
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "雅安市",
     "center": {
      "longitude": 103.042375,
      "latitude": 30.010602
     },
     "level": "city",
     "districts": [
      {
       "name": "宝兴县",
       "center": {
        "longitude": 102.815403,
        "latitude": 30.37641
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "汉源县",
       "center": {
        "longitude": 102.645467,
        "latitude": 29.347192
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芦山县",
       "center": {
        "longitude": 102.932385,
        "latitude": 30.142307
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "名山区",
       "center": {
        "longitude": 103.109184,
        "latitude": 30.069954
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石棉县",
       "center": {
        "longitude": 102.359462,
        "latitude": 29.227874
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天全县",
       "center": {
        "longitude": 102.758317,
        "latitude": 30.066712
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荥经县",
       "center": {
        "longitude": 102.846737,
        "latitude": 29.792931
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雨城区",
       "center": {
        "longitude": 103.033026,
        "latitude": 30.005461
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "宜宾市",
     "center": {
      "longitude": 104.642845,
      "latitude": 28.752134
     },
     "level": "city",
     "districts": [
      {
       "name": "翠屏区",
       "center": {
        "longitude": 104.620009,
        "latitude": 28.765689
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "高县",
       "center": {
        "longitude": 104.517748,
        "latitude": 28.436166
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "珙县",
       "center": {
        "longitude": 104.709202,
        "latitude": 28.43863
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江安县",
       "center": {
        "longitude": 105.066879,
        "latitude": 28.723855
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南溪区",
       "center": {
        "longitude": 104.969152,
        "latitude": 28.846382
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "屏山县",
       "center": {
        "longitude": 104.345974,
        "latitude": 28.828482
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兴文县",
       "center": {
        "longitude": 105.236325,
        "latitude": 28.303614
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜宾县",
       "center": {
        "longitude": 104.533212,
        "latitude": 28.690045
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "筠连县",
       "center": {
        "longitude": 104.512025,
        "latitude": 28.167831
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长宁县",
       "center": {
        "longitude": 104.921174,
        "latitude": 28.582169
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "资阳市",
     "center": {
      "longitude": 104.627636,
      "latitude": 30.128901
     },
     "level": "city",
     "districts": [
      {
       "name": "安岳县",
       "center": {
        "longitude": 105.35534,
        "latitude": 30.103107
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乐至县",
       "center": {
        "longitude": 105.02019,
        "latitude": 30.276121
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "雁江区",
       "center": {
        "longitude": 104.677091,
        "latitude": 30.108216
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "自贡市",
     "center": {
      "longitude": 104.778442,
      "latitude": 29.33903
     },
     "level": "city",
     "districts": [
      {
       "name": "大安区",
       "center": {
        "longitude": 104.773994,
        "latitude": 29.363702
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富顺县",
       "center": {
        "longitude": 104.975048,
        "latitude": 29.181429
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贡井区",
       "center": {
        "longitude": 104.715288,
        "latitude": 29.345313
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "荣县",
       "center": {
        "longitude": 104.417493,
        "latitude": 29.445479
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沿滩区",
       "center": {
        "longitude": 104.874079,
        "latitude": 29.272586
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "自流井区",
       "center": {
        "longitude": 104.777191,
        "latitude": 29.337429
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "西藏自治区",
   "center": {
    "longitude": 91.117525,
    "latitude": 29.647535
   },
   "level": "province",
   "districts": [
    {
     "name": "阿里地区",
     "center": {
      "longitude": 80.105804,
      "latitude": 32.501111
     },
     "level": "city",
     "districts": [
      {
       "name": "措勤县",
       "center": {
        "longitude": 85.151455,
        "latitude": 31.017312
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "噶尔县",
       "center": {
        "longitude": 80.096419,
        "latitude": 32.491488
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "改则县",
       "center": {
        "longitude": 84.06259,
        "latitude": 32.302713
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "革吉县",
       "center": {
        "longitude": 81.145433,
        "latitude": 32.387233
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "普兰县",
       "center": {
        "longitude": 81.176237,
        "latitude": 30.294402
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "日土县",
       "center": {
        "longitude": 79.732427,
        "latitude": 33.381359
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "札达县",
       "center": {
        "longitude": 79.802706,
        "latitude": 31.479216
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "昌都市",
     "center": {
      "longitude": 97.17202,
      "latitude": 31.140969
     },
     "level": "city",
     "districts": [
      {
       "name": "八宿县",
       "center": {
        "longitude": 96.917836,
        "latitude": 30.053209
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "边坝县",
       "center": {
        "longitude": 94.7078,
        "latitude": 30.933652
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "察雅县",
       "center": {
        "longitude": 97.568752,
        "latitude": 30.653943
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丁青县",
       "center": {
        "longitude": 95.619868,
        "latitude": 31.409024
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贡觉县",
       "center": {
        "longitude": 98.27097,
        "latitude": 30.860099
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江达县",
       "center": {
        "longitude": 98.21843,
        "latitude": 31.499202
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "卡若区",
       "center": {
        "longitude": 97.196021,
        "latitude": 31.112087
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "类乌齐县",
       "center": {
        "longitude": 96.600246,
        "latitude": 31.211601
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洛隆县",
       "center": {
        "longitude": 95.825197,
        "latitude": 30.741845
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芒康县",
       "center": {
        "longitude": 98.593113,
        "latitude": 29.679907
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "左贡县",
       "center": {
        "longitude": 97.841022,
        "latitude": 29.671069
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "拉萨市",
     "center": {
      "longitude": 91.172148,
      "latitude": 29.652341
     },
     "level": "city",
     "districts": [
      {
       "name": "达孜县",
       "center": {
        "longitude": 91.349867,
        "latitude": 29.66941
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "城关区",
       "center": {
        "longitude": 91.140552,
        "latitude": 29.654838
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "当雄县",
       "center": {
        "longitude": 91.101162,
        "latitude": 30.473118
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "堆龙德庆区",
       "center": {
        "longitude": 91.003339,
        "latitude": 29.646063
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "林周县",
       "center": {
        "longitude": 91.265287,
        "latitude": 29.893545
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "墨竹工卡县",
       "center": {
        "longitude": 91.730732,
        "latitude": 29.834111
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尼木县",
       "center": {
        "longitude": 90.164524,
        "latitude": 29.431831
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "曲水县",
       "center": {
        "longitude": 90.743853,
        "latitude": 29.353058
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "林芝市",
     "center": {
      "longitude": 94.36149,
      "latitude": 29.649128
     },
     "level": "city",
     "districts": [
      {
       "name": "巴宜区",
       "center": {
        "longitude": 94.361094,
        "latitude": 29.636576
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "察隅县",
       "center": {
        "longitude": 97.466919,
        "latitude": 28.66128
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "波密县",
       "center": {
        "longitude": 95.767913,
        "latitude": 29.859028
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "工布江达县",
       "center": {
        "longitude": 93.246077,
        "latitude": 29.88528
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "朗县",
       "center": {
        "longitude": 93.074702,
        "latitude": 29.046337
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "米林县",
       "center": {
        "longitude": 94.213679,
        "latitude": 29.213811
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "墨脱县",
       "center": {
        "longitude": 95.333197,
        "latitude": 29.325298
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "那曲地区",
     "center": {
      "longitude": 92.052064,
      "latitude": 31.476479
     },
     "level": "city",
     "districts": [
      {
       "name": "安多县",
       "center": {
        "longitude": 91.68233,
        "latitude": 32.265176
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巴青县",
       "center": {
        "longitude": 94.053438,
        "latitude": 31.91847
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "班戈县",
       "center": {
        "longitude": 90.009957,
        "latitude": 31.392411
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "比如县",
       "center": {
        "longitude": 93.679639,
        "latitude": 31.480249
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嘉黎县",
       "center": {
        "longitude": 93.232528,
        "latitude": 30.640814
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "那曲县",
       "center": {
        "longitude": 92.0535,
        "latitude": 31.469643
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尼玛县",
       "center": {
        "longitude": 87.236772,
        "latitude": 31.784701
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "聂荣县",
       "center": {
        "longitude": 92.303377,
        "latitude": 32.10775
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "申扎县",
       "center": {
        "longitude": 88.709852,
        "latitude": 30.930505
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双湖县",
       "center": {
        "longitude": 88.837641,
        "latitude": 33.188514
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "索县",
       "center": {
        "longitude": 93.785516,
        "latitude": 31.886671
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "山南市",
     "center": {
      "longitude": 91.773134,
      "latitude": 29.237137
     },
     "level": "city",
     "districts": [
      {
       "name": "措美县",
       "center": {
        "longitude": 91.433509,
        "latitude": 28.438202
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "错那县",
       "center": {
        "longitude": 91.960132,
        "latitude": 27.991707
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贡嘎县",
       "center": {
        "longitude": 90.98414,
        "latitude": 29.289455
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "加查县",
       "center": {
        "longitude": 92.593993,
        "latitude": 29.14029
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浪卡子县",
       "center": {
        "longitude": 90.397977,
        "latitude": 28.968031
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隆子县",
       "center": {
        "longitude": 92.463308,
        "latitude": 28.408548
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洛扎县",
       "center": {
        "longitude": 90.859992,
        "latitude": 28.385713
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乃东区",
       "center": {
        "longitude": 91.761538,
        "latitude": 29.224904
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "曲松县",
       "center": {
        "longitude": 92.203738,
        "latitude": 29.062826
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "琼结县",
       "center": {
        "longitude": 91.683881,
        "latitude": 29.024625
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桑日县",
       "center": {
        "longitude": 92.015818,
        "latitude": 29.259189
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "扎囊县",
       "center": {
        "longitude": 91.33725,
        "latitude": 29.245113
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "日喀则市",
     "center": {
      "longitude": 88.880583,
      "latitude": 29.266869
     },
     "level": "city",
     "districts": [
      {
       "name": "昂仁县",
       "center": {
        "longitude": 87.236051,
        "latitude": 29.294802
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "白朗县",
       "center": {
        "longitude": 89.261977,
        "latitude": 29.107688
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "定结县",
       "center": {
        "longitude": 87.765872,
        "latitude": 28.364159
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "定日县",
       "center": {
        "longitude": 87.12612,
        "latitude": 28.658743
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岗巴县",
       "center": {
        "longitude": 88.520031,
        "latitude": 28.274601
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉隆县",
       "center": {
        "longitude": 85.297534,
        "latitude": 28.852393
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江孜县",
       "center": {
        "longitude": 89.605627,
        "latitude": 28.911626
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "康马县",
       "center": {
        "longitude": 89.681663,
        "latitude": 28.555627
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "拉孜县",
       "center": {
        "longitude": 87.63704,
        "latitude": 29.081659
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南木林县",
       "center": {
        "longitude": 89.099242,
        "latitude": 29.68233
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "聂拉木县",
       "center": {
        "longitude": 85.982237,
        "latitude": 28.155186
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "萨嘎县",
       "center": {
        "longitude": 85.232941,
        "latitude": 29.328818
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "萨迦县",
       "center": {
        "longitude": 88.021674,
        "latitude": 28.899664
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仁布县",
       "center": {
        "longitude": 89.841983,
        "latitude": 29.230933
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桑珠孜区",
       "center": {
        "longitude": 88.898483,
        "latitude": 29.24779
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "谢通门县",
       "center": {
        "longitude": 88.261664,
        "latitude": 29.432476
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "亚东县",
       "center": {
        "longitude": 88.907093,
        "latitude": 27.484806
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仲巴县",
       "center": {
        "longitude": 84.03153,
        "latitude": 29.770279
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "新疆维吾尔自治区",
   "center": {
    "longitude": 87.627704,
    "latitude": 43.793026
   },
   "level": "province",
   "districts": [
    {
     "name": "阿克苏地区",
     "center": {
      "longitude": 80.260605,
      "latitude": 41.168779
     },
     "level": "city",
     "districts": [
      {
       "name": "阿克苏市",
       "center": {
        "longitude": 80.263387,
        "latitude": 41.167548
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阿瓦提县",
       "center": {
        "longitude": 80.375053,
        "latitude": 40.643647
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "拜城县",
       "center": {
        "longitude": 81.85148,
        "latitude": 41.795912
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柯坪县",
       "center": {
        "longitude": 79.054497,
        "latitude": 40.501936
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "库车县",
       "center": {
        "longitude": 82.987312,
        "latitude": 41.714696
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙雅县",
       "center": {
        "longitude": 82.781818,
        "latitude": 41.221666
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "温宿县",
       "center": {
        "longitude": 80.238959,
        "latitude": 41.276688
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌什县",
       "center": {
        "longitude": 79.224616,
        "latitude": 41.222319
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新和县",
       "center": {
        "longitude": 82.618736,
        "latitude": 41.551206
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "阿勒泰地区",
     "center": {
      "longitude": 88.141253,
      "latitude": 47.844924
     },
     "level": "city",
     "districts": [
      {
       "name": "阿勒泰市",
       "center": {
        "longitude": 88.131842,
        "latitude": 47.827308
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "布尔津县",
       "center": {
        "longitude": 86.874923,
        "latitude": 47.702163
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "福海县",
       "center": {
        "longitude": 87.486703,
        "latitude": 47.111918
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富蕴县",
       "center": {
        "longitude": 89.525504,
        "latitude": 46.994115
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "哈巴河县",
       "center": {
        "longitude": 86.418621,
        "latitude": 48.060846
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉木乃县",
       "center": {
        "longitude": 85.874096,
        "latitude": 47.443101
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青河县",
       "center": {
        "longitude": 90.37555,
        "latitude": 46.679113
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "昌吉回族自治州",
     "center": {
      "longitude": 87.308224,
      "latitude": 44.011182
     },
     "level": "city",
     "districts": [
      {
       "name": "昌吉市",
       "center": {
        "longitude": 87.267532,
        "latitude": 44.014435
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阜康市",
       "center": {
        "longitude": 87.952991,
        "latitude": 44.164402
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "呼图壁县",
       "center": {
        "longitude": 86.871584,
        "latitude": 44.179361
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吉木萨尔县",
       "center": {
        "longitude": 89.180437,
        "latitude": 44.000497
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玛纳斯县",
       "center": {
        "longitude": 86.20368,
        "latitude": 44.284722
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "木垒哈萨克自治县",
       "center": {
        "longitude": 90.286028,
        "latitude": 43.834689
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "奇台县",
       "center": {
        "longitude": 89.593967,
        "latitude": 44.022066
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "巴音郭楞蒙古自治州",
     "center": {
      "longitude": 86.145297,
      "latitude": 41.764115
     },
     "level": "city",
     "districts": [
      {
       "name": "博湖县",
       "center": {
        "longitude": 86.631997,
        "latitude": 41.980152
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和静县",
       "center": {
        "longitude": 86.384065,
        "latitude": 42.323625
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和硕县",
       "center": {
        "longitude": 86.876799,
        "latitude": 42.284331
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "库尔勒市",
       "center": {
        "longitude": 86.174633,
        "latitude": 41.725891
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "轮台县",
       "center": {
        "longitude": 84.252156,
        "latitude": 41.777702
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "且末县",
       "center": {
        "longitude": 85.529702,
        "latitude": 38.145485
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "若羌县",
       "center": {
        "longitude": 88.167152,
        "latitude": 39.023241
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尉犁县",
       "center": {
        "longitude": 86.261321,
        "latitude": 41.343933
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "焉耆回族自治县",
       "center": {
        "longitude": 86.574067,
        "latitude": 42.059759
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "博尔塔拉蒙古自治州",
     "center": {
      "longitude": 82.066363,
      "latitude": 44.906039
     },
     "level": "city",
     "districts": [
      {
       "name": "阿拉山口市",
       "center": {
        "longitude": 82.559396,
        "latitude": 45.172227
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "博乐市",
       "center": {
        "longitude": 82.051004,
        "latitude": 44.853869
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "精河县",
       "center": {
        "longitude": 82.890656,
        "latitude": 44.599393
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "温泉县",
       "center": {
        "longitude": 81.024816,
        "latitude": 44.968856
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "哈密市",
     "center": {
      "longitude": 93.515224,
      "latitude": 42.819541
     },
     "level": "city",
     "districts": [
      {
       "name": "巴里坤哈萨克自治县",
       "center": {
        "longitude": 93.010383,
        "latitude": 43.599929
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伊吾县",
       "center": {
        "longitude": 94.697074,
        "latitude": 43.254978
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伊州区",
       "center": {
        "longitude": 93.514797,
        "latitude": 42.827254
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "和田地区",
     "center": {
      "longitude": 79.922211,
      "latitude": 37.114157
     },
     "level": "city",
     "districts": [
      {
       "name": "策勒县",
       "center": {
        "longitude": 80.806159,
        "latitude": 36.998335
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和田市",
       "center": {
        "longitude": 79.913534,
        "latitude": 37.112148
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和田县",
       "center": {
        "longitude": 79.81907,
        "latitude": 37.120031
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洛浦县",
       "center": {
        "longitude": 80.188986,
        "latitude": 37.073667
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "民丰县",
       "center": {
        "longitude": 82.695861,
        "latitude": 37.06408
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "墨玉县",
       "center": {
        "longitude": 79.728683,
        "latitude": 37.277143
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "皮山县",
       "center": {
        "longitude": 78.283669,
        "latitude": 37.62145
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "于田县",
       "center": {
        "longitude": 81.677418,
        "latitude": 36.85708
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "克孜勒苏柯尔克孜自治州",
     "center": {
      "longitude": 76.167819,
      "latitude": 39.714526
     },
     "level": "city",
     "districts": [
      {
       "name": "阿克陶县",
       "center": {
        "longitude": 75.947396,
        "latitude": 39.147785
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阿合奇县",
       "center": {
        "longitude": 78.446253,
        "latitude": 40.936936
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "阿图什市",
       "center": {
        "longitude": 76.1684,
        "latitude": 39.71616
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌恰县",
       "center": {
        "longitude": 75.259227,
        "latitude": 39.71931
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "克拉玛依市",
     "center": {
      "longitude": 84.889207,
      "latitude": 45.579888
     },
     "level": "city",
     "districts": [
      {
       "name": "白碱滩区",
       "center": {
        "longitude": 85.131696,
        "latitude": 45.687854
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "独山子区",
       "center": {
        "longitude": 84.886974,
        "latitude": 44.328095
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "克拉玛依区",
       "center": {
        "longitude": 84.867844,
        "latitude": 45.602525
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌尔禾区",
       "center": {
        "longitude": 85.693742,
        "latitude": 46.089148
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "喀什地区",
     "center": {
      "longitude": 75.989741,
      "latitude": 39.47046
     },
     "level": "city",
     "districts": [
      {
       "name": "巴楚县",
       "center": {
        "longitude": 78.549296,
        "latitude": 39.785155
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伽师县",
       "center": {
        "longitude": 76.723719,
        "latitude": 39.488181
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "喀什市",
       "center": {
        "longitude": 75.99379,
        "latitude": 39.467685
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麦盖提县",
       "center": {
        "longitude": 77.610125,
        "latitude": 38.898001
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莎车县",
       "center": {
        "longitude": 77.245761,
        "latitude": 38.41422
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "疏附县",
       "center": {
        "longitude": 75.862813,
        "latitude": 39.375043
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "疏勒县",
       "center": {
        "longitude": 76.048139,
        "latitude": 39.401384
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "塔什库尔干塔吉克自治县",
       "center": {
        "longitude": 75.229889,
        "latitude": 37.772094
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "叶城县",
       "center": {
        "longitude": 77.413836,
        "latitude": 37.882989
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "英吉沙县",
       "center": {
        "longitude": 76.175729,
        "latitude": 38.930381
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岳普湖县",
       "center": {
        "longitude": 76.8212,
        "latitude": 39.2198
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泽普县",
       "center": {
        "longitude": 77.259675,
        "latitude": 38.18529
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "塔城地区",
     "center": {
      "longitude": 82.980316,
      "latitude": 46.745364
     },
     "level": "city",
     "districts": [
      {
       "name": "额敏县",
       "center": {
        "longitude": 83.628303,
        "latitude": 46.524673
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "和布克赛尔蒙古自治县",
       "center": {
        "longitude": 85.728328,
        "latitude": 46.793235
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙湾县",
       "center": {
        "longitude": 85.619416,
        "latitude": 44.326388
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "塔城市",
       "center": {
        "longitude": 82.986978,
        "latitude": 46.751428
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "托里县",
       "center": {
        "longitude": 83.60695,
        "latitude": 45.947638
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌苏市",
       "center": {
        "longitude": 84.713396,
        "latitude": 44.41881
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "裕民县",
       "center": {
        "longitude": 82.982667,
        "latitude": 46.201104
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "乌鲁木齐市",
     "center": {
      "longitude": 87.616848,
      "latitude": 43.825592
     },
     "level": "city",
     "districts": [
      {
       "name": "达坂城区",
       "center": {
        "longitude": 88.311099,
        "latitude": 43.363668
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "米东区",
       "center": {
        "longitude": 87.655935,
        "latitude": 43.974784
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沙依巴克区",
       "center": {
        "longitude": 87.598195,
        "latitude": 43.800939
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "水磨沟区",
       "center": {
        "longitude": 87.642481,
        "latitude": 43.832459
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天山区",
       "center": {
        "longitude": 87.631676,
        "latitude": 43.794399
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "头屯河区",
       "center": {
        "longitude": 87.428141,
        "latitude": 43.877664
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乌鲁木齐县",
       "center": {
        "longitude": 87.409417,
        "latitude": 43.47136
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新市区",
       "center": {
        "longitude": 87.569431,
        "latitude": 43.855378
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "吐鲁番市",
     "center": {
      "longitude": 89.189752,
      "latitude": 42.951303
     },
     "level": "city",
     "districts": [
      {
       "name": "高昌区",
       "center": {
        "longitude": 89.185877,
        "latitude": 42.942327
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄯善县",
       "center": {
        "longitude": 90.21333,
        "latitude": 42.868744
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "托克逊县",
       "center": {
        "longitude": 88.653827,
        "latitude": 42.792526
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "伊犁哈萨克自治州",
     "center": {
      "longitude": 81.324136,
      "latitude": 43.916823
     },
     "level": "city",
     "districts": [
      {
       "name": "察布查尔锡伯自治县",
       "center": {
        "longitude": 81.151337,
        "latitude": 43.840726
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巩留县",
       "center": {
        "longitude": 82.231718,
        "latitude": 43.482628
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "霍尔果斯市",
       "center": {
        "longitude": 80.411271,
        "latitude": 44.213941
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "霍城县",
       "center": {
        "longitude": 80.87898,
        "latitude": 44.055984
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "奎屯市",
       "center": {
        "longitude": 84.903267,
        "latitude": 44.426529
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "尼勒克县",
       "center": {
        "longitude": 82.511809,
        "latitude": 43.800247
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "特克斯县",
       "center": {
        "longitude": 81.836206,
        "latitude": 43.217183
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新源县",
       "center": {
        "longitude": 83.232848,
        "latitude": 43.433896
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伊宁市",
       "center": {
        "longitude": 81.27795,
        "latitude": 43.908558
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "伊宁县",
       "center": {
        "longitude": 81.52745,
        "latitude": 43.977119
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昭苏县",
       "center": {
        "longitude": 81.130974,
        "latitude": 43.157293
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "阿拉尔市",
     "center": {
      "longitude": 81.280527,
      "latitude": 40.547653
     },
     "level": "city",
     "districts": [
      {
       "name": "托喀依乡",
       "center": {
        "longitude": 81.120055,
        "latitude": 40.538677
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "北屯市",
     "center": {
      "longitude": 87.837075,
      "latitude": 47.332643
     },
     "level": "city",
     "districts": [
      {
       "name": "北屯镇",
       "center": {
        "longitude": 87.800381,
        "latitude": 47.36356
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "可克达拉市",
     "center": {
      "longitude": 81.044542,
      "latitude": 43.944798
     },
     "level": "city",
     "districts": []
    },
    {
     "name": "昆玉市",
     "center": {
      "longitude": 79.291083,
      "latitude": 37.209642
     },
     "level": "city",
     "districts": []
    },
    {
     "name": "石河子市",
     "center": {
      "longitude": 86.080602,
      "latitude": 44.306097
     },
     "level": "city",
     "districts": [
      {
       "name": "向阳街道",
       "center": {
        "longitude": 86.053247,
        "latitude": 44.307085
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "老街街道",
       "center": {
        "longitude": 86.025494,
        "latitude": 44.314066
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "东城街道",
       "center": {
        "longitude": 86.09183,
        "latitude": 44.310211
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "新城镇",
       "center": {
        "longitude": 86.027642,
        "latitude": 44.29313
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "红山街道",
       "center": {
        "longitude": 86.052025,
        "latitude": 44.296169
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "北泉镇",
       "center": {
        "longitude": 86.016731,
        "latitude": 44.333841
       },
       "level": "street",
       "districts": []
      },
      {
       "name": "石河子镇",
       "center": {
        "longitude": 86.035422,
        "latitude": 44.286568
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "双河市",
     "center": {
      "longitude": 82.353656,
      "latitude": 44.840524
     },
     "level": "city",
     "districts": []
    },
    {
     "name": "铁门关市",
     "center": {
      "longitude": 85.501217,
      "latitude": 41.82725
     },
     "level": "city",
     "districts": []
    },
    {
     "name": "图木舒克市",
     "center": {
      "longitude": 79.073963,
      "latitude": 39.868965
     },
     "level": "city",
     "districts": [
      {
       "name": "四十九团九连",
       "center": {
        "longitude": 78.928924,
        "latitude": 39.707707
       },
       "level": "street",
       "districts": []
      }
     ]
    },
    {
     "name": "五家渠市",
     "center": {
      "longitude": 87.54324,
      "latitude": 44.166756
     },
     "level": "city",
     "districts": [
      {
       "name": "梧桐镇",
       "center": {
        "longitude": 87.651141,
        "latitude": 44.262647
       },
       "level": "street",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "云南省",
   "center": {
    "longitude": 102.710002,
    "latitude": 25.045806
   },
   "level": "province",
   "districts": [
    {
     "name": "保山市",
     "center": {
      "longitude": 99.161761,
      "latitude": 25.112046
     },
     "level": "city",
     "districts": [
      {
       "name": "昌宁县",
       "center": {
        "longitude": 99.605142,
        "latitude": 24.827839
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "隆阳区",
       "center": {
        "longitude": 99.165607,
        "latitude": 25.121154
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙陵县",
       "center": {
        "longitude": 98.689261,
        "latitude": 24.586794
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "施甸县",
       "center": {
        "longitude": 99.189221,
        "latitude": 24.723064
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "腾冲市",
       "center": {
        "longitude": 98.490966,
        "latitude": 25.020439
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "楚雄彝族自治州",
     "center": {
      "longitude": 101.527992,
      "latitude": 25.045513
     },
     "level": "city",
     "districts": [
      {
       "name": "楚雄市",
       "center": {
        "longitude": 101.545906,
        "latitude": 25.032889
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大姚县",
       "center": {
        "longitude": 101.336617,
        "latitude": 25.729513
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "禄丰县",
       "center": {
        "longitude": 102.079027,
        "latitude": 25.150111
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "牟定县",
       "center": {
        "longitude": 101.546566,
        "latitude": 25.313121
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南华县",
       "center": {
        "longitude": 101.273577,
        "latitude": 25.192293
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双柏县",
       "center": {
        "longitude": 101.641937,
        "latitude": 24.688875
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武定县",
       "center": {
        "longitude": 102.404337,
        "latitude": 25.530389
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "姚安县",
       "center": {
        "longitude": 101.241728,
        "latitude": 25.504173
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永仁县",
       "center": {
        "longitude": 101.666132,
        "latitude": 26.049464
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "元谋县",
       "center": {
        "longitude": 101.87452,
        "latitude": 25.704338
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "大理白族自治州",
     "center": {
      "longitude": 100.267638,
      "latitude": 25.606486
     },
     "level": "city",
     "districts": [
      {
       "name": "宾川县",
       "center": {
        "longitude": 100.590473,
        "latitude": 25.829828
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "大理市",
       "center": {
        "longitude": 100.30127,
        "latitude": 25.678068
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洱源县",
       "center": {
        "longitude": 99.951053,
        "latitude": 26.11116
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鹤庆县",
       "center": {
        "longitude": 100.176498,
        "latitude": 26.560231
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "剑川县",
       "center": {
        "longitude": 99.905559,
        "latitude": 26.537033
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "弥渡县",
       "center": {
        "longitude": 100.49099,
        "latitude": 25.343804
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南涧彝族自治县",
       "center": {
        "longitude": 100.509035,
        "latitude": 25.04351
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巍山彝族回族自治县",
       "center": {
        "longitude": 100.307174,
        "latitude": 25.227212
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "祥云县",
       "center": {
        "longitude": 100.550945,
        "latitude": 25.48385
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "漾濞彝族自治县",
       "center": {
        "longitude": 99.958015,
        "latitude": 25.670148
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永平县",
       "center": {
        "longitude": 99.541236,
        "latitude": 25.464681
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云龙县",
       "center": {
        "longitude": 99.37112,
        "latitude": 25.885595
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "德宏傣族景颇族自治州",
     "center": {
      "longitude": 98.584895,
      "latitude": 24.433353
     },
     "level": "city",
     "districts": [
      {
       "name": "梁河县",
       "center": {
        "longitude": 98.296657,
        "latitude": 24.804232
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陇川县",
       "center": {
        "longitude": 97.792104,
        "latitude": 24.182965
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "芒市",
       "center": {
        "longitude": 98.588086,
        "latitude": 24.43369
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "瑞丽市",
       "center": {
        "longitude": 97.85559,
        "latitude": 24.017958
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盈江县",
       "center": {
        "longitude": 97.931936,
        "latitude": 24.705164
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "迪庆藏族自治州",
     "center": {
      "longitude": 99.702583,
      "latitude": 27.818807
     },
     "level": "city",
     "districts": [
      {
       "name": "德钦县",
       "center": {
        "longitude": 98.911559,
        "latitude": 28.486163
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "维西傈僳族自治县",
       "center": {
        "longitude": 99.287173,
        "latitude": 27.177161
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "香格里拉市",
       "center": {
        "longitude": 99.700904,
        "latitude": 27.829578
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "红河哈尼族彝族自治州",
     "center": {
      "longitude": 103.374893,
      "latitude": 23.363245
     },
     "level": "city",
     "districts": [
      {
       "name": "个旧市",
       "center": {
        "longitude": 103.160034,
        "latitude": 23.359121
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "河口瑶族自治县",
       "center": {
        "longitude": 103.93952,
        "latitude": 22.529645
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红河县",
       "center": {
        "longitude": 102.4206,
        "latitude": 23.369161
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建水县",
       "center": {
        "longitude": 102.826557,
        "latitude": 23.6347
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金平苗族瑶族傣族自治县",
       "center": {
        "longitude": 103.226448,
        "latitude": 22.779543
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开远市",
       "center": {
        "longitude": 103.266624,
        "latitude": 23.714523
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绿春县",
       "center": {
        "longitude": 102.392463,
        "latitude": 22.993717
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泸西县",
       "center": {
        "longitude": 103.766196,
        "latitude": 24.532025
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "弥勒市",
       "center": {
        "longitude": 103.414874,
        "latitude": 24.411912
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "蒙自市",
       "center": {
        "longitude": 103.364905,
        "latitude": 23.396201
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "屏边苗族自治县",
       "center": {
        "longitude": 103.687612,
        "latitude": 22.983559
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石屏县",
       "center": {
        "longitude": 102.494983,
        "latitude": 23.705936
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "元阳县",
       "center": {
        "longitude": 102.835223,
        "latitude": 23.219932
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "昆明市",
     "center": {
      "longitude": 102.832891,
      "latitude": 24.880095
     },
     "level": "city",
     "districts": [
      {
       "name": "安宁市",
       "center": {
        "longitude": 102.478494,
        "latitude": 24.919493
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "呈贡区",
       "center": {
        "longitude": 102.821675,
        "latitude": 24.885587
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "东川区",
       "center": {
        "longitude": 103.187824,
        "latitude": 26.082873
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富民县",
       "center": {
        "longitude": 102.4976,
        "latitude": 25.221935
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "官渡区",
       "center": {
        "longitude": 102.749026,
        "latitude": 24.950231
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "晋宁区",
       "center": {
        "longitude": 102.595412,
        "latitude": 24.66974
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "禄劝彝族苗族自治县",
       "center": {
        "longitude": 102.471518,
        "latitude": 25.551332
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盘龙区",
       "center": {
        "longitude": 102.751941,
        "latitude": 25.116465
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "石林彝族自治县",
       "center": {
        "longitude": 103.290536,
        "latitude": 24.771761
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嵩明县",
       "center": {
        "longitude": 103.036908,
        "latitude": 25.338643
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "五华区",
       "center": {
        "longitude": 102.707262,
        "latitude": 25.043635
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西山区",
       "center": {
        "longitude": 102.664382,
        "latitude": 25.038604
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "寻甸回族彝族自治县",
       "center": {
        "longitude": 103.256615,
        "latitude": 25.558201
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宜良县",
       "center": {
        "longitude": 103.141603,
        "latitude": 24.919839
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "丽江市",
     "center": {
      "longitude": 100.22775,
      "latitude": 26.855047
     },
     "level": "city",
     "districts": [
      {
       "name": "古城区",
       "center": {
        "longitude": 100.225784,
        "latitude": 26.876927
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华坪县",
       "center": {
        "longitude": 101.266195,
        "latitude": 26.629211
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁蒗彝族自治县",
       "center": {
        "longitude": 100.852001,
        "latitude": 27.28207
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永胜县",
       "center": {
        "longitude": 100.750826,
        "latitude": 26.684225
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玉龙纳西族自治县",
       "center": {
        "longitude": 100.236954,
        "latitude": 26.821459
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "临沧市",
     "center": {
      "longitude": 100.08879,
      "latitude": 23.883955
     },
     "level": "city",
     "districts": [
      {
       "name": "沧源佤族自治县",
       "center": {
        "longitude": 99.246196,
        "latitude": 23.146712
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "凤庆县",
       "center": {
        "longitude": 99.928459,
        "latitude": 24.580424
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "耿马傣族佤族自治县",
       "center": {
        "longitude": 99.397126,
        "latitude": 23.538092
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临翔区",
       "center": {
        "longitude": 100.082523,
        "latitude": 23.895137
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "双江拉祜族佤族布朗族傣族自治县",
       "center": {
        "longitude": 99.827697,
        "latitude": 23.473499
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永德县",
       "center": {
        "longitude": 99.259339,
        "latitude": 24.018357
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云县",
       "center": {
        "longitude": 100.129354,
        "latitude": 24.44422
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇康县",
       "center": {
        "longitude": 98.825284,
        "latitude": 23.762584
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "怒江傈僳族自治州",
     "center": {
      "longitude": 98.8566,
      "latitude": 25.817555
     },
     "level": "city",
     "districts": [
      {
       "name": "福贡县",
       "center": {
        "longitude": 98.869132,
        "latitude": 26.901831
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "贡山独龙族怒族自治县",
       "center": {
        "longitude": 98.665964,
        "latitude": 27.740999
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兰坪白族普米族自治县",
       "center": {
        "longitude": 99.416677,
        "latitude": 26.453571
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泸水市",
       "center": {
        "longitude": 98.857977,
        "latitude": 25.822879
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "曲靖市",
     "center": {
      "longitude": 103.796167,
      "latitude": 25.489999
     },
     "level": "city",
     "districts": [
      {
       "name": "富源县",
       "center": {
        "longitude": 104.255014,
        "latitude": 25.674238
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "会泽县",
       "center": {
        "longitude": 103.297386,
        "latitude": 26.417345
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "陆良县",
       "center": {
        "longitude": 103.666663,
        "latitude": 25.030051
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "罗平县",
       "center": {
        "longitude": 104.308675,
        "latitude": 24.884626
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "马龙县",
       "center": {
        "longitude": 103.578478,
        "latitude": 25.42805
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麒麟区",
       "center": {
        "longitude": 103.80474,
        "latitude": 25.495326
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "师宗县",
       "center": {
        "longitude": 103.985321,
        "latitude": 24.822233
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宣威市",
       "center": {
        "longitude": 104.10455,
        "latitude": 26.219735
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "沾益区",
       "center": {
        "longitude": 103.822324,
        "latitude": 25.600507
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "普洱市",
     "center": {
      "longitude": 100.966156,
      "latitude": 22.825155
     },
     "level": "city",
     "districts": [
      {
       "name": "江城哈尼族彝族自治县",
       "center": {
        "longitude": 101.86212,
        "latitude": 22.585867
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "景谷傣族彝族自治县",
       "center": {
        "longitude": 100.702871,
        "latitude": 23.497028
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "景东彝族自治县",
       "center": {
        "longitude": 100.833877,
        "latitude": 24.446731
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "澜沧拉祜族自治县",
       "center": {
        "longitude": 99.931975,
        "latitude": 22.555904
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "孟连傣族拉祜族佤族自治县",
       "center": {
        "longitude": 99.584157,
        "latitude": 22.329099
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "墨江哈尼族自治县",
       "center": {
        "longitude": 101.692461,
        "latitude": 23.431894
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁洱哈尼族彝族自治县",
       "center": {
        "longitude": 101.045837,
        "latitude": 23.048401
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "思茅区",
       "center": {
        "longitude": 100.977256,
        "latitude": 22.787115
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西盟佤族自治县",
       "center": {
        "longitude": 99.590123,
        "latitude": 22.644508
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇沅彝族哈尼族拉祜族自治县",
       "center": {
        "longitude": 101.108595,
        "latitude": 24.004441
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "文山壮族苗族自治州",
     "center": {
      "longitude": 104.216248,
      "latitude": 23.400733
     },
     "level": "city",
     "districts": [
      {
       "name": "富宁县",
       "center": {
        "longitude": 105.630999,
        "latitude": 23.625283
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "广南县",
       "center": {
        "longitude": 105.055107,
        "latitude": 24.046386
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "麻栗坡县",
       "center": {
        "longitude": 104.702799,
        "latitude": 23.125714
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "马关县",
       "center": {
        "longitude": 104.394157,
        "latitude": 23.012915
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "丘北县",
       "center": {
        "longitude": 104.166587,
        "latitude": 24.051746
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "文山市",
       "center": {
        "longitude": 104.232665,
        "latitude": 23.386527
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西畴县",
       "center": {
        "longitude": 104.672597,
        "latitude": 23.437782
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "砚山县",
       "center": {
        "longitude": 104.337211,
        "latitude": 23.605768
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "西双版纳傣族自治州",
     "center": {
      "longitude": 100.796984,
      "latitude": 22.009113
     },
     "level": "city",
     "districts": [
      {
       "name": "景洪市",
       "center": {
        "longitude": 100.799545,
        "latitude": 22.011928
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "勐腊县",
       "center": {
        "longitude": 101.564635,
        "latitude": 21.459233
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "勐海县",
       "center": {
        "longitude": 100.452547,
        "latitude": 21.957353
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "玉溪市",
     "center": {
      "longitude": 102.527197,
      "latitude": 24.347324
     },
     "level": "city",
     "districts": [
      {
       "name": "澄江县",
       "center": {
        "longitude": 102.904629,
        "latitude": 24.675689
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "峨山彝族自治县",
       "center": {
        "longitude": 102.405819,
        "latitude": 24.168957
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "红塔区",
       "center": {
        "longitude": 102.540122,
        "latitude": 24.341215
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "华宁县",
       "center": {
        "longitude": 102.928835,
        "latitude": 24.19276
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江川区",
       "center": {
        "longitude": 102.75344,
        "latitude": 24.287485
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "通海县",
       "center": {
        "longitude": 102.725452,
        "latitude": 24.111048
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新平彝族傣族自治县",
       "center": {
        "longitude": 101.990157,
        "latitude": 24.07005
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "易门县",
       "center": {
        "longitude": 102.162531,
        "latitude": 24.671651
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "元江哈尼族彝族傣族自治县",
       "center": {
        "longitude": 101.998103,
        "latitude": 23.596503
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "昭通市",
     "center": {
      "longitude": 103.717465,
      "latitude": 27.338257
     },
     "level": "city",
     "districts": [
      {
       "name": "大关县",
       "center": {
        "longitude": 103.891146,
        "latitude": 27.747978
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鲁甸县",
       "center": {
        "longitude": 103.558042,
        "latitude": 27.186659
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "巧家县",
       "center": {
        "longitude": 102.930164,
        "latitude": 26.90846
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "水富县",
       "center": {
        "longitude": 104.41603,
        "latitude": 28.62988
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "绥江县",
       "center": {
        "longitude": 103.968978,
        "latitude": 28.592099
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "威信县",
       "center": {
        "longitude": 105.049027,
        "latitude": 27.8469
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "盐津县",
       "center": {
        "longitude": 104.234441,
        "latitude": 28.10871
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "彝良县",
       "center": {
        "longitude": 104.048289,
        "latitude": 27.625418
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永善县",
       "center": {
        "longitude": 103.638067,
        "latitude": 28.229112
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "昭阳区",
       "center": {
        "longitude": 103.706539,
        "latitude": 27.320075
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇雄县",
       "center": {
        "longitude": 104.87376,
        "latitude": 27.441622
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  },
  {
   "name": "浙江省",
   "center": {
    "longitude": 120.152585,
    "latitude": 30.266597
   },
   "level": "province",
   "districts": [
    {
     "name": "杭州市",
     "center": {
      "longitude": 120.209789,
      "latitude": 30.24692
     },
     "level": "city",
     "districts": [
      {
       "name": "滨江区",
       "center": {
        "longitude": 120.211623,
        "latitude": 30.208847
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "淳安县",
       "center": {
        "longitude": 119.042037,
        "latitude": 29.608886
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "富阳区",
       "center": {
        "longitude": 119.960076,
        "latitude": 30.048692
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "拱墅区",
       "center": {
        "longitude": 120.141406,
        "latitude": 30.319037
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江干区",
       "center": {
        "longitude": 120.205001,
        "latitude": 30.257012
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "建德市",
       "center": {
        "longitude": 119.281231,
        "latitude": 29.474759
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临安区",
       "center": {
        "longitude": 119.724734,
        "latitude": 30.233873
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上城区",
       "center": {
        "longitude": 120.169312,
        "latitude": 30.242404
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桐庐县",
       "center": {
        "longitude": 119.691467,
        "latitude": 29.79299
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "西湖区",
       "center": {
        "longitude": 120.130194,
        "latitude": 30.259463
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "萧山区",
       "center": {
        "longitude": 120.264253,
        "latitude": 30.183806
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "下城区",
       "center": {
        "longitude": 120.180891,
        "latitude": 30.281677
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "余杭区",
       "center": {
        "longitude": 120.299401,
        "latitude": 30.419045
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "嘉兴市",
     "center": {
      "longitude": 120.75547,
      "latitude": 30.746191
     },
     "level": "city",
     "districts": [
      {
       "name": "海盐县",
       "center": {
        "longitude": 120.946263,
        "latitude": 30.526435
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海宁市",
       "center": {
        "longitude": 120.680239,
        "latitude": 30.511539
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嘉善县",
       "center": {
        "longitude": 120.926028,
        "latitude": 30.830864
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南湖区",
       "center": {
        "longitude": 120.783024,
        "latitude": 30.747842
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平湖市",
       "center": {
        "longitude": 121.015142,
        "latitude": 30.677233
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "桐乡市",
       "center": {
        "longitude": 120.565098,
        "latitude": 30.630173
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "秀洲区",
       "center": {
        "longitude": 120.710082,
        "latitude": 30.765188
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "湖州市",
     "center": {
      "longitude": 120.086809,
      "latitude": 30.89441
     },
     "level": "city",
     "districts": [
      {
       "name": "安吉县",
       "center": {
        "longitude": 119.680353,
        "latitude": 30.638674
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "德清县",
       "center": {
        "longitude": 119.9774,
        "latitude": 30.54251
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "南浔区",
       "center": {
        "longitude": 120.418513,
        "latitude": 30.849689
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "吴兴区",
       "center": {
        "longitude": 120.185838,
        "latitude": 30.857151
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "长兴县",
       "center": {
        "longitude": 119.910952,
        "latitude": 31.026665
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "丽水市",
     "center": {
      "longitude": 119.922796,
      "latitude": 28.46763
     },
     "level": "city",
     "districts": [
      {
       "name": "景宁畲族自治县",
       "center": {
        "longitude": 119.635739,
        "latitude": 27.9733
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "缙云县",
       "center": {
        "longitude": 120.091572,
        "latitude": 28.659283
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "莲都区",
       "center": {
        "longitude": 119.912626,
        "latitude": 28.445928
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙泉市",
       "center": {
        "longitude": 119.141473,
        "latitude": 28.074649
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "青田县",
       "center": {
        "longitude": 120.289478,
        "latitude": 28.139837
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "庆元县",
       "center": {
        "longitude": 119.06259,
        "latitude": 27.61922
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "遂昌县",
       "center": {
        "longitude": 119.276103,
        "latitude": 28.592148
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "松阳县",
       "center": {
        "longitude": 119.481511,
        "latitude": 28.448803
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "云和县",
       "center": {
        "longitude": 119.573397,
        "latitude": 28.11579
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "金华市",
     "center": {
      "longitude": 119.647229,
      "latitude": 29.079208
     },
     "level": "city",
     "districts": [
      {
       "name": "东阳市",
       "center": {
        "longitude": 120.241566,
        "latitude": 29.289648
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "金东区",
       "center": {
        "longitude": 119.69278,
        "latitude": 29.099723
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "兰溪市",
       "center": {
        "longitude": 119.460472,
        "latitude": 29.2084
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "磐安县",
       "center": {
        "longitude": 120.450005,
        "latitude": 29.054548
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "浦江县",
       "center": {
        "longitude": 119.892222,
        "latitude": 29.452476
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "婺城区",
       "center": {
        "longitude": 119.571728,
        "latitude": 29.0872
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "武义县",
       "center": {
        "longitude": 119.816562,
        "latitude": 28.89267
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "义乌市",
       "center": {
        "longitude": 120.075106,
        "latitude": 29.306775
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永康市",
       "center": {
        "longitude": 120.047651,
        "latitude": 28.888555
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "衢州市",
     "center": {
      "longitude": 118.859457,
      "latitude": 28.970079
     },
     "level": "city",
     "districts": [
      {
       "name": "常山县",
       "center": {
        "longitude": 118.511235,
        "latitude": 28.901462
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江山市",
       "center": {
        "longitude": 118.626991,
        "latitude": 28.737331
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "开化县",
       "center": {
        "longitude": 118.415495,
        "latitude": 29.137336
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "柯城区",
       "center": {
        "longitude": 118.871516,
        "latitude": 28.96862
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙游县",
       "center": {
        "longitude": 119.172189,
        "latitude": 29.028439
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "衢江区",
       "center": {
        "longitude": 118.95946,
        "latitude": 28.97978
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "宁波市",
     "center": {
      "longitude": 121.622485,
      "latitude": 29.859971
     },
     "level": "city",
     "districts": [
      {
       "name": "北仑区",
       "center": {
        "longitude": 121.844172,
        "latitude": 29.899778
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "慈溪市",
       "center": {
        "longitude": 121.266561,
        "latitude": 30.170261
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "奉化区",
       "center": {
        "longitude": 121.406997,
        "latitude": 29.655144
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "海曙区",
       "center": {
        "longitude": 121.550752,
        "latitude": 29.874903
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "江北区",
       "center": {
        "longitude": 121.555081,
        "latitude": 29.886781
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "宁海县",
       "center": {
        "longitude": 121.429477,
        "latitude": 29.287939
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "象山县",
       "center": {
        "longitude": 121.869339,
        "latitude": 29.476705
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鄞州区",
       "center": {
        "longitude": 121.546603,
        "latitude": 29.816511
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "余姚市",
       "center": {
        "longitude": 121.154629,
        "latitude": 30.037106
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "镇海区",
       "center": {
        "longitude": 121.596496,
        "latitude": 29.965203
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "绍兴市",
     "center": {
      "longitude": 120.580364,
      "latitude": 30.030192
     },
     "level": "city",
     "districts": [
      {
       "name": "柯桥区",
       "center": {
        "longitude": 120.495085,
        "latitude": 30.081929
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嵊州市",
       "center": {
        "longitude": 120.831025,
        "latitude": 29.56141
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "上虞区",
       "center": {
        "longitude": 120.868122,
        "latitude": 30.03312
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "新昌县",
       "center": {
        "longitude": 120.903866,
        "latitude": 29.499831
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "越城区",
       "center": {
        "longitude": 120.582633,
        "latitude": 29.988244
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "诸暨市",
       "center": {
        "longitude": 120.246863,
        "latitude": 29.708692
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "台州市",
     "center": {
      "longitude": 121.42076,
      "latitude": 28.65638
     },
     "level": "city",
     "districts": [
      {
       "name": "黄岩区",
       "center": {
        "longitude": 121.261972,
        "latitude": 28.650083
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "椒江区",
       "center": {
        "longitude": 121.442978,
        "latitude": 28.672981
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "临海市",
       "center": {
        "longitude": 121.144556,
        "latitude": 28.858881
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "路桥区",
       "center": {
        "longitude": 121.365123,
        "latitude": 28.582654
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "三门县",
       "center": {
        "longitude": 121.395711,
        "latitude": 29.104789
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "天台县",
       "center": {
        "longitude": 121.006595,
        "latitude": 29.144064
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "温岭市",
       "center": {
        "longitude": 121.385604,
        "latitude": 28.372506
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "仙居县",
       "center": {
        "longitude": 120.728801,
        "latitude": 28.846966
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "玉环市",
       "center": {
        "longitude": 121.231805,
        "latitude": 28.135929
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "温州市",
     "center": {
      "longitude": 120.699361,
      "latitude": 27.993828
     },
     "level": "city",
     "districts": [
      {
       "name": "苍南县",
       "center": {
        "longitude": 120.427619,
        "latitude": 27.519773
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "洞头区",
       "center": {
        "longitude": 121.157249,
        "latitude": 27.836154
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "乐清市",
       "center": {
        "longitude": 120.983906,
        "latitude": 28.113725
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "龙湾区",
       "center": {
        "longitude": 120.811213,
        "latitude": 27.932747
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "鹿城区",
       "center": {
        "longitude": 120.655271,
        "latitude": 28.015737
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "瓯海区",
       "center": {
        "longitude": 120.61491,
        "latitude": 27.966844
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "平阳县",
       "center": {
        "longitude": 120.565793,
        "latitude": 27.661918
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "瑞安市",
       "center": {
        "longitude": 120.655148,
        "latitude": 27.778657
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "泰顺县",
       "center": {
        "longitude": 119.717649,
        "latitude": 27.556884
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "文成县",
       "center": {
        "longitude": 120.091498,
        "latitude": 27.786996
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "永嘉县",
       "center": {
        "longitude": 120.692025,
        "latitude": 28.153607
       },
       "level": "district",
       "districts": []
      }
     ]
    },
    {
     "name": "舟山市",
     "center": {
      "longitude": 122.207106,
      "latitude": 29.985553
     },
     "level": "city",
     "districts": [
      {
       "name": "定海区",
       "center": {
        "longitude": 122.106773,
        "latitude": 30.019858
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "岱山县",
       "center": {
        "longitude": 122.226237,
        "latitude": 30.264139
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "普陀区",
       "center": {
        "longitude": 122.323867,
        "latitude": 29.97176
       },
       "level": "district",
       "districts": []
      },
      {
       "name": "嵊泗县",
       "center": {
        "longitude": 122.451382,
        "latitude": 30.725686
       },
       "level": "district",
       "districts": []
      }
     ]
    }
   ]
  }
 ]
}
